// Generated from dev_tools/seo/generated-bucket-review/*.csv for staging SEO category review.
// Do not edit individual product memberships by hand; regenerate from the review output.

export interface SeoRuntimeMenuLink {
  title: string;
  href: string;
}

export interface SeoRuntimeMenuSection {
  title: string;
  items: SeoRuntimeMenuLink[];
}

export interface SeoRuntimeNavItem {
  title: string;
  href: string;
  sections: SeoRuntimeMenuSection[];
}

export interface SeoRuntimeCollectionDefinition {
  handle: string;
  title: string;
  parentCategory: string;
  productCount: number;
  description: string;
  productHandles: readonly string[];
}

export interface SeoRuntimeRelatedCategoryLink extends SeoRuntimeMenuLink {
  context: string;
}

const ENABLED_BY_ENV =
  process.env.ENABLE_SEO_RUNTIME_COLLECTIONS === 'true' ||
  process.env.NEXT_PUBLIC_ENABLE_SEO_RUNTIME_COLLECTIONS === 'true' ||
  process.env.ENABLE_SEO_PILOT_COLLECTIONS === 'true' ||
  process.env.NEXT_PUBLIC_ENABLE_SEO_PILOT_COLLECTIONS === 'true' ||
  process.env.NODE_ENV !== 'production';

export function isSeoRuntimeEnabled() {
  return ENABLED_BY_ENV;
}

export function shouldNoIndexSeoRuntimeCollections() {
  return (
    process.env.SEO_RUNTIME_NOINDEX === 'true' ||
    process.env.SEO_PILOT_NOINDEX === 'true' ||
    process.env.NODE_ENV !== 'production'
  );
}

const collections: SeoRuntimeCollectionDefinition[] = [
  {
    "handle": "basins",
    "title": "Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 196,
    "description": "Shop basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-in-1-round-close-coupled-toilet-basin-385w-x-400h-x-610d-tap-not-included",
      "2-in-1-square-close-coupled-toilet-basin-390w-x-400h-x-670d-tap-not-included",
      "ashford-500-anthracite-ceramic-basin-500w-x-840h-x-385d",
      "ashford-500-free-standing-matt-blue-ceramic-basin-500w-x-840h-x-385d",
      "ashford-500-free-standing-matt-grey-ceramic-basin-500w-x-840h-x-385d",
      "ashford-500-free-standing-white-ceramic-basin-500w-x-840h-x-385d",
      "ashford-600-free-standing-anthracite-ceramic-basin-600w-x-840h-x-455d",
      "ashford-600-free-standing-matt-blue-ceramic-basin-600w-x-840h-x-455d",
      "ashford-600-free-standing-matt-grey-ceramic-basin-600w-x-840h-x-455d",
      "ashford-600-free-standing-white-ceramic-basin-600w-x-840h-x-455d",
      "bathroom-mid-edge-ceramic-500mm-freestanding-basin-sink-vanity-unit-furniture",
      "camberly-600-matt-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "camberly-800-freestanding-ceramic-vanity-basin-matt-grey-810w-x-815h-x-465d",
      "capri-1100-left-anthracite-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-left-matt-grey-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-left-matt-grey-bathroom-resin-basin-1100w-x-820h-x-450d-1",
      "capri-1100-left-white-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-right-anthracite-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-right-matt-grey-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-right-white-bathroom-resin-basin-1100w-x-820h-x-450d",
      "chelsea-1050-white-vanity-unit-with-ceramic-basin-1060w-x-836h-x-485d",
      "chelsea-400-white-ceramic-vanity-basin-400w-x-810h-x-400d",
      "chelsea-450-white-ceramic-vanity-basin-450w-x-836h-x-440d",
      "chelsea-550-white-ceramic-vanity-basin-550w-x-836h-x-430d",
      "chelsea-650-white-ceramic-vanity-basin-650w-x-836h-x-446d",
      "chelsea-750-white-vanity-unit-with-ceramic-basin-755w-x-836h-x-485d",
      "chelsea-850-white-vanity-unit-with-ceramic-basin-855w-x-836h-x-485d",
      "countertop-basin-310mm-w-x-110mm-h-x-310mm-d-waste-not-included",
      "countertop-basin-320mm-w-x-145mm-h-x-320mm-d-waste-not-included",
      "countertop-basin-matt-black-360w-x-120h-x-360d-waste-not-included",
      "countertop-basin-matt-black-375w-x-135h-x-490d-waste-not-included",
      "countertop-basin-white-320w-x-145h-x-320d-waste-not-included",
      "countertop-basin-white-330w-x-135h-x-410d-waste-not-included",
      "countertop-basin-white-360w-x-150h-x-510d-waste-not-included",
      "countertop-basin-white-380w-x-135h-x-480d-waste-not-included",
      "countertop-basin-white-410w-x-155h-x-410d",
      "countertop-basin-white-460w-x-140h-x-320d-waste-not-included",
      "countertop-basin-white-480w-x-135h-x-350d-waste-not-included",
      "devon-400-floorstanding-anthracite-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-floorstanding-matt-grey-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-floorstanding-white-ceramic-basin-400w-x-790h-x-220d-1",
      "devon-400-wall-hung-ceramic-vanity-basin-anthracite-nbsp-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-matt-grey-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-white-400w-x-450h-x-220d",
      "devon-450-floorstanding-anthracite-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-matt-grey-vanity-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-450-floorstanding-white-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-matt-grey-450w-x-585h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-white-450w-x-585h-x-310d",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-830h-x395d",
      "devon-500-floorstanding-twin-drawers-white-anthracite-basin-510w-x-830h-x-395d-1",
      "devon-500-floorstanding-vanity-unit-with-drawers-anthracite-finish-ceramic-basin",
      "devon-500-wall-hung-single-drawers-white-anthracite-basin-510w-x-440h-x-395d",
      "devon-500-wall-hung-twin-drawers-anthracite-basin-510w-x-550h-x-390d",
      "devon-500-wall-hung-twin-drawers-white-anthracite-basin-510w-x-550h-x-390d",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-600-floorstanding-anthracite-drawers-anthracite-basin-610w-x-790h-x-395d",
      "devon-600-floorstanding-doors-matt-grey-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-doors-white-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-drawers-matt-grey-ceramic-basin-610w-x-790h-x-395d",
      "devon-600-floorstanding-vanity-unit-with-ceramic-basin-white",
      "devon-600-floorstanding-white-drawers-ceramic-basin-610w-x-790h-x-395d",
      "devon-600-wall-hung-twin-drawers-anthracite-ceramic-basin-610w-x-585h-x-395d",
      "devon-600-wall-hung-twin-drawers-matt-grey-ceramic-basin-610w-x-585h-x-395d",
      "devon-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "devon-800-floorstanding-drawers-anthracite-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-floorstanding-drawers-matt-grey-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-floorstanding-drawers-white-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-wall-hung-twin-drawers-matt-grey-ceramic-basin-810w-x-585h-x-395d",
      "devon-800-wall-hung-twin-drawers-white-ceramic-basin-810w-x-585h-x-395d",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "dwelta-500-floorstanding-anthracite-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-floorstanding-matt-grey-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-floorstanding-white-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-wall-hung-anthracite-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-anthracite-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-500-wall-hung-matt-grey-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-matt-grey-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-500-wall-hung-white-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-white-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-600-floorstanding-anthracite-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-floorstanding-matt-grey-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-floorstanding-white-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-wall-hung-anthracite-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-matt-grey-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-600-wall-hung-white-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-white-ceramic-basin-600w-x-500h-x-450d-1",
      "dwelta-800-floorstanding-anthracite-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-matt-grey-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-white-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d-1",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d-2",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "dwelta-800-wall-hung-white-resin-basin-800w-x-500h-x-450d",
      "dwelta-800-wall-hung-white-resin-basin-800w-x-500h-x-450d-1",
      "dwelta-back-to-wall-wc-anthracite-500w-x-200d",
      "dwelta-back-to-wall-wc-matt-grey-500w-x-200d",
      "dwelta-back-to-wall-wc-white-500w-x-200d",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-brass-200w-x-30h",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-silver-200w-x-30h",
      "handles-for-pmb-vanity-with-fixings-pair-chrome-200w-x-30h",
      "harris-900-left-anthracite-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-left-anthracite-bathroom-resin-basin-900w-x-840h-x-380d-1",
      "harris-900-left-matt-grey-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-left-matt-grey-bathroom-resin-basin-900w-x-840h-x-380d-1",
      "harris-900-right-anthracite-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-right-matt-grey-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-right-matt-grey-bathroom-resin-basin-900w-x-840h-x-380d-1",
      "harris-900-right-white-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-right-white-bathroom-resin-basin-900w-x-840h-x-380d-1",
      "harris-900mm-left-white-vanity-unit-with-resin-basin-storage-cabinet",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d-1",
      "harrow-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d-1",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-500-wall-hung-single-drawer-white-ceramic-basin-510w-x-435h-x-395d",
      "harrow-600-floorstanding-doors-anthracite-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-doors-matt-grey-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-doors-white-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-twin-drawer-anthracite-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-floorstanding-twin-drawer-matt-grey-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-floorstanding-twin-drawer-white-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-600-wall-hung-twin-drawer-matt-grey-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-white-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-white-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-800-floorstanding-twin-drawer-anthracite-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-matt-grey-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawer-matt-grey-ceramic-basin-800w-x-585h-x-395d",
      "harrow-800-wall-hung-twin-drawer-matt-grey-ceramic-basin-800w-x-585h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawer-white-ceramic-basin-800w-x-585h-x-395d",
      "harrow-800-wall-hung-twin-drawer-white-ceramic-basin-800w-x-585h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawers-anthracite-ceramic-basin-800w-x-585h-x-395d",
      "hilton-600-freestanding-ceramic-vanity-basin-cream-610w-x-840h-x-460d",
      "hilton-800-freestanding-ceramic-vanity-basin-cream-810w-x-815h-x-465d",
      "matt-black-countertop-basin-330mm-w-x-145mm-h-x-410mm-d-waste-not-included",
      "modern-countertop-basin-370x135x480mm-rectangular-ceramic-sink-white",
      "oval-countertop-basin-white-600w-x-180h-x-390d-waste-not-included",
      "paris-1100-left-anthracite-bathroom-resin-basin-1100w-x-825h-x-460d",
      "paris-1100-left-anthracite-bathroom-resin-basin-1100w-x-825h-x-460d-1",
      "paris-1100-left-white-bathroom-resin-basin-1100w-x-825h-x-460d",
      "paris-1100-right-anthracite-resin-basin-1100w-x-825h-x-460d",
      "paris-1100-right-anthracite-resin-basin-1100w-x-825h-x-460d-1",
      "paris-1100-right-matt-grey-bathroom-resin-basin-1100w-x-825h-x-460d",
      "paris-1100-right-white-bathroom-resin-basin-1100w-x-825h-x-460d",
      "paris-1100mm-left-matt-grey-vanity-basin-unit-with-resin-sink-storage",
      "paris-600-floorstanding-anthracite-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-600-floorstanding-matt-grey-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-600-floorstanding-white-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-nbsp-320w-x-1418h-x-360d",
      "prelim-1000-left-freestanding-anthracite-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-left-freestanding-matt-grey-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-left-freestanding-white-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-right-freestanding-anthracite-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-right-freestanding-matt-grey-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-right-freestanding-white-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-right-freestanding-white-resin-basin-996w-x-845h-x-380d-1",
      "prelim-1000-right-freestanding-white-resin-basin-996w-x-845h-x-380d-2",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-610w-x-840h-x-395d-copy",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d-copy",
      "pvc-vanity-500-wall-hung-twin-drawers-waterproof-vanity-ceramic-basin-510w-x-585h-x-395d",
      "pvc-vanity-600-floorstanding-twin-drawers-white-ceramic-basin-610w-x-840h-x-395d",
      "pvc-vanity-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "rectangular-countertop-basin-380x135x480mm-white-ceramic-bathroom-sink",
      "right-handed-countertop-or-wall-hung-basin-compact-ceramic-sink-180x370mm",
      "round-countertop-basin-white-360w-x-120h-x-360d",
      "round-countertop-basin-white-400w-x-115h-x-400d-waste-not-included",
      "round-countertop-basin-white-420w-x-160h-x-420d-waste-not-included",
      "round-countertop-basin-white-420w-x-170h-x-420d-waste-not-included",
      "sharaton-600-stone-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "sharaton-800-stone-grey-vanity-unit-with-ceramic-basin-810w-x-815h-x-465d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d-copy",
      "slim-1000-floorstanding-white-cabinet-resin-basin-1000w-x-865h-x-305d",
      "square-countertop-basin-white-380w-x-135h-x-380d-waste-not-included",
      "square-countertop-basin-white-390w-x-135h-x-390d-waste-not-included",
      "square-countertop-basin-white-430w-x-125h-x-430d-waste-not-included"
    ]
  },
  {
    "handle": "countertop-basins",
    "title": "Countertop Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 24,
    "description": "Shop countertop basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-500-anthracite-ceramic-basin-500w-x-840h-x-385d",
      "countertop-basin-310mm-w-x-110mm-h-x-310mm-d-waste-not-included",
      "countertop-basin-320mm-w-x-145mm-h-x-320mm-d-waste-not-included",
      "countertop-basin-matt-black-360w-x-120h-x-360d-waste-not-included",
      "countertop-basin-matt-black-375w-x-135h-x-490d-waste-not-included",
      "countertop-basin-white-320w-x-145h-x-320d-waste-not-included",
      "countertop-basin-white-330w-x-135h-x-410d-waste-not-included",
      "countertop-basin-white-360w-x-150h-x-510d-waste-not-included",
      "countertop-basin-white-380w-x-135h-x-480d-waste-not-included",
      "countertop-basin-white-410w-x-155h-x-410d",
      "countertop-basin-white-460w-x-140h-x-320d-waste-not-included",
      "countertop-basin-white-480w-x-135h-x-350d-waste-not-included",
      "matt-black-countertop-basin-330mm-w-x-145mm-h-x-410mm-d-waste-not-included",
      "modern-countertop-basin-370x135x480mm-rectangular-ceramic-sink-white",
      "oval-countertop-basin-white-600w-x-180h-x-390d-waste-not-included",
      "rectangular-countertop-basin-380x135x480mm-white-ceramic-bathroom-sink",
      "right-handed-countertop-or-wall-hung-basin-compact-ceramic-sink-180x370mm",
      "round-countertop-basin-white-360w-x-120h-x-360d",
      "round-countertop-basin-white-400w-x-115h-x-400d-waste-not-included",
      "round-countertop-basin-white-420w-x-160h-x-420d-waste-not-included",
      "round-countertop-basin-white-420w-x-170h-x-420d-waste-not-included",
      "square-countertop-basin-white-380w-x-135h-x-380d-waste-not-included",
      "square-countertop-basin-white-390w-x-135h-x-390d-waste-not-included",
      "square-countertop-basin-white-430w-x-125h-x-430d-waste-not-included"
    ]
  },
  {
    "handle": "wall-hung-basins",
    "title": "Wall Hung Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 49,
    "description": "Shop wall hung basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "devon-400-wall-hung-ceramic-vanity-basin-anthracite-nbsp-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-matt-grey-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-white-400w-x-450h-x-220d",
      "devon-450-wall-hung-ceramic-vanity-basin-matt-grey-450w-x-585h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-white-450w-x-585h-x-310d",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-wall-hung-single-drawers-white-anthracite-basin-510w-x-440h-x-395d",
      "devon-500-wall-hung-twin-drawers-anthracite-basin-510w-x-550h-x-390d",
      "devon-500-wall-hung-twin-drawers-white-anthracite-basin-510w-x-550h-x-390d",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-600-wall-hung-twin-drawers-anthracite-ceramic-basin-610w-x-585h-x-395d",
      "devon-600-wall-hung-twin-drawers-matt-grey-ceramic-basin-610w-x-585h-x-395d",
      "devon-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "devon-800-wall-hung-twin-drawers-matt-grey-ceramic-basin-810w-x-585h-x-395d",
      "devon-800-wall-hung-twin-drawers-white-ceramic-basin-810w-x-585h-x-395d",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "dwelta-500-wall-hung-anthracite-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-anthracite-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-500-wall-hung-matt-grey-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-matt-grey-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-500-wall-hung-white-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-white-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-600-wall-hung-anthracite-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-matt-grey-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-600-wall-hung-white-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-white-ceramic-basin-600w-x-500h-x-450d-1",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d-1",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d-2",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "dwelta-800-wall-hung-white-resin-basin-800w-x-500h-x-450d",
      "dwelta-800-wall-hung-white-resin-basin-800w-x-500h-x-450d-1",
      "harrow-500-wall-hung-single-drawer-white-ceramic-basin-510w-x-435h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-600-wall-hung-twin-drawer-matt-grey-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-white-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-white-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawer-matt-grey-ceramic-basin-800w-x-585h-x-395d",
      "harrow-800-wall-hung-twin-drawer-matt-grey-ceramic-basin-800w-x-585h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawer-white-ceramic-basin-800w-x-585h-x-395d",
      "harrow-800-wall-hung-twin-drawer-white-ceramic-basin-800w-x-585h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawers-anthracite-ceramic-basin-800w-x-585h-x-395d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-nbsp-320w-x-1418h-x-360d",
      "pvc-vanity-500-wall-hung-twin-drawers-waterproof-vanity-ceramic-basin-510w-x-585h-x-395d",
      "pvc-vanity-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "right-handed-countertop-or-wall-hung-basin-compact-ceramic-sink-180x370mm"
    ]
  },
  {
    "handle": "cloakroom-basins",
    "title": "Cloakroom Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 1,
    "description": "Shop cloakroom basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "right-handed-countertop-or-wall-hung-basin-compact-ceramic-sink-180x370mm"
    ]
  },
  {
    "handle": "ceramic-basins",
    "title": "Ceramic Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 115,
    "description": "Shop ceramic basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-500-anthracite-ceramic-basin-500w-x-840h-x-385d",
      "ashford-500-free-standing-matt-blue-ceramic-basin-500w-x-840h-x-385d",
      "ashford-500-free-standing-matt-grey-ceramic-basin-500w-x-840h-x-385d",
      "ashford-500-free-standing-white-ceramic-basin-500w-x-840h-x-385d",
      "ashford-600-free-standing-anthracite-ceramic-basin-600w-x-840h-x-455d",
      "ashford-600-free-standing-matt-blue-ceramic-basin-600w-x-840h-x-455d",
      "ashford-600-free-standing-matt-grey-ceramic-basin-600w-x-840h-x-455d",
      "ashford-600-free-standing-white-ceramic-basin-600w-x-840h-x-455d",
      "bathroom-mid-edge-ceramic-500mm-freestanding-basin-sink-vanity-unit-furniture",
      "camberly-600-matt-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "camberly-800-freestanding-ceramic-vanity-basin-matt-grey-810w-x-815h-x-465d",
      "chelsea-1050-white-vanity-unit-with-ceramic-basin-1060w-x-836h-x-485d",
      "chelsea-400-white-ceramic-vanity-basin-400w-x-810h-x-400d",
      "chelsea-450-white-ceramic-vanity-basin-450w-x-836h-x-440d",
      "chelsea-550-white-ceramic-vanity-basin-550w-x-836h-x-430d",
      "chelsea-650-white-ceramic-vanity-basin-650w-x-836h-x-446d",
      "chelsea-750-white-vanity-unit-with-ceramic-basin-755w-x-836h-x-485d",
      "chelsea-850-white-vanity-unit-with-ceramic-basin-855w-x-836h-x-485d",
      "devon-400-floorstanding-anthracite-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-floorstanding-matt-grey-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-floorstanding-white-ceramic-basin-400w-x-790h-x-220d-1",
      "devon-400-wall-hung-ceramic-vanity-basin-anthracite-nbsp-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-matt-grey-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-white-400w-x-450h-x-220d",
      "devon-450-floorstanding-anthracite-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-450-floorstanding-white-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-matt-grey-450w-x-585h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-white-450w-x-585h-x-310d",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-830h-x395d",
      "devon-500-floorstanding-vanity-unit-with-drawers-anthracite-finish-ceramic-basin",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-600-floorstanding-doors-matt-grey-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-doors-white-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-drawers-matt-grey-ceramic-basin-610w-x-790h-x-395d",
      "devon-600-floorstanding-vanity-unit-with-ceramic-basin-white",
      "devon-600-floorstanding-white-drawers-ceramic-basin-610w-x-790h-x-395d",
      "devon-600-wall-hung-twin-drawers-anthracite-ceramic-basin-610w-x-585h-x-395d",
      "devon-600-wall-hung-twin-drawers-matt-grey-ceramic-basin-610w-x-585h-x-395d",
      "devon-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "devon-800-floorstanding-drawers-anthracite-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-floorstanding-drawers-matt-grey-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-floorstanding-drawers-white-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-wall-hung-twin-drawers-matt-grey-ceramic-basin-810w-x-585h-x-395d",
      "devon-800-wall-hung-twin-drawers-white-ceramic-basin-810w-x-585h-x-395d",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "dwelta-500-floorstanding-anthracite-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-floorstanding-matt-grey-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-floorstanding-white-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-wall-hung-anthracite-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-anthracite-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-500-wall-hung-matt-grey-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-matt-grey-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-500-wall-hung-white-ceramic-basin-500w-x-500h-x-430d",
      "dwelta-500-wall-hung-white-ceramic-basin-500w-x-500h-x-430d-1",
      "dwelta-600-floorstanding-anthracite-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-floorstanding-matt-grey-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-floorstanding-white-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-wall-hung-anthracite-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-matt-grey-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-600-wall-hung-white-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-white-ceramic-basin-600w-x-500h-x-450d-1",
      "dwelta-800-floorstanding-anthracite-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-white-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d-1",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d-1",
      "harrow-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d-1",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-500-wall-hung-single-drawer-white-ceramic-basin-510w-x-435h-x-395d",
      "harrow-600-floorstanding-doors-anthracite-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-doors-matt-grey-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-doors-white-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-twin-drawer-anthracite-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-floorstanding-twin-drawer-matt-grey-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-floorstanding-twin-drawer-white-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-600-wall-hung-twin-drawer-matt-grey-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-white-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-white-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-800-floorstanding-twin-drawer-anthracite-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-matt-grey-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawer-matt-grey-ceramic-basin-800w-x-585h-x-395d",
      "harrow-800-wall-hung-twin-drawer-matt-grey-ceramic-basin-800w-x-585h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawer-white-ceramic-basin-800w-x-585h-x-395d",
      "harrow-800-wall-hung-twin-drawer-white-ceramic-basin-800w-x-585h-x-395d-copy",
      "harrow-800-wall-hung-twin-drawers-anthracite-ceramic-basin-800w-x-585h-x-395d",
      "hilton-600-freestanding-ceramic-vanity-basin-cream-610w-x-840h-x-460d",
      "hilton-800-freestanding-ceramic-vanity-basin-cream-810w-x-815h-x-465d",
      "modern-countertop-basin-370x135x480mm-rectangular-ceramic-sink-white",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-610w-x-840h-x-395d-copy",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d-copy",
      "pvc-vanity-500-wall-hung-twin-drawers-waterproof-vanity-ceramic-basin-510w-x-585h-x-395d",
      "pvc-vanity-600-floorstanding-twin-drawers-white-ceramic-basin-610w-x-840h-x-395d",
      "pvc-vanity-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "rectangular-countertop-basin-380x135x480mm-white-ceramic-bathroom-sink",
      "right-handed-countertop-or-wall-hung-basin-compact-ceramic-sink-180x370mm",
      "sharaton-600-stone-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "sharaton-800-stone-grey-vanity-unit-with-ceramic-basin-810w-x-815h-x-465d"
    ]
  },
  {
    "handle": "resin-basins",
    "title": "Resin Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 48,
    "description": "Shop resin basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "capri-1100-left-anthracite-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-left-matt-grey-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-left-matt-grey-bathroom-resin-basin-1100w-x-820h-x-450d-1",
      "capri-1100-left-white-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-right-anthracite-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-right-matt-grey-bathroom-resin-basin-1100w-x-820h-x-450d",
      "capri-1100-right-white-bathroom-resin-basin-1100w-x-820h-x-450d",
      "dwelta-800-floorstanding-anthracite-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-matt-grey-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-white-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d-1",
      "dwelta-800-wall-hung-matt-grey-resin-basin-800w-x-500h-x-450d-2",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "dwelta-800-wall-hung-white-resin-basin-800w-x-500h-x-450d",
      "dwelta-800-wall-hung-white-resin-basin-800w-x-500h-x-450d-1",
      "harris-900-left-anthracite-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-left-anthracite-bathroom-resin-basin-900w-x-840h-x-380d-1",
      "harris-900-left-matt-grey-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-left-matt-grey-bathroom-resin-basin-900w-x-840h-x-380d-1",
      "harris-900-right-anthracite-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-right-matt-grey-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-right-matt-grey-bathroom-resin-basin-900w-x-840h-x-380d-1",
      "harris-900-right-white-bathroom-resin-basin-900w-x-840h-x-380d",
      "harris-900-right-white-bathroom-resin-basin-900w-x-840h-x-380d-1",
      "harris-900mm-left-white-vanity-unit-with-resin-basin-storage-cabinet",
      "paris-1100-left-anthracite-bathroom-resin-basin-1100w-x-825h-x-460d",
      "paris-1100-left-anthracite-bathroom-resin-basin-1100w-x-825h-x-460d-1",
      "paris-1100-left-white-bathroom-resin-basin-1100w-x-825h-x-460d",
      "paris-1100-right-anthracite-resin-basin-1100w-x-825h-x-460d",
      "paris-1100-right-anthracite-resin-basin-1100w-x-825h-x-460d-1",
      "paris-1100-right-matt-grey-bathroom-resin-basin-1100w-x-825h-x-460d",
      "paris-1100-right-white-bathroom-resin-basin-1100w-x-825h-x-460d",
      "paris-1100mm-left-matt-grey-vanity-basin-unit-with-resin-sink-storage",
      "paris-600-floorstanding-anthracite-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-600-floorstanding-matt-grey-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-600-floorstanding-white-bathroom-resin-basin-600w-x-825h-x-460d",
      "prelim-1000-left-freestanding-anthracite-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-left-freestanding-matt-grey-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-left-freestanding-white-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-right-freestanding-anthracite-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-right-freestanding-matt-grey-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-right-freestanding-white-resin-basin-996w-x-845h-x-380d",
      "prelim-1000-right-freestanding-white-resin-basin-996w-x-845h-x-380d-1",
      "prelim-1000-right-freestanding-white-resin-basin-996w-x-845h-x-380d-2",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d-copy",
      "slim-1000-floorstanding-white-cabinet-resin-basin-1000w-x-865h-x-305d"
    ]
  },
  {
    "handle": "square-basins",
    "title": "Square Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 4,
    "description": "Shop square basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-in-1-square-close-coupled-toilet-basin-390w-x-400h-x-670d-tap-not-included",
      "square-countertop-basin-white-380w-x-135h-x-380d-waste-not-included",
      "square-countertop-basin-white-390w-x-135h-x-390d-waste-not-included",
      "square-countertop-basin-white-430w-x-125h-x-430d-waste-not-included"
    ]
  },
  {
    "handle": "round-basins",
    "title": "Round Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 5,
    "description": "Shop round basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-in-1-round-close-coupled-toilet-basin-385w-x-400h-x-610d-tap-not-included",
      "round-countertop-basin-white-360w-x-120h-x-360d",
      "round-countertop-basin-white-400w-x-115h-x-400d-waste-not-included",
      "round-countertop-basin-white-420w-x-160h-x-420d-waste-not-included",
      "round-countertop-basin-white-420w-x-170h-x-420d-waste-not-included"
    ]
  },
  {
    "handle": "oval-basins",
    "title": "Oval Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 1,
    "description": "Shop oval basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "oval-countertop-basin-white-600w-x-180h-x-390d-waste-not-included"
    ]
  },
  {
    "handle": "matt-black-basins",
    "title": "Matt Black Basins",
    "parentCategory": "Basins & Sinks",
    "productCount": 3,
    "description": "Shop matt black basins at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "countertop-basin-matt-black-360w-x-120h-x-360d-waste-not-included",
      "countertop-basin-matt-black-375w-x-135h-x-490d-waste-not-included",
      "matt-black-countertop-basin-330mm-w-x-145mm-h-x-410mm-d-waste-not-included"
    ]
  },
  {
    "handle": "toilets",
    "title": "Toilets",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 77,
    "description": "Shop toilets at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-in-1-round-close-coupled-toilet-basin-385w-x-400h-x-610d-tap-not-included",
      "2-in-1-square-close-coupled-toilet-basin-390w-x-400h-x-670d-tap-not-included",
      "ashford-back-to-wall-wc-anthracite-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-matt-grey-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-matt-grey-500w-x-805h-x-220d-1",
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d-1",
      "ashford-wc-unit-matt-blue-500w-x-805h-x-220d",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-400h-x-540d-copy",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-450h-x-480d-copy",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-360w-x-465h-x-605d-copy",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-360w-x-465h-x-605d-copy-1",
      "blu-rimless-comfort-height-back-to-wall-pan-soft-close-seat-white",
      "blu-rimless-comfort-height-back-to-wall-pan-soft-close-seat-white-360w-x-450h-x-480d-copy",
      "blu-wall-mounted-square-1-tap-hole-bathroom-basin-sink-full-pedestal-white",
      "blu-wall-mounted-square-1-tap-hole-bathroom-basin-sink-full-pedestal-white-520w-x-820h-x-420d-copy",
      "blu-wall-mounted-square-1-tap-hole-bathroom-basin-sink-full-pedestal-white-560w-x-850h-x-430d-copy",
      "brushed-brass-round-dual-flush-toilet-button-universal-fit-water-saving",
      "chelsea-500-x-300mm-wc-unit-white-500w-x-800h-x-300d",
      "chelsea-500-x-330mm-wc-unit-white-500w-x-770h-x-330d",
      "chrome-round-dual-flush-toilet-button-universal-fit-water-saving",
      "class-rimless-comfort-close-coupled-toilet-soft-close-seat-365w-x-460h-x-660d",
      "class-standard-close-coupled-toilet-soft-close-seat-370w-x-385h-x-650d",
      "cove-rimless-back-to-wall-pan-soft-close-seat-360w-x-410h-x-600d-white",
      "cove-rimless-close-coupled-toilet-soft-close-seat-375w-x-410h-x-660d-white",
      "cove-rimless-comfort-close-coupled-toilet-soft-close-sea-365w-x-450h-x-610d",
      "cove-rimless-square-wall-hung-wc-pan-soft-close-seat-360w-x290h-x-515d-white",
      "delta-rimless-close-coupled-toilet-soft-close-seat-365w-x-400h-x-610d-copy",
      "delta-rimless-close-coupled-toilet-soft-close-seat-365w-x-400h-x-610d-white",
      "delta-rimless-close-coupled-toilet-soft-close-seat-370w-x-400h-x-605d-white",
      "delta-rimless-close-coupled-toilet-soft-close-seat-380w-x-390h-x-630d",
      "delta-rimless-comfort-close-coupled-toilet-soft-close-seat-365w-x-455h-x-645d",
      "delta-rimless-comfort-close-coupled-toilet-soft-close-seat-390w-x-450h-x-625d",
      "delta-rimless-comfort-height-back-to-wall-pan-soft-close-seat-365w-x440h-x570d",
      "delta-rimless-d-shape-wall-hung-wc-pan-soft-close-seat-355w-x-315h-x-510d-copy",
      "delta-rimless-d-shape-wall-hung-wc-pan-soft-close-seat-360w-x-400h-x-560d-copy",
      "devon-5020-bathroom-wc-anthracite-500w-x-800h-x-200d",
      "devon-5020-bathroom-wc-matt-grey-500w-x-800h-x-200d",
      "devon-5020-bathroom-wc-white-500w-x-800h-x-200d",
      "dwelta-back-to-wall-wc-anthracite-500w-x-200d",
      "dwelta-back-to-wall-wc-anthracite-500w-x-200d-1",
      "dwelta-back-to-wall-wc-matt-grey-500w-x-200d",
      "dwelta-back-to-wall-wc-matt-grey-500w-x-200d-1",
      "dwelta-back-to-wall-wc-white-500w-x-200d",
      "dwelta-back-to-wall-wc-white-500w-x-200d-1",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white-360w-x-400h-x-520d-copy",
      "esen-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-1",
      "esen-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-375w-460h-635d-copy",
      "fife-rimless-back-to-wall-pan-soft-close-seat-360w-x-400h-x-600d-white",
      "fife-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white",
      "fife-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-365w-400h-600d-copy",
      "grand-back-to-wall-pan-amp-soft-close-toilet-seat-355w-x-400h-x-515d-white",
      "grand-rimless-close-coupled-toilet-soft-close-seat-370w-x-400h-x-615d",
      "grand-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x-460h-x-665d",
      "grand-rimless-comfort-height-back-to-wall-pan-soft-close-seat-360w-x460h-x500d",
      "haven-rimless-back-to-wall-pan-soft-close-seat-370w-x-430h-x-480d-white",
      "haven-rimless-close-coupled-toilet-soft-close-seat-370w-x-430h-x-610d",
      "haven-rimless-close-coupled-toilet-soft-close-seat-370w-x-430h-x-610d-white",
      "haven-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x-455h-x-665d",
      "haven-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x460h-x-665d",
      "haven-rimless-comfort-height-back-to-wall-pan-soft-close-seat-370w-x460h-x490d",
      "haven-rimless-wall-hung-toilet-soft-close-seat-370w-x-368h-x-490d-white-1",
      "matt-black-round-dual-flush-toilet-button-universal-fit-water-saving",
      "modern-close-coupled-toilet-with-soft-close-seat-dual-flush-compact-design-360w-x-465h-x-605d",
      "modern-corner-close-coupled-toilet-space-saving-wc-with-soft-360w-x-400h-x-605d",
      "modern-toilet-with-integrated-sink-saving-dual-flush-design-380w-x-410h-x-700d",
      "pvc-vanity-waterproof-back-to-wall-wc-unit-white-500w-x-200h-x-800d",
      "raven-rimless-close-coupled-toilet-soft-close-seat-matt-black-370w-x390h-x620d",
      "raven-rimless-square-back-to-wall-toilet-w-soft-close-seat-black-345w-x400hx560d",
      "raven-rimless-square-close-coupled-toilet-soft-close-seat-black-360wx405hx645d",
      "raven-rimless-square-wall-hung-toilet-w-soft-close-seat-black-340w-x-315h-x-510d",
      "raven-rimless-wall-hung-toilet-with-soft-close-seat-matt-black-360w-x-405h-x545d",
      "raven-rimless-wall-hung-toilet-with-soft-close-seat-matt-black-365w-x-350h-x520d",
      "stylish-white-wall-mounted-toilet-with-modern-sleek-design-360w-x-320h-x-510d"
    ]
  },
  {
    "handle": "close-coupled-toilets",
    "title": "Close Coupled Toilets",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 29,
    "description": "Shop close coupled toilets at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-in-1-round-close-coupled-toilet-basin-385w-x-400h-x-610d-tap-not-included",
      "2-in-1-square-close-coupled-toilet-basin-390w-x-400h-x-670d-tap-not-included",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-360w-x-465h-x-605d-copy",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-360w-x-465h-x-605d-copy-1",
      "class-rimless-comfort-close-coupled-toilet-soft-close-seat-365w-x-460h-x-660d",
      "class-standard-close-coupled-toilet-soft-close-seat-370w-x-385h-x-650d",
      "cove-rimless-close-coupled-toilet-soft-close-seat-375w-x-410h-x-660d-white",
      "cove-rimless-comfort-close-coupled-toilet-soft-close-sea-365w-x-450h-x-610d",
      "delta-rimless-close-coupled-toilet-soft-close-seat-365w-x-400h-x-610d-copy",
      "delta-rimless-close-coupled-toilet-soft-close-seat-365w-x-400h-x-610d-white",
      "delta-rimless-close-coupled-toilet-soft-close-seat-370w-x-400h-x-605d-white",
      "delta-rimless-close-coupled-toilet-soft-close-seat-380w-x-390h-x-630d",
      "delta-rimless-comfort-close-coupled-toilet-soft-close-seat-365w-x-455h-x-645d",
      "delta-rimless-comfort-close-coupled-toilet-soft-close-seat-390w-x-450h-x-625d",
      "esen-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-1",
      "esen-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-375w-460h-635d-copy",
      "fife-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white",
      "fife-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-365w-400h-600d-copy",
      "grand-rimless-close-coupled-toilet-soft-close-seat-370w-x-400h-x-615d",
      "grand-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x-460h-x-665d",
      "haven-rimless-close-coupled-toilet-soft-close-seat-370w-x-430h-x-610d",
      "haven-rimless-close-coupled-toilet-soft-close-seat-370w-x-430h-x-610d-white",
      "haven-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x-455h-x-665d",
      "haven-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x460h-x-665d",
      "modern-close-coupled-toilet-with-soft-close-seat-dual-flush-compact-design-360w-x-465h-x-605d",
      "modern-corner-close-coupled-toilet-space-saving-wc-with-soft-360w-x-400h-x-605d",
      "raven-rimless-close-coupled-toilet-soft-close-seat-matt-black-370w-x390h-x620d",
      "raven-rimless-square-close-coupled-toilet-soft-close-seat-black-360wx405hx645d"
    ]
  },
  {
    "handle": "back-to-wall-toilets",
    "title": "Back To Wall Toilets",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 29,
    "description": "Shop back to wall toilets at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-back-to-wall-wc-anthracite-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-matt-grey-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-matt-grey-500w-x-805h-x-220d-1",
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d-1",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-400h-x-540d-copy",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-450h-x-480d-copy",
      "blu-rimless-comfort-height-back-to-wall-pan-soft-close-seat-white",
      "blu-rimless-comfort-height-back-to-wall-pan-soft-close-seat-white-360w-x-450h-x-480d-copy",
      "cove-rimless-back-to-wall-pan-soft-close-seat-360w-x-410h-x-600d-white",
      "delta-rimless-comfort-height-back-to-wall-pan-soft-close-seat-365w-x440h-x570d",
      "delta-rimless-d-shape-wall-hung-wc-pan-soft-close-seat-355w-x-315h-x-510d-copy",
      "dwelta-back-to-wall-wc-anthracite-500w-x-200d",
      "dwelta-back-to-wall-wc-anthracite-500w-x-200d-1",
      "dwelta-back-to-wall-wc-matt-grey-500w-x-200d",
      "dwelta-back-to-wall-wc-matt-grey-500w-x-200d-1",
      "dwelta-back-to-wall-wc-white-500w-x-200d",
      "dwelta-back-to-wall-wc-white-500w-x-200d-1",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white-360w-x-400h-x-520d-copy",
      "fife-rimless-back-to-wall-pan-soft-close-seat-360w-x-400h-x-600d-white",
      "grand-back-to-wall-pan-amp-soft-close-toilet-seat-355w-x-400h-x-515d-white",
      "grand-rimless-comfort-height-back-to-wall-pan-soft-close-seat-360w-x460h-x500d",
      "haven-rimless-back-to-wall-pan-soft-close-seat-370w-x-430h-x-480d-white",
      "haven-rimless-comfort-height-back-to-wall-pan-soft-close-seat-370w-x460h-x490d",
      "pvc-vanity-waterproof-back-to-wall-wc-unit-white-500w-x-200h-x-800d",
      "raven-rimless-square-back-to-wall-toilet-w-soft-close-seat-black-345w-x400hx560d",
      "raven-rimless-wall-hung-toilet-with-soft-close-seat-matt-black-360w-x-405h-x545d"
    ]
  },
  {
    "handle": "wall-hung-toilets",
    "title": "Wall Hung Toilets",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 9,
    "description": "Shop wall hung toilets at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "cove-rimless-square-wall-hung-wc-pan-soft-close-seat-360w-x290h-x-515d-white",
      "delta-rimless-d-shape-wall-hung-wc-pan-soft-close-seat-355w-x-315h-x-510d-copy",
      "delta-rimless-d-shape-wall-hung-wc-pan-soft-close-seat-360w-x-400h-x-560d-copy",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white-360w-x-400h-x-520d-copy",
      "haven-rimless-wall-hung-toilet-soft-close-seat-370w-x-368h-x-490d-white-1",
      "raven-rimless-square-wall-hung-toilet-w-soft-close-seat-black-340w-x-315h-x-510d",
      "raven-rimless-wall-hung-toilet-with-soft-close-seat-matt-black-360w-x-405h-x545d",
      "raven-rimless-wall-hung-toilet-with-soft-close-seat-matt-black-365w-x-350h-x520d"
    ]
  },
  {
    "handle": "rimless-toilets",
    "title": "Rimless Toilets",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 46,
    "description": "Shop rimless toilets at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-in-1-square-close-coupled-toilet-basin-390w-x-400h-x-670d-tap-not-included",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-400h-x-540d-copy",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-450h-x-480d-copy",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-360w-x-465h-x-605d-copy",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-360w-x-465h-x-605d-copy-1",
      "blu-rimless-comfort-height-back-to-wall-pan-soft-close-seat-white",
      "blu-rimless-comfort-height-back-to-wall-pan-soft-close-seat-white-360w-x-450h-x-480d-copy",
      "class-rimless-comfort-close-coupled-toilet-soft-close-seat-365w-x-460h-x-660d",
      "cove-rimless-back-to-wall-pan-soft-close-seat-360w-x-410h-x-600d-white",
      "cove-rimless-close-coupled-toilet-soft-close-seat-375w-x-410h-x-660d-white",
      "cove-rimless-comfort-close-coupled-toilet-soft-close-sea-365w-x-450h-x-610d",
      "cove-rimless-square-wall-hung-wc-pan-soft-close-seat-360w-x290h-x-515d-white",
      "delta-rimless-close-coupled-toilet-soft-close-seat-365w-x-400h-x-610d-copy",
      "delta-rimless-close-coupled-toilet-soft-close-seat-365w-x-400h-x-610d-white",
      "delta-rimless-close-coupled-toilet-soft-close-seat-370w-x-400h-x-605d-white",
      "delta-rimless-close-coupled-toilet-soft-close-seat-380w-x-390h-x-630d",
      "delta-rimless-comfort-close-coupled-toilet-soft-close-seat-365w-x-455h-x-645d",
      "delta-rimless-comfort-close-coupled-toilet-soft-close-seat-390w-x-450h-x-625d",
      "delta-rimless-comfort-height-back-to-wall-pan-soft-close-seat-365w-x440h-x570d",
      "delta-rimless-d-shape-wall-hung-wc-pan-soft-close-seat-355w-x-315h-x-510d-copy",
      "delta-rimless-d-shape-wall-hung-wc-pan-soft-close-seat-360w-x-400h-x-560d-copy",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white-360w-x-400h-x-520d-copy",
      "esen-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-1",
      "esen-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-375w-460h-635d-copy",
      "fife-rimless-back-to-wall-pan-soft-close-seat-360w-x-400h-x-600d-white",
      "fife-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white",
      "fife-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-365w-400h-600d-copy",
      "grand-rimless-close-coupled-toilet-soft-close-seat-370w-x-400h-x-615d",
      "grand-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x-460h-x-665d",
      "grand-rimless-comfort-height-back-to-wall-pan-soft-close-seat-360w-x460h-x500d",
      "haven-rimless-back-to-wall-pan-soft-close-seat-370w-x-430h-x-480d-white",
      "haven-rimless-close-coupled-toilet-soft-close-seat-370w-x-430h-x-610d",
      "haven-rimless-close-coupled-toilet-soft-close-seat-370w-x-430h-x-610d-white",
      "haven-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x-455h-x-665d",
      "haven-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x460h-x-665d",
      "haven-rimless-comfort-height-back-to-wall-pan-soft-close-seat-370w-x460h-x490d",
      "haven-rimless-wall-hung-toilet-soft-close-seat-370w-x-368h-x-490d-white-1",
      "raven-rimless-close-coupled-toilet-soft-close-seat-matt-black-370w-x390h-x620d",
      "raven-rimless-square-back-to-wall-toilet-w-soft-close-seat-black-345w-x400hx560d",
      "raven-rimless-square-close-coupled-toilet-soft-close-seat-black-360wx405hx645d",
      "raven-rimless-square-wall-hung-toilet-w-soft-close-seat-black-340w-x-315h-x-510d",
      "raven-rimless-wall-hung-toilet-with-soft-close-seat-matt-black-360w-x-405h-x545d",
      "raven-rimless-wall-hung-toilet-with-soft-close-seat-matt-black-365w-x-350h-x520d"
    ]
  },
  {
    "handle": "comfort-height-toilets",
    "title": "Comfort Height Toilets",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 23,
    "description": "Shop comfort height toilets at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-400h-x-540d-copy",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-450h-x-480d-copy",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-360w-x-465h-x-605d-copy",
      "aura-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-360w-x-465h-x-605d-copy-1",
      "blu-rimless-comfort-height-back-to-wall-pan-soft-close-seat-white",
      "blu-rimless-comfort-height-back-to-wall-pan-soft-close-seat-white-360w-x-450h-x-480d-copy",
      "class-rimless-comfort-close-coupled-toilet-soft-close-seat-365w-x-460h-x-660d",
      "cove-rimless-comfort-close-coupled-toilet-soft-close-sea-365w-x-450h-x-610d",
      "delta-rimless-comfort-close-coupled-toilet-soft-close-seat-365w-x-455h-x-645d",
      "delta-rimless-comfort-close-coupled-toilet-soft-close-seat-390w-x-450h-x-625d",
      "delta-rimless-comfort-height-back-to-wall-pan-soft-close-seat-365w-x440h-x570d",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white",
      "esen-rimless-comfort-height-back-to-wall-hung-toilet-soft-close-seat-white-360w-x-400h-x-520d-copy",
      "esen-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-1",
      "esen-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-375w-460h-635d-copy",
      "fife-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white",
      "fife-rimless-comfort-height-close-coupled-toilet-soft-close-seat-white-365w-400h-600d-copy",
      "grand-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x-460h-x-665d",
      "grand-rimless-comfort-height-back-to-wall-pan-soft-close-seat-360w-x460h-x500d",
      "haven-rimless-comfort-close-coupled-toilet-soft-close-seat-370w-x460h-x-665d",
      "haven-rimless-comfort-height-back-to-wall-pan-soft-close-seat-370w-x460h-x490d"
    ]
  },
  {
    "handle": "toilet-seats",
    "title": "Toilet Seats",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 7,
    "description": "Shop toilet seats at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-400h-x-540d-copy",
      "aura-rimless-comfort-height-back-to-wall-pan-soft-close-toilet-seat-white-360w-x-450h-x-480d-copy",
      "delta-rimless-d-shape-wall-hung-wc-pan-soft-close-seat-355w-x-315h-x-510d",
      "grand-back-to-wall-pan-amp-soft-close-toilet-seat-355w-x-400h-x-515d-white",
      "standard-soft-close-d-shape-toilet-seat-white",
      "standard-soft-close-square-toilet-seat-white"
    ]
  },
  {
    "handle": "concealed-cisterns",
    "title": "Concealed Cisterns",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 7,
    "description": "Shop concealed cisterns at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "brushed-brass-dual-flush-push-button-plate-63w-x-63h-for-fac001n-fac001s",
      "chrome-square-dual-flush-push-button-plate-63w-x-63h-for-fac001n-fac001s",
      "concealed-cistern-wall-hung-wc-frame-395w-x-1134-1464h-x-119d",
      "concealed-cistern-with-bottom-inlet-white",
      "concealed-cistern-with-side-inlet-compact-toilet-tank-335x290x140mm",
      "infra-red-sensor-concealed-cistern-hygienic-touchless-flush-toilet-tank",
      "matt-black-square-dual-flush-push-button-plate-63w-x-63h-for-fac001n-fac001s"
    ]
  },
  {
    "handle": "flush-plates-and-buttons",
    "title": "Flush Plates & Buttons",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 10,
    "description": "Shop flush plates & buttons at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "brushed-brass-dual-flush-push-button-plate-63w-x-63h-for-fac001n-fac001s",
      "brushed-brass-round-dual-flush-toilet-button-universal-fit-water-saving",
      "chrome-round-dual-flush-toilet-button-universal-fit-water-saving",
      "chrome-square-dual-flush-push-button-plate-63w-x-63h-for-fac001n-fac001s",
      "matt-black-round-dual-flush-toilet-button-universal-fit-water-saving",
      "matt-black-square-dual-flush-push-button-plate-63w-x-63h-for-fac001n-fac001s",
      "modern-white-toilet-with-compact-design-and-chrome-flush-button-420w-x-400h-x-670d",
      "square-flush-plate-black-push-button-can-only-be-used-for-wc-frame-236w-x-152h",
      "square-flush-plate-brushed-brass-push-button-can-only-used-for-wc-frame236wx152h",
      "square-flush-plate-chrome-push-button-can-only-be-used-for-wc-frame-236w-x-152h"
    ]
  },
  {
    "handle": "toilet-frames",
    "title": "Toilet Frames",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 5,
    "description": "Shop toilet frames at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "compact-top-front-flush-toilet-frame-480w-x-1134-1464h-x-102d",
      "concealed-cistern-wall-hung-wc-frame-395w-x-1134-1464h-x-119d",
      "square-flush-plate-black-push-button-can-only-be-used-for-wc-frame-236w-x-152h",
      "square-flush-plate-brushed-brass-push-button-can-only-used-for-wc-frame236wx152h",
      "square-flush-plate-chrome-push-button-can-only-be-used-for-wc-frame-236w-x-152h"
    ]
  },
  {
    "handle": "toilet-and-basin-units",
    "title": "Toilet and Basin Units",
    "parentCategory": "Toilets & Cisterns",
    "productCount": 2,
    "description": "Shop toilet and basin units at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-in-1-round-close-coupled-toilet-basin-385w-x-400h-x-610d-tap-not-included",
      "2-in-1-square-close-coupled-toilet-basin-390w-x-400h-x-670d-tap-not-included"
    ]
  },
  {
    "handle": "bathroom-furniture",
    "title": "Bathroom Furniture",
    "parentCategory": "Bathroom Furniture",
    "productCount": 142,
    "description": "Shop bathroom furniture at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-back-to-wall-wc-matt-grey-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d-1",
      "ashford-wall-hung-side-cabinet-anthracite-350w-x-1000h-x-240d",
      "ashford-wall-hung-side-cabinet-matt-blue-350w-x-1000h-x-240d",
      "ashford-wall-hung-side-cabinet-matt-grey-350w-x-1000h-x-240d",
      "ashford-wall-hung-side-cabinet-white-350w-x-1000h-x-240d",
      "ashford-wc-unit-matt-blue-500w-x-805h-x-220d",
      "bathroom-mid-edge-ceramic-500mm-freestanding-basin-sink-vanity-unit-furniture",
      "camberly-600-matt-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "camberly-800-freestanding-ceramic-vanity-basin-matt-grey-810w-x-815h-x-465d",
      "chelsea-1050-white-vanity-unit-with-ceramic-basin-1060w-x-836h-x-485d",
      "chelsea-400-white-ceramic-vanity-basin-400w-x-810h-x-400d",
      "chelsea-450-white-ceramic-vanity-basin-450w-x-836h-x-440d",
      "chelsea-500-x-300mm-wc-unit-white-500w-x-800h-x-300d",
      "chelsea-500-x-330mm-wc-unit-white-500w-x-770h-x-330d",
      "chelsea-550-white-ceramic-vanity-basin-550w-x-836h-x-430d",
      "chelsea-650-white-ceramic-vanity-basin-650w-x-836h-x-446d",
      "chelsea-750-white-vanity-unit-with-ceramic-basin-755w-x-836h-x-485d",
      "chelsea-850-white-vanity-unit-with-ceramic-basin-855w-x-836h-x-485d",
      "chelsea-corner-mirror-cabinet-white-320w-x-650h-x-320d",
      "devon-1200-mirror-cabinet-1200mm-wide-bathroom-storage-with-mirror-doors",
      "devon-400-floorstanding-anthracite-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-floorstanding-matt-grey-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-floorstanding-white-ceramic-basin-400w-x-790h-x-220d-1",
      "devon-400-mirror-cabinet-400w-x-700h-x-150d",
      "devon-400-wall-hung-ceramic-vanity-basin-anthracite-nbsp-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-matt-grey-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-white-400w-x-450h-x-220d",
      "devon-450-floorstanding-anthracite-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-matt-grey-vanity-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-450-floorstanding-white-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-matt-grey-450w-x-585h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-white-450w-x-585h-x-310d",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-830h-x395d",
      "devon-500-floorstanding-twin-drawers-white-anthracite-basin-510w-x-830h-x-395d-1",
      "devon-500-floorstanding-vanity-unit-with-drawers-anthracite-finish-ceramic-basin",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-600-floorstanding-anthracite-drawers-anthracite-basin-610w-x-790h-x-395d",
      "devon-600-floorstanding-doors-matt-grey-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-doors-white-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-drawers-matt-grey-ceramic-basin-610w-x-790h-x-395d",
      "devon-600-floorstanding-vanity-unit-with-ceramic-basin-white",
      "devon-600-floorstanding-white-drawers-ceramic-basin-610w-x-790h-x-395d",
      "devon-600-mirror-cabinet-600w-x-700h-x-150d",
      "devon-800-floorstanding-drawers-anthracite-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-floorstanding-drawers-matt-grey-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-floorstanding-drawers-white-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "devon-900-mirror-cabinet-900mm-wide-wall-mounted-bathroom-storage-with-mirror-doors",
      "devon-freestanding-tallboy-storage-unit-white-350w-x-1700h-x-300d",
      "devon-harrow-vanity-worktop-anthracite-finish",
      "devon-harrow-vanity-worktop-matt-grey-finish",
      "devon-harrow-vanity-worktop-white-finish",
      "dwelta-500-floorstanding-anthracite-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-floorstanding-matt-grey-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-floorstanding-white-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-600-floorstanding-anthracite-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-floorstanding-matt-grey-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-floorstanding-white-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-wall-hung-anthracite-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-800-floorstanding-anthracite-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-matt-grey-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-white-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "dwelta-matt-grey-bathroom-worktop-stylish-durable-vanity-countertop",
      "dwelta-tallboy-storage-cabinet-anthracite-finish-slim-bathroom-unit",
      "dwelta-wall-hung-tallboy-storage-white-400w-x-1500h-x-300d",
      "dwelta-white-bathroom-worktop-sleek-durable-vanity-countertop-surface",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-brass-200w-x-30h",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-brass-200w-x-30h-1",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-silver-200w-x-30h",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-silver-200w-x-30h-1",
      "handles-for-pmb-vanity-with-fixings-pair-chrome-200w-x-30h",
      "handles-for-pmb-vanity-with-fixings-pair-chrome-200w-x-30h-1",
      "handles-for-pmb-vanity-with-fixings-pair-matt-black-200w-x-30h",
      "harris-900mm-left-white-vanity-unit-with-resin-basin-storage-cabinet",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d-1",
      "harrow-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d-1",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-600-floorstanding-doors-anthracite-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-doors-matt-grey-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-doors-white-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-twin-drawer-anthracite-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-floorstanding-twin-drawer-matt-grey-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-floorstanding-twin-drawer-white-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-600-wall-hung-twin-drawer-matt-grey-ceramic-basin-605w-x-585h-x-395d",
      "harrow-800-floorstanding-twin-drawer-anthracite-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-matt-grey-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d-copy",
      "hilton-2-door-mirror-cabinet-cream-500w-x-600h-x-205d",
      "hilton-600-freestanding-ceramic-vanity-basin-cream-610w-x-840h-x-460d",
      "hilton-800-freestanding-ceramic-vanity-basin-cream-810w-x-815h-x-465d",
      "hilton-freestanding-tallboy-storage-unit-cream-465w-x-1180h-x-455d",
      "led-mirror-cabinet-1-door-with-sensor-shaver-socket-modern-bathroom",
      "led-mirror-cabinet-2-door-with-sensor-shaver-socket-bathroom-storage",
      "led-rectangle-bathroom-mirror-500x700mm-with-shaver-socket-modern-vanity",
      "led-rectangle-bathroom-mirror-800x600mm-with-shaver-socket-modern-vanity",
      "led-round-bathroom-mirror-600x600mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-bathroom-mirror-700x700mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-corner-bathroom-mirror-with-built-in-light-modern-vanity-mirror",
      "paris-1100mm-left-matt-grey-vanity-basin-unit-with-resin-sink-storage",
      "paris-600-floorstanding-anthracite-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-600-floorstanding-matt-grey-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-600-floorstanding-white-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d-1",
      "paris-bathroom-wall-hung-cabinet-tallboy-matt-grey-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-nbsp-320w-x-1418h-x-360d",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-610w-x-840h-x-395d-copy",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d-copy",
      "pvc-vanity-500-wall-hung-twin-drawers-waterproof-vanity-ceramic-basin-510w-x-585h-x-395d",
      "pvc-vanity-600-floorstanding-twin-drawers-white-ceramic-basin-610w-x-840h-x-395d",
      "pvc-vanity-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "pvc-vanity-waterproof-back-to-wall-wc-unit-white-500w-x-200h-x-800d",
      "sharaton-600-stone-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "sharaton-800-stone-grey-vanity-unit-with-ceramic-basin-810w-x-815h-x-465d",
      "sharaton-mirror-cabinet-stone-grey-500w-x-600h-x-205d",
      "sharaton-tallboy-cabinet-stone-grey-465w-x-1180h-x-455d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d-copy",
      "slim-1000-floorstanding-white-cabinet-resin-basin-1000w-x-865h-x-305d",
      "welta-tallboy-storage-cabinet-matt-grey-400w-x-1500h-x-300d"
    ]
  },
  {
    "handle": "bathroom-vanities",
    "title": "Bathroom Vanities",
    "parentCategory": "Bathroom Furniture",
    "productCount": 61,
    "description": "Shop bathroom vanities at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "bathroom-mid-edge-ceramic-500mm-freestanding-basin-sink-vanity-unit-furniture",
      "camberly-600-matt-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "camberly-800-freestanding-ceramic-vanity-basin-matt-grey-810w-x-815h-x-465d",
      "chelsea-1050-white-vanity-unit-with-ceramic-basin-1060w-x-836h-x-485d",
      "chelsea-400-white-ceramic-vanity-basin-400w-x-810h-x-400d",
      "chelsea-450-white-ceramic-vanity-basin-450w-x-836h-x-440d",
      "chelsea-550-white-ceramic-vanity-basin-550w-x-836h-x-430d",
      "chelsea-650-white-ceramic-vanity-basin-650w-x-836h-x-446d",
      "chelsea-750-white-vanity-unit-with-ceramic-basin-755w-x-836h-x-485d",
      "chelsea-850-white-vanity-unit-with-ceramic-basin-855w-x-836h-x-485d",
      "devon-400-wall-hung-ceramic-vanity-basin-anthracite-nbsp-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-matt-grey-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-white-400w-x-450h-x-220d",
      "devon-450-floorstanding-matt-grey-vanity-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-450-wall-hung-ceramic-vanity-basin-matt-grey-450w-x-585h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-white-450w-x-585h-x-310d",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-830h-x395d",
      "devon-500-floorstanding-vanity-unit-with-drawers-anthracite-finish-ceramic-basin",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-600-floorstanding-vanity-unit-with-ceramic-basin-white",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "devon-harrow-vanity-worktop-anthracite-finish",
      "devon-harrow-vanity-worktop-matt-grey-finish",
      "devon-harrow-vanity-worktop-white-finish",
      "dwelta-600-wall-hung-anthracite-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "dwelta-matt-grey-bathroom-worktop-stylish-durable-vanity-countertop",
      "dwelta-white-bathroom-worktop-sleek-durable-vanity-countertop-surface",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-brass-200w-x-30h",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-brass-200w-x-30h-1",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-silver-200w-x-30h",
      "handles-for-pmb-vanity-with-fixings-pair-brushed-silver-200w-x-30h-1",
      "handles-for-pmb-vanity-with-fixings-pair-chrome-200w-x-30h",
      "handles-for-pmb-vanity-with-fixings-pair-chrome-200w-x-30h-1",
      "handles-for-pmb-vanity-with-fixings-pair-matt-black-200w-x-30h",
      "harris-900mm-left-white-vanity-unit-with-resin-basin-storage-cabinet",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-600-wall-hung-twin-drawer-matt-grey-ceramic-basin-605w-x-585h-x-395d",
      "harrow-800-floorstanding-twin-drawer-matt-grey-ceramic-basin-800w-x-835h-x-395d",
      "hilton-600-freestanding-ceramic-vanity-basin-cream-610w-x-840h-x-460d",
      "hilton-800-freestanding-ceramic-vanity-basin-cream-810w-x-815h-x-465d",
      "led-rectangle-bathroom-mirror-500x700mm-with-shaver-socket-modern-vanity",
      "led-rectangle-bathroom-mirror-800x600mm-with-shaver-socket-modern-vanity",
      "led-round-bathroom-mirror-600x600mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-bathroom-mirror-700x700mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-corner-bathroom-mirror-with-built-in-light-modern-vanity-mirror",
      "paris-1100mm-left-matt-grey-vanity-basin-unit-with-resin-sink-storage",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-610w-x-840h-x-395d-copy",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d-copy",
      "pvc-vanity-500-wall-hung-twin-drawers-waterproof-vanity-ceramic-basin-510w-x-585h-x-395d",
      "pvc-vanity-600-floorstanding-twin-drawers-white-ceramic-basin-610w-x-840h-x-395d",
      "pvc-vanity-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "pvc-vanity-waterproof-back-to-wall-wc-unit-white-500w-x-200h-x-800d",
      "sharaton-600-stone-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "sharaton-800-stone-grey-vanity-unit-with-ceramic-basin-810w-x-815h-x-465d"
    ]
  },
  {
    "handle": "vanity-units",
    "title": "Vanity Units",
    "parentCategory": "Bathroom Furniture",
    "productCount": 19,
    "description": "Shop vanity units at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "bathroom-mid-edge-ceramic-500mm-freestanding-basin-sink-vanity-unit-furniture",
      "camberly-600-matt-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "chelsea-1050-white-vanity-unit-with-ceramic-basin-1060w-x-836h-x-485d",
      "chelsea-750-white-vanity-unit-with-ceramic-basin-755w-x-836h-x-485d",
      "chelsea-850-white-vanity-unit-with-ceramic-basin-855w-x-836h-x-485d",
      "devon-450-floorstanding-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-830h-x395d",
      "devon-500-floorstanding-vanity-unit-with-drawers-anthracite-finish-ceramic-basin",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-600-floorstanding-vanity-unit-with-ceramic-basin-white",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "harris-900mm-left-white-vanity-unit-with-resin-basin-storage-cabinet",
      "paris-1100mm-left-matt-grey-vanity-basin-unit-with-resin-sink-storage",
      "pvc-vanity-waterproof-back-to-wall-wc-unit-white-500w-x-200h-x-800d",
      "sharaton-600-stone-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "sharaton-800-stone-grey-vanity-unit-with-ceramic-basin-810w-x-815h-x-465d"
    ]
  },
  {
    "handle": "wall-hung-vanity-units",
    "title": "Wall Hung Vanity Units",
    "parentCategory": "Bathroom Furniture",
    "productCount": 26,
    "description": "Shop wall hung vanity units at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-wall-hung-side-cabinet-anthracite-350w-x-1000h-x-240d",
      "ashford-wall-hung-side-cabinet-matt-blue-350w-x-1000h-x-240d",
      "ashford-wall-hung-side-cabinet-matt-grey-350w-x-1000h-x-240d",
      "ashford-wall-hung-side-cabinet-white-350w-x-1000h-x-240d",
      "devon-400-wall-hung-ceramic-vanity-basin-anthracite-nbsp-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-matt-grey-400w-x-450h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-white-400w-x-450h-x-220d",
      "devon-450-wall-hung-ceramic-vanity-basin-matt-grey-450w-x-585h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-white-450w-x-585h-x-310d",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "dwelta-600-wall-hung-anthracite-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "dwelta-wall-hung-tallboy-storage-white-400w-x-1500h-x-300d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-600-wall-hung-twin-drawer-matt-grey-ceramic-basin-605w-x-585h-x-395d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d-1",
      "paris-bathroom-wall-hung-cabinet-tallboy-matt-grey-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-nbsp-320w-x-1418h-x-360d",
      "pvc-vanity-500-wall-hung-twin-drawers-waterproof-vanity-ceramic-basin-510w-x-585h-x-395d",
      "pvc-vanity-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d"
    ]
  },
  {
    "handle": "floorstanding-vanity-units",
    "title": "Floorstanding Vanity Units",
    "parentCategory": "Bathroom Furniture",
    "productCount": 63,
    "description": "Shop floorstanding vanity units at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "bathroom-mid-edge-ceramic-500mm-freestanding-basin-sink-vanity-unit-furniture",
      "devon-400-floorstanding-anthracite-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-floorstanding-matt-grey-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-floorstanding-white-ceramic-basin-400w-x-790h-x-220d-1",
      "devon-450-floorstanding-anthracite-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-matt-grey-vanity-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-450-floorstanding-white-ceramic-basin-450w-x-810h-x-310d",
      "devon-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-830h-x395d",
      "devon-500-floorstanding-twin-drawers-white-anthracite-basin-510w-x-830h-x-395d-1",
      "devon-500-floorstanding-vanity-unit-with-drawers-anthracite-finish-ceramic-basin",
      "devon-600-floorstanding-anthracite-drawers-anthracite-basin-610w-x-790h-x-395d",
      "devon-600-floorstanding-doors-matt-grey-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-doors-white-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-drawers-matt-grey-ceramic-basin-610w-x-790h-x-395d",
      "devon-600-floorstanding-vanity-unit-with-ceramic-basin-white",
      "devon-600-floorstanding-white-drawers-ceramic-basin-610w-x-790h-x-395d",
      "devon-800-floorstanding-drawers-anthracite-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-floorstanding-drawers-matt-grey-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-floorstanding-drawers-white-ceramic-basin-810w-x-825h-x-395d",
      "dwelta-500-floorstanding-anthracite-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-floorstanding-matt-grey-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-500-floorstanding-white-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-600-floorstanding-anthracite-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-floorstanding-matt-grey-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-floorstanding-white-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-800-floorstanding-anthracite-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-matt-grey-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-floorstanding-white-resin-basin-800w-x-850h-x-450d",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d-1",
      "harrow-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d-1",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-600-floorstanding-doors-anthracite-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-doors-matt-grey-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-doors-white-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-twin-drawer-anthracite-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-floorstanding-twin-drawer-matt-grey-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-floorstanding-twin-drawer-white-ceramic-basin-610w-x-840h-x-395d",
      "harrow-800-floorstanding-twin-drawer-anthracite-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-matt-grey-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d-copy",
      "paris-600-floorstanding-anthracite-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-600-floorstanding-matt-grey-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-600-floorstanding-white-bathroom-resin-basin-600w-x-825h-x-460d",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-twin-drawer-vanity-ceramic-basin-610w-x-840h-x-395d-copy",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d",
      "pvc-vanity-500-floorstanding-waterproof-vanity-ceramic-basin-510w-x-840h-x-395d-copy",
      "pvc-vanity-600-floorstanding-twin-drawers-white-ceramic-basin-610w-x-840h-x-395d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d-copy",
      "slim-1000-floorstanding-white-cabinet-resin-basin-1000w-x-865h-x-305d"
    ]
  },
  {
    "handle": "basin-units",
    "title": "Basin Units",
    "parentCategory": "Bathroom Furniture",
    "productCount": 17,
    "description": "Shop basin units at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "camberly-600-matt-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "chelsea-1050-white-vanity-unit-with-ceramic-basin-1060w-x-836h-x-485d",
      "chelsea-750-white-vanity-unit-with-ceramic-basin-755w-x-836h-x-485d",
      "chelsea-850-white-vanity-unit-with-ceramic-basin-855w-x-836h-x-485d",
      "devon-450-floorstanding-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-830h-x395d",
      "devon-500-floorstanding-vanity-unit-with-drawers-anthracite-finish-ceramic-basin",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-600-floorstanding-vanity-unit-with-ceramic-basin-white",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "harris-900mm-left-white-vanity-unit-with-resin-basin-storage-cabinet",
      "paris-1100mm-left-matt-grey-vanity-basin-unit-with-resin-sink-storage",
      "sharaton-600-stone-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "sharaton-800-stone-grey-vanity-unit-with-ceramic-basin-810w-x-815h-x-465d"
    ]
  },
  {
    "handle": "tallboy-units",
    "title": "Tallboy Units",
    "parentCategory": "Bathroom Furniture",
    "productCount": 11,
    "description": "Shop tallboy units at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "devon-freestanding-tallboy-storage-unit-white-350w-x-1700h-x-300d",
      "dwelta-tallboy-storage-cabinet-anthracite-finish-slim-bathroom-unit",
      "dwelta-wall-hung-tallboy-storage-white-400w-x-1500h-x-300d",
      "hilton-freestanding-tallboy-storage-unit-cream-465w-x-1180h-x-455d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d-1",
      "paris-bathroom-wall-hung-cabinet-tallboy-matt-grey-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-nbsp-320w-x-1418h-x-360d",
      "sharaton-tallboy-cabinet-stone-grey-465w-x-1180h-x-455d",
      "welta-tallboy-storage-cabinet-matt-grey-400w-x-1500h-x-300d"
    ]
  },
  {
    "handle": "wc-units",
    "title": "WC Units",
    "parentCategory": "Bathroom Furniture",
    "productCount": 6,
    "description": "Shop wc units at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d-1",
      "ashford-wc-unit-matt-blue-500w-x-805h-x-220d",
      "chelsea-500-x-300mm-wc-unit-white-500w-x-800h-x-300d",
      "chelsea-500-x-330mm-wc-unit-white-500w-x-770h-x-330d",
      "pvc-vanity-waterproof-back-to-wall-wc-unit-white-500w-x-200h-x-800d"
    ]
  },
  {
    "handle": "anthracite-bathroom-furniture",
    "title": "Anthracite Bathroom Furniture",
    "parentCategory": "Bathroom Furniture",
    "productCount": 33,
    "description": "Shop anthracite bathroom furniture at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-wall-hung-side-cabinet-anthracite-350w-x-1000h-x-240d",
      "bathroom-mid-edge-ceramic-500mm-freestanding-basin-sink-vanity-unit-furniture",
      "devon-400-floorstanding-anthracite-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-anthracite-nbsp-400w-x-450h-x-220d",
      "devon-450-floorstanding-anthracite-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-floorstanding-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-450-wall-hung-vanity-unit-anthracite-finish-with-ceramic-basin",
      "devon-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-twin-drawers-white-anthracite-basin-510w-x-830h-x-395d-1",
      "devon-500-floorstanding-vanity-unit-with-drawers-anthracite-finish-ceramic-basin",
      "devon-600-floorstanding-anthracite-drawers-anthracite-basin-610w-x-790h-x-395d",
      "devon-800-floorstanding-drawers-anthracite-ceramic-basin-810w-x-825h-x-395d",
      "devon-800-wall-hung-vanity-unit-with-twin-drawers-anthracite-finish-ceramic-basin",
      "devon-harrow-vanity-worktop-anthracite-finish",
      "dwelta-500-floorstanding-anthracite-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-600-floorstanding-anthracite-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-600-wall-hung-anthracite-ceramic-basin-600w-x-500h-x-450d",
      "dwelta-600-wall-hung-vanity-unit-with-ceramic-basin-anthracite-finish",
      "dwelta-800-floorstanding-anthracite-resin-basin-800w-x-850h-x-450d",
      "dwelta-800-wall-hung-vanity-unit-with-resin-basin-anthracite-800x500x450mm",
      "dwelta-tallboy-storage-cabinet-anthracite-finish-slim-bathroom-unit",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-doors-anthracite-ceramic-basin-510w-x-840h-x-395d-1",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d",
      "harrow-500-floorstanding-twin-drawers-anthracite-ceramic-basin-510w-x-840h-x390d-1",
      "harrow-600-floorstanding-doors-anthracite-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-twin-drawer-anthracite-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d",
      "harrow-600-wall-hung-twin-drawer-anthracite-ceramic-basin-605w-x-585h-x-395d-copy",
      "harrow-800-floorstanding-twin-drawer-anthracite-ceramic-basin-800w-x-835h-x-395d",
      "paris-600-floorstanding-anthracite-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-anthracite-320w-x-1418h-x-360d-1"
    ]
  },
  {
    "handle": "matt-grey-bathroom-furniture",
    "title": "Matt Grey Bathroom Furniture",
    "parentCategory": "Bathroom Furniture",
    "productCount": 36,
    "description": "Shop matt grey bathroom furniture at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-back-to-wall-wc-matt-grey-500w-x-805h-x-220d",
      "ashford-wall-hung-side-cabinet-matt-grey-350w-x-1000h-x-240d",
      "camberly-600-matt-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "camberly-800-freestanding-ceramic-vanity-basin-matt-grey-810w-x-815h-x-465d",
      "devon-400-floorstanding-matt-grey-ceramic-basin-400w-x-790h-x-220d",
      "devon-400-wall-hung-ceramic-vanity-basin-matt-grey-400w-x-450h-x-220d",
      "devon-450-floorstanding-matt-grey-vanity-basin-450w-x-810h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-matt-grey-450w-x-585h-x-310d",
      "devon-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-830h-x395d",
      "devon-500-wall-hung-vanity-unit-matt-grey-with-twin-drawers-ceramic-basin-510mm",
      "devon-600-floorstanding-doors-matt-grey-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-drawers-matt-grey-ceramic-basin-610w-x-790h-x-395d",
      "devon-800-floorstanding-drawers-matt-grey-ceramic-basin-810w-x-825h-x-395d",
      "devon-harrow-vanity-worktop-matt-grey-finish",
      "dwelta-500-floorstanding-matt-grey-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-600-floorstanding-matt-grey-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-800-floorstanding-matt-grey-resin-basin-800w-x-850h-x-450d",
      "dwelta-matt-grey-bathroom-worktop-stylish-durable-vanity-countertop",
      "harrow-500-floorstanding-doors-matt-grey-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-matt-grey-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-600-floorstanding-doors-matt-grey-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-twin-drawer-matt-grey-ceramic-basin-610w-x-840h-x-395d",
      "harrow-600-wall-hung-twin-drawer-matt-grey-ceramic-basin-605w-x-585h-x-395d",
      "harrow-800-floorstanding-twin-drawer-matt-grey-ceramic-basin-800w-x-835h-x-395d",
      "paris-1100mm-left-matt-grey-vanity-basin-unit-with-resin-sink-storage",
      "paris-600-floorstanding-matt-grey-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-bathroom-wall-hung-cabinet-tallboy-matt-grey-320w-x-1418h-x-360d",
      "sharaton-600-stone-grey-vanity-unit-with-ceramic-basin-610w-x-840h-x-460d",
      "sharaton-800-stone-grey-vanity-unit-with-ceramic-basin-810w-x-815h-x-465d",
      "sharaton-mirror-cabinet-stone-grey-500w-x-600h-x-205d",
      "sharaton-tallboy-cabinet-stone-grey-465w-x-1180h-x-455d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d",
      "slim-1000-floorstanding-matt-grey-cabinet-resin-basin-1000w-x-865h-x-305d-copy",
      "welta-tallboy-storage-cabinet-matt-grey-400w-x-1500h-x-300d"
    ]
  },
  {
    "handle": "white-bathroom-furniture",
    "title": "White Bathroom Furniture",
    "parentCategory": "Bathroom Furniture",
    "productCount": 47,
    "description": "Shop white bathroom furniture at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d",
      "ashford-back-to-wall-wc-unit-white-500w-x-805h-x-220d-1",
      "ashford-wall-hung-side-cabinet-white-350w-x-1000h-x-240d",
      "chelsea-1050-white-vanity-unit-with-ceramic-basin-1060w-x-836h-x-485d",
      "chelsea-400-white-ceramic-vanity-basin-400w-x-810h-x-400d",
      "chelsea-450-white-ceramic-vanity-basin-450w-x-836h-x-440d",
      "chelsea-500-x-300mm-wc-unit-white-500w-x-800h-x-300d",
      "chelsea-500-x-330mm-wc-unit-white-500w-x-770h-x-330d",
      "chelsea-550-white-ceramic-vanity-basin-550w-x-836h-x-430d",
      "chelsea-650-white-ceramic-vanity-basin-650w-x-836h-x-446d",
      "chelsea-750-white-vanity-unit-with-ceramic-basin-755w-x-836h-x-485d",
      "chelsea-850-white-vanity-unit-with-ceramic-basin-855w-x-836h-x-485d",
      "chelsea-corner-mirror-cabinet-white-320w-x-650h-x-320d",
      "devon-400-floorstanding-white-ceramic-basin-400w-x-790h-x-220d-1",
      "devon-400-wall-hung-ceramic-vanity-basin-white-400w-x-450h-x-220d",
      "devon-450-floorstanding-white-ceramic-basin-450w-x-810h-x-310d",
      "devon-450-wall-hung-ceramic-vanity-basin-white-450w-x-585h-x-310d",
      "devon-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "devon-500-floorstanding-twin-drawers-white-anthracite-basin-510w-x-830h-x-395d-1",
      "devon-600-floorstanding-doors-white-ceramic-basin-610w-x-835h-x-395d",
      "devon-600-floorstanding-vanity-unit-with-ceramic-basin-white",
      "devon-600-floorstanding-white-drawers-ceramic-basin-610w-x-790h-x-395d",
      "devon-800-floorstanding-drawers-white-ceramic-basin-810w-x-825h-x-395d",
      "devon-freestanding-tallboy-storage-unit-white-350w-x-1700h-x-300d",
      "devon-harrow-vanity-worktop-white-finish",
      "dwelta-500-floorstanding-white-ceramic-basin-500w-x-850h-x-430d",
      "dwelta-600-floorstanding-white-ceramic-basin-600w-x-850h-x-450d",
      "dwelta-800-floorstanding-white-resin-basin-800w-x-850h-x-450d",
      "dwelta-wall-hung-tallboy-storage-white-400w-x-1500h-x-300d",
      "dwelta-white-bathroom-worktop-sleek-durable-vanity-countertop-surface",
      "harris-900mm-left-white-vanity-unit-with-resin-basin-storage-cabinet",
      "harrow-500-floorstanding-doors-white-ceramic-basin-510w-x-840h-x-395d",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d",
      "harrow-500-floorstanding-twin-drawers-white-ceramic-basin-510w-x-840h-x-390d-1",
      "harrow-600-floorstanding-doors-white-ceramic-basin-605w-x-815h-x-395d",
      "harrow-600-floorstanding-twin-drawer-white-ceramic-basin-610w-x-840h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d",
      "harrow-800-floorstanding-twin-drawer-white-ceramic-basin-800w-x-835h-x-395d-copy",
      "led-round-bathroom-mirror-600x600mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-bathroom-mirror-700x700mm-with-soft-glow-light-modern-vanity-mirror",
      "paris-600-floorstanding-white-bathroom-resin-basin-600w-x-825h-x-460d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-320w-x-1418h-x-360d",
      "paris-bathroom-wall-hung-cabinet-tallboy-white-nbsp-320w-x-1418h-x-360d",
      "pvc-vanity-600-floorstanding-twin-drawers-white-ceramic-basin-610w-x-840h-x-395d",
      "pvc-vanity-600-wall-hung-twin-drawers-white-ceramic-basin-610w-x-585h-x-395d",
      "pvc-vanity-waterproof-back-to-wall-wc-unit-white-500w-x-200h-x-800d",
      "slim-1000-floorstanding-white-cabinet-resin-basin-1000w-x-865h-x-305d"
    ]
  },
  {
    "handle": "baths",
    "title": "Baths",
    "parentCategory": "Baths & Panels",
    "productCount": 13,
    "description": "Shop baths at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2th-steel-enamel-bath-1-8mm-thick-2-tap-hole-twin-grip-handle-included-leg",
      "2th-steel-enamel-bath-1-8mm-thick-with-bath-legs-white-modern-tub",
      "2th-steel-enamel-bath-i-1-8mm-thick-2-tap-hole-no-handle-included-bath-leg",
      "l-shape-acrylic-bath-left-hand-with-pre-drilled-holes-bath-legs-850w-x-1700d",
      "l-shape-acrylic-bath-right-hand-with-pre-drilled-hole-bath-legs-850w-x-1700d",
      "modern-concealed-thermostatic-shower-set-with-rain-shower-handset-rectangular-bath-spout-chrome-finish",
      "premium-2th-steel-enamel-bath-2-3mm-thick-2-tap-hole-no-handle-included-leg",
      "premium-2th-steel-enamel-bath-with-anti-slip-base-twin-grip-handles-legs",
      "premium-steel-enamel-bath-i-2-3mm-thick-no-tap-hole-no-handle-included-legs",
      "round-acrylic-bath-with-pre-drilled-holes-included-bath-legs-700w-x-1700d",
      "square-acrylic-bath-700w-x-1700d-with-pre-drilled-holes-bath-legs",
      "steel-enamel-bath-i-1-8mm-thick-no-tap-holes-no-handle-included-bath-legs",
      "straight-bath-screen-with-towel-bar-adjustment-size-790-805-800-x-1400mm"
    ]
  },
  {
    "handle": "l-shape-baths",
    "title": "L Shape Baths",
    "parentCategory": "Baths & Panels",
    "productCount": 2,
    "description": "Shop l shape baths at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "l-shape-acrylic-bath-left-hand-with-pre-drilled-holes-bath-legs-850w-x-1700d",
      "l-shape-acrylic-bath-right-hand-with-pre-drilled-hole-bath-legs-850w-x-1700d"
    ]
  },
  {
    "handle": "acrylic-baths",
    "title": "Acrylic Baths",
    "parentCategory": "Baths & Panels",
    "productCount": 4,
    "description": "Shop acrylic baths at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "l-shape-acrylic-bath-left-hand-with-pre-drilled-holes-bath-legs-850w-x-1700d",
      "l-shape-acrylic-bath-right-hand-with-pre-drilled-hole-bath-legs-850w-x-1700d",
      "round-acrylic-bath-with-pre-drilled-holes-included-bath-legs-700w-x-1700d",
      "square-acrylic-bath-700w-x-1700d-with-pre-drilled-holes-bath-legs"
    ]
  },
  {
    "handle": "steel-enamel-baths",
    "title": "Steel Enamel Baths",
    "parentCategory": "Baths & Panels",
    "productCount": 7,
    "description": "Shop steel enamel baths at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2th-steel-enamel-bath-1-8mm-thick-2-tap-hole-twin-grip-handle-included-leg",
      "2th-steel-enamel-bath-1-8mm-thick-with-bath-legs-white-modern-tub",
      "2th-steel-enamel-bath-i-1-8mm-thick-2-tap-hole-no-handle-included-bath-leg",
      "premium-2th-steel-enamel-bath-2-3mm-thick-2-tap-hole-no-handle-included-leg",
      "premium-2th-steel-enamel-bath-with-anti-slip-base-twin-grip-handles-legs",
      "premium-steel-enamel-bath-i-2-3mm-thick-no-tap-hole-no-handle-included-legs",
      "steel-enamel-bath-i-1-8mm-thick-no-tap-holes-no-handle-included-bath-legs"
    ]
  },
  {
    "handle": "two-tap-hole-baths",
    "title": "2 Tap Hole Baths",
    "parentCategory": "Baths & Panels",
    "productCount": 3,
    "description": "Shop 2 tap hole baths at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2th-steel-enamel-bath-1-8mm-thick-2-tap-hole-twin-grip-handle-included-leg",
      "2th-steel-enamel-bath-i-1-8mm-thick-2-tap-hole-no-handle-included-bath-leg",
      "premium-2th-steel-enamel-bath-2-3mm-thick-2-tap-hole-no-handle-included-leg"
    ]
  },
  {
    "handle": "bath-panels",
    "title": "Bath Panels",
    "parentCategory": "Baths & Panels",
    "productCount": 13,
    "description": "Shop bath panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "4-folding-glass-panel-door-bath-shower-screen-4mm-thick",
      "4-folding-glass-panel-door-bath-shower-screen-matt-black-4mm-thick",
      "bath-panel-clips-with-screws-set-of-6-secure-fixing-kit",
      "bathroom-accessories-bath-panel-clips-x6-screws",
      "front-bath-panel-i-gloss-anthracite-15mm-thick-height-adjustable-up-to-550mm",
      "front-bath-panel-i-gloss-matt-grey-15mm-thick-height-adjustable-up-to-550mm",
      "front-bath-panel-i-gloss-white-15mm-thick-height-adjustable-up-to-550mm",
      "gloss-anthracite-end-bath-panel-15mm-durable-adjustable-height-up-to-550mm",
      "gloss-matt-grey-end-bath-panel-15mm-thick-height-adjustable-up-to-550mm",
      "gloss-white-end-bath-panel-15mm-thick-height-adjustable-up-to-550mm",
      "radius-edge-bath-screen-with-double-panel-amp-towel-bar-6mm-thick-1000-x-1400mm",
      "radius-edge-bath-screen-with-double-panel-towel-bar-6mm-thick-1000-x-1400mm",
      "square-edge-bath-screen-with-double-panel-towel-bar-6mm-thick-1000-x1400mm"
    ]
  },
  {
    "handle": "front-bath-panels",
    "title": "Front Bath Panels",
    "parentCategory": "Baths & Panels",
    "productCount": 3,
    "description": "Shop front bath panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "front-bath-panel-i-gloss-anthracite-15mm-thick-height-adjustable-up-to-550mm",
      "front-bath-panel-i-gloss-matt-grey-15mm-thick-height-adjustable-up-to-550mm",
      "front-bath-panel-i-gloss-white-15mm-thick-height-adjustable-up-to-550mm"
    ]
  },
  {
    "handle": "end-bath-panels",
    "title": "End Bath Panels",
    "parentCategory": "Baths & Panels",
    "productCount": 3,
    "description": "Shop end bath panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "gloss-anthracite-end-bath-panel-15mm-durable-adjustable-height-up-to-550mm",
      "gloss-matt-grey-end-bath-panel-15mm-thick-height-adjustable-up-to-550mm",
      "gloss-white-end-bath-panel-15mm-thick-height-adjustable-up-to-550mm"
    ]
  },
  {
    "handle": "bath-screens",
    "title": "Bath Screens",
    "parentCategory": "Baths & Panels",
    "productCount": 27,
    "description": "Shop bath screens at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "4-folding-glass-panel-door-bath-shower-screen-4mm-thick",
      "4-folding-glass-panel-door-bath-shower-screen-matt-black-4mm-thick",
      "5-folding-bath-screen-1200mm-4mm-thick-adjustment-size-1190-1205-1200-x-1400mm",
      "5-folding-bath-screen-matt-black-4mm-thick-adjustment-1190-1205-1200-x-1400mm",
      "bath-screen-door-rubber-seal-900mm-gap-10mm-suitable-for-6mm-screen",
      "bath-screen-door-rubber-seal-900mm-gap-14mm-suitable-for-6mm-screen",
      "bath-screen-door-rubber-seal-900mm-gap-14mm-suitable-for-6mm-screen-1",
      "bath-screen-door-seal-750mm-gap-6mm-suitable-for-6mm-screen",
      "bath-screen-door-seal-900mm-gap-10mm-suitable-for-6mm-screen",
      "bath-screen-door-seal-900mm-gap-18mm-suitable-for-6mm-screen",
      "bath-screen-door-seal-900mm-gap-25mm-suitable-for-6mm-screen",
      "bath-screen-door-seal-900mm-gap-5mm-suitable-for-6mm-screen",
      "bath-screen-door-seal-900mm-gap-7mm-suitable-for-6mm-screen",
      "bath-screen-door-seal-900mm-gap-8mm-suitable-for-6mm-screen",
      "grid-square-bath-screen-5mm-thick-adjustment-size-790-805-800-x-1400mm",
      "radius-edge-bath-screen-dark-grey-5mm-thick-adjustment-790-805-800-x-1400mm",
      "radius-edge-bath-screen-grey-5mm-thick-adjustment-size-790-805-800-x-1400mm",
      "radius-edge-bath-screen-matt-black-5mm-thick-adjustment-790-805-800-x-1400mm",
      "radius-edge-bath-screen-w-towel-bar-5mm-thick-adjustment-790-805-800x-1400mm",
      "radius-edge-bath-screen-with-double-panel-amp-towel-bar-6mm-thick-1000-x-1400mm",
      "radius-edge-bath-screen-with-double-panel-towel-bar-6mm-thick-1000-x-1400mm",
      "square-edge-bath-screen-adjustment-size-790-805-800-x-1400mm",
      "square-edge-bath-screen-dark-grey-adjustment-size-790-805-800-x-1400mm",
      "square-edge-bath-screen-grey-6mm-thick-adjustment-size-790-805-800-x-1400mm",
      "square-edge-bath-screen-matt-black-6mm-thick-adjustment-790-805-800-x-1400mm",
      "square-edge-bath-screen-with-double-panel-towel-bar-6mm-thick-1000-x1400mm",
      "straight-bath-screen-with-towel-bar-adjustment-size-790-805-800-x-1400mm"
    ]
  },
  {
    "handle": "bath-legs-and-supports",
    "title": "Bath Legs & Supports",
    "parentCategory": "Baths & Panels",
    "productCount": 15,
    "description": "Shop bath legs & supports at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2th-steel-enamel-bath-1-8mm-thick-2-tap-hole-twin-grip-handle-included-leg",
      "2th-steel-enamel-bath-1-8mm-thick-with-bath-legs-white-modern-tub",
      "2th-steel-enamel-bath-i-1-8mm-thick-2-tap-hole-no-handle-included-bath-leg",
      "bath-leg-for-bath17rnd-heavy-duty-steel-support",
      "bath-leg-for-steel-bath-heavy-duty-support-stability",
      "bath-legs-for-lbath-rh-lbath-lh-strong-steel-support",
      "l-shape-acrylic-bath-left-hand-with-pre-drilled-holes-bath-legs-850w-x-1700d",
      "l-shape-acrylic-bath-right-hand-with-pre-drilled-hole-bath-legs-850w-x-1700d",
      "premium-2th-steel-enamel-bath-2-3mm-thick-2-tap-hole-no-handle-included-leg",
      "premium-2th-steel-enamel-bath-with-anti-slip-base-twin-grip-handles-legs",
      "premium-steel-enamel-bath-i-2-3mm-thick-no-tap-hole-no-handle-included-legs",
      "round-acrylic-bath-with-pre-drilled-holes-included-bath-legs-700w-x-1700d",
      "square-acrylic-bath-700w-x-1700d-with-pre-drilled-holes-bath-legs",
      "steel-bath-handles-durable-safety-support-for-baths",
      "steel-enamel-bath-i-1-8mm-thick-no-tap-holes-no-handle-included-bath-legs"
    ]
  },
  {
    "handle": "bath-handles",
    "title": "Bath Handles",
    "parentCategory": "Baths & Panels",
    "productCount": 15,
    "description": "Shop bath handles at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2th-steel-enamel-bath-1-8mm-thick-2-tap-hole-twin-grip-handle-included-leg",
      "2th-steel-enamel-bath-i-1-8mm-thick-2-tap-hole-no-handle-included-bath-leg",
      "classic-bath-filler-matt-black-traditional-dual-handle-bathtub-mixer-tap",
      "classic-bath-filler-tap-traditional-dual-handle-bathtub-mixer-for-elegant-bathrooms",
      "crystal-bath-filler-traditional-dual-handle-bathtub-mixer-tap",
      "deluxe-bath-filler-luxury-dual-handle-bathtub-mixer-tap-for-elegant-bathrooms",
      "deluxe-bath-filler-matt-black-premium-dual-handle-bathtub-mixer-tap",
      "devon-bathroom-bath-shower-mixer-waterfall-style-chrome-twin-handle-tap",
      "elite-chrome-dual-handle-bath-filler-tap-modern-deck-mounted-mixer",
      "oxford-deck-mounted-bath-filler-tap-dual-handle-chrome-waterfall-spout",
      "premium-2th-steel-enamel-bath-2-3mm-thick-2-tap-hole-no-handle-included-leg",
      "premium-steel-enamel-bath-i-2-3mm-thick-no-tap-hole-no-handle-included-legs",
      "steel-bath-handles-durable-safety-support-for-baths",
      "steel-enamel-bath-i-1-8mm-thick-no-tap-holes-no-handle-included-bath-legs",
      "titan-bath-filler-mixer-tap-dual-handle-chrome-finish-bathroom-faucet"
    ]
  },
  {
    "handle": "showers",
    "title": "Showers",
    "parentCategory": "Showers",
    "productCount": 280,
    "description": "Shop showers at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "1200mm-support-bar-straight-round-wetroom-shower-enclosure",
      "1900mm-chrome-profile-extension-up-to-20mm-wall-adjustment-kit-shower-enclosures",
      "2-outlet-concealed-shower-valve-with-round-handles-and-diverter",
      "4-folding-glass-panel-door-bath-shower-screen-4mm-thick",
      "4-folding-glass-panel-door-bath-shower-screen-matt-black-4mm-thick",
      "700mm-support-bar-straight-round-wetroom-shower-enclosure",
      "90mm-black-top-fast-flow-shower-tray-waste",
      "90mm-brushed-brass-top-fast-flow-shower-tray-waste",
      "90mm-chrome-top-fast-flow-shower-tray-waste",
      "a-pair-of-universal-rounded-chrome-160-mm-shower-door-handles",
      "adjustable-leg-set-for-1000-1200mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-1000mm-square-rectangular-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays-1",
      "adjustable-leg-set-for-700-900mm-square-rectangular-shower-trays-black-chrome-finish",
      "adjustable-shower-tray-leg-set-for-1300-1800mm-rectangular-walk-in-trays",
      "adjustable-support-bar-970-660mm-straight-square-wetroom-shower-enclosure",
      "angled-180-magnetic-shower-seal-8mm-to-8mm-glass-2000mm-length",
      "aqua-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "aqua-freestanding-bath-shower-mixer-modern-chrome-finish-with-handset-hose",
      "arezzo-round-triple-concealed-thermostatic-shower-valve-with-diverter-matt-black",
      "arezzo-square-modern-twin-concealed-shower-valve-with-diverter-brushed-brass",
      "bathroom-fort-round-rigid-riser-shower-kit-brushed-brass-finish",
      "bathroom-fort-round-rigid-riser-shower-kit-matt-black-finish",
      "bathroom-fort-round-rigid-riser-shower-kit-modern-chrome-finish",
      "bathroom-fort-round-rigid-riser-shower-kit-with-bath-filler-modern-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-brushed-brass-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-matt-black-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-matt-black-finish-1",
      "bathroom-fort-square-rigid-riser-shower-kit-modern-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-with-bath-filler-chrome-finish",
      "bathroom-fort-thermostatic-round-shower-mixer-slider-rail-kit-brushed-brass",
      "bathroom-fort-thermostatic-round-shower-mixer-valve-slider-rail-kit-chrome",
      "bathroom-fort-thermostatic-round-shower-mixer-valve-slider-rail-kit-matt-black",
      "better-bathrooms-cube-freestanding-bath-shower-mixer-15032-spare-parts",
      "biava-wall-mounted-thermostatic-bath-shower-mixer-bsm-tap",
      "black-triple-handle-2-outlet-concealed-valve",
      "breeze-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "bristol-bath-shower-mixer-chrome-with-shower-kit-wall-bracket",
      "bristol-traditional-freestanding-bath-shower-mixer-tap-with-handheld-shower-chrome",
      "brushed-brass-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "brushed-brass-square-wall-mounted-shower-arm-modern-bathroom-fitting",
      "brushed-brass-wall-mounted-shower-arm-with-flange-l-shaped-extension-pipe",
      "brushed-nickel-wall-mounted-shower-arm-380mm-with-flange-modern-bathroom-fixture",
      "cambridge-chrome-single-outlet-concealed-shower-valve",
      "cascade-bath-shower-mixer-brushed-brass-with-shower-kit-wall-bracket-luxury-tap",
      "cascade-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-tap",
      "cascade-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "chrome-bathroom-basin-mixer-tap-bath-shower-mixer-tap-waste",
      "chrome-ceiling-shower-arm-12-inch-extension-pipe-with-flange",
      "chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange-1",
      "chrome-wall-mounted-shower-arm-l-shaped-extension-pipe-with-flange",
      "classic-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "classic-bath-shower-mixer-tap-with-shower-kit-wall-bracket-traditional-bathtub-tap",
      "classsic-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "clear-135-magnetic-shower-enclosure-seal-10mm-glass-2000mm-length",
      "clear-135-magnetic-shower-enclosure-seal-6mm-glass-2000mm-length",
      "clear-135-magnetic-shower-enclosure-seal-8mm-x-2000mm",
      "clear-180-magnetic-shower-enclosure-seal-10mm-glass-2000mm-length",
      "clear-180-magnetic-shower-enclosure-seal-6mm-glass-2000mm-length",
      "concealed-shower-valve-trimset-1-outlet-brushed-gunmetal",
      "concealed-thermo-mixer-valve-square-taurus-double-outlet-2-knob",
      "cross-traditional-bathroom-shower-thermostatic-exposed-shower-valve",
      "crystal-bath-shower-mixer-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "deluxe-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "deluxe-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-luxury-tap",
      "deluxe-bath-shower-mixer-with-shower-kit-wall-bracket-luxury-bathtub-tap",
      "descent-chrome-bath-shower-mixer-with-shower-kit",
      "devon-bathroom-bath-shower-mixer-waterfall-style-chrome-twin-handle-tap",
      "dual-concealed-thermostatic-shower-valve-matt-black",
      "easy-plumb-kit-for-1100-1200mm-rectangular-trays-slate-grey-leg3s",
      "eden-freestanding-bath-shower-mixer-chrome",
      "eden-freestanding-bath-shower-mixer-tap-with-handset-brushed-brass",
      "eden-freestanding-bath-shower-mixer-with-hand-shower-matt-black",
      "elite-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "ellena-chrome-bathroom-taps-basin-mixer-bath-filler-shower-tap-wide-waterfall",
      "emso-round-exposed-thermostatic-shower-valve-with-bottom-outlet",
      "essence-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "essence-bath-shower-mixer-shower-kit-wall-bracket-included",
      "exposed-thermostatic-shower-system-chrome-rainfall-shower-with-handheld",
      "exposed-thermostatic-shower-system-chrome-wall-mounted-rainfall-shower-set",
      "fairford-carton-deck-mounted-thermostic-bath-shower-mixer",
      "freestanding-bath-shower-mixer-tap-matt-black-modern-waterfall-design",
      "freestanding-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "gold-exposed-thermostatic-shower-system-rainfall-shower-with-handheld",
      "heavy-duty-leg-set-for-1000mm-square-rectangular-shower-trays-chrome-black-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish-1",
      "hudson-reed-leg-set-suitable-for-1300-1800-rectangular-walk-in-trays-slate-grey",
      "imperial-bath-shower-mixer-shower-kit-wall-bracket-included",
      "leda-concealed-3-way-thermostatic-shower-valve-chrome",
      "leg-set-for-1000-1200-quad-offset-trays-durable-easy-installation",
      "libra-thermostatic-wall-mounted-modern-chrome-bath-shower-mixer-tap",
      "luxury-concealed-thermostatic-shower-set-with-overhead-rain-shower-handheld-kit-chrome-finish",
      "luxury-concealed-thermostatic-shower-system-with-rain-shower-handset-6-body-jets-chrome-finish",
      "lyra-thermostatic-shower-valve-with-handset-two-outlet",
      "marina-6-bi-fold-shower-door-6mm-clear-glass-with-brushed-brass-frame",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-brushed-brass",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-chrome",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-matt-black",
      "marina-6-quadrant-6mm-clear-glass-brushed-brass",
      "marina-6-quadrant-6mm-clear-glass-chrome",
      "marina-6-quadrant-corner-shower-6mm-clear-glass-matt-black",
      "marina-6-quadrant-quadrant-corner-shower-6mm-clear-glass-brushed-brass",
      "marina-6-quadrant-quadrant-corner-shower-6mm-clear-glass-chrome",
      "marina-6-quadrant-shower-enclosure-6mm-clear-glass-with-matt-black-frame",
      "marina-6-shower-slider-door-6mm-clear-glass-brushed-brass",
      "marina-6-shower-slider-door-6mm-clear-glass-matt-black",
      "marina-6-slider-shower-door-6mm-clear-tempered-glass-chrome-frame-bathroom",
      "marina-8-frameless-quadrant-door-8mm-clear-glass-chrome",
      "marina-8-wet-room-8mm-clear-glass-shower-enclosure-with-brushed-brass-frame",
      "marina-8-wet-room-shower-screen-8mm-black-grid",
      "matt-black-round-rigid-riser-shower-kit-with-thermostatic-control-middleton",
      "matte-black-round-thermostatic-shower-bar-valve-with-single-outlet",
      "matte-black-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "matte-black-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "matte-black-wall-mounted-shower-arm-l-shaped-extension-pipe-with-flange",
      "mini-bar-valve-fixing-kit-plate-brushed-brass-shower-bar-valve-support",
      "mini-bar-valve-fixing-kit-plate-brushed-brass-shower-bar-valve-support-1",
      "mini-bar-valve-fixing-kit-plate-matt-black-shower-bar-valve-support",
      "mini-bar-valve-fixing-kit-plate-secure-shower-bar-valve-installation",
      "mini-thermostatic-shower-mixing-valve-temperature-control-faucet-valve",
      "mizu-1500-shower-mixer-cover-plate-chrome",
      "mode-harrison-square-twin-thermostatic-shower-valve-chrome-shower-valve-square-shower-valves-showers",
      "modern-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "modern-concealed-thermostatic-shower-set-with-rain-shower-handset-rectangular-bath-spout-chrome-finish",
      "nes-home-kento-chrome-square-bath-shower-mixer-tap-with-handheld",
      "noble-5-hole-deck-mounted-bath-shower-mixer-waterfall-spout-with-hand-shower-kit-wall-bracket",
      "nuie-reef-thermostatic-bath-shower-mixer-modern-wall-mounted-faucet",
      "nuie-shower-tray-leg-set-plinth-for-square-rectangle-shower-trays-700-900mm",
      "oxford-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "polished-chrome-ceiling-shower-arm-12-inch-extension-pipe-with-flange",
      "polished-chrome-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "premium-leg-set-for-1100-1200mm-rectangular-shower-trays-adjustable-chrome-black-kit",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-modern-chrome-finish-without-hand-shower",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-with-hand-shower-modern-chrome-finish",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-matt-black-tap-set-with-handheld-shower",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-hand-shower",
      "prestige-bath-shower-mixer-matt-black-tap-with-shower-kit-wall-bracket",
      "prestige-bath-shower-mixer-with-kit-brushed-brass",
      "prestige-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "prestige-freestanding-bath-shower-mixer-matte-black-finish",
      "prestige-freestanding-bath-shower-mixer-modern-brushed-brass-faucet",
      "prestige-freestanding-bath-shower-mixer-modern-floor-mounted-tap-with-handset",
      "pure-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "pure-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "quadro-thermostatic-valve-with-3-4-ceramic-disc-volume-control-matt-black",
      "qubec-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "radius-edge-bath-screen-with-double-panel-amp-towel-bar-6mm-thick-1000-x-1400mm",
      "rectangular-acrylic-shower-base-with-corner-drain-low-profile-slip-resistant-easy-clean",
      "rectangular-brass-shower-handset-modern-bathroom-handheld-shower-fixture",
      "round-2-outlet-3-handle-thermostatic-concealed-shower-valve",
      "round-abs-shower-handset-lightweight-modern-bathroom-handheld-shower",
      "round-abs-ultra-slim-shower-head-200mm-modern-lightweight-bathroom-design",
      "round-adjustable-shower-handset-wall-bracket-modern-bathroom-fixture",
      "round-adjustable-shower-handset-wall-bracket-modern-bathroom-fixture-1",
      "round-brass-shower-handset-modern-bathroom-handheld-shower-fixture",
      "round-brass-ultra-slim-shower-head-200mm-elegant-bathroom-rainfall-design",
      "round-brass-ultra-slim-shower-head-250mm-elegant-bathroom-rainfall-design",
      "round-ceiling-shower-arm-brushed-brass-120mm",
      "round-ceiling-shower-arm-matte-black-120mm",
      "round-ceiling-shower-arm-stainless-steel-120mm",
      "round-exposed-shower-riser-rail-kit-chrome-finish",
      "round-exposed-shower-riser-rail-kit-matt-black-adjustable",
      "round-shower-door-handle-pair-matt-black-finish",
      "round-shower-handset-wall-bracket-with-wall-outlet-modern-bathroom-fixture",
      "round-shower-handset-with-hose-wall-outlet-brushed-brass-modern-bathroom-set",
      "round-shower-handset-with-hose-wall-outlet-matt-black-modern-bathroom-set",
      "round-shower-handset-with-hose-wall-outlet-modern-bathroom-set",
      "round-shower-outlet-elbow-matte-black-wall-mounted-connector",
      "round-slider-rail-kit-matt-black-finish-modern-adjustable-shower-rail",
      "round-slider-rail-kit-sleek-design-easy-adjustment",
      "round-triple-outlet-3-handle-thermostatic-concealed-shower-valve",
      "round-ultra-slim-rainfall-shower-head-200mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-200mm-stainless-steel",
      "round-ultra-slim-rainfall-shower-head-250mm-brushed-brass",
      "round-ultra-slim-rainfall-shower-head-250mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-250mm-stainless-steel",
      "round-ultra-slim-rainfall-shower-head-300mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-300mm-stainless-steel",
      "round-ultra-slim-shower-head-200mm-chrome-modern-bathroom-fitting",
      "serena-round-rigid-riser-shower-in-chrome-finish-modern-design-for-stylish-bathrooms",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays-1",
      "shower-tray-leg-set-suitable-for-1000mm-square-rectangular-tray",
      "shower-tray-leg-set-suitable-for-1100-1200mm-quadrant-offset-trays-black",
      "shower-tray-leg-set-suitable-for-1100-1200mm-rectangular-trays-black",
      "shower-tray-leg-set-suitable-for-1300-1800mm-rectangular-walk-in-tray",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays-black",
      "single-outlet-thermostatic-mixer-with-300mm-arm-200mm-ultra-slim-shower",
      "single-outlet-thermostatic-mixer-with-300mm-square-arm-200mm-square-head",
      "sleek-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "sleek-matt-black-bath-shower-mixer-tap-with-shower-kit-wall-bracket",
      "slim-line-quadrant-shower-tray-gloss-white",
      "slim-line-quadrant-shower-tray-slate-grey",
      "slip-resistant-offset-quad-shower-tray-lh-gloss-white",
      "slip-resistant-offset-quad-shower-tray-lh-gloss-white-1",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white-1",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white-2",
      "slip-resistant-rectangular-shower-tray-gloss-white",
      "slip-resistant-rectangular-shower-tray-gloss-white-1",
      "slip-resistant-rectangular-shower-tray-slate-grey",
      "slip-resistant-rectangular-shower-tray-slate-grey-1",
      "slip-resistant-square-bathroom-shower-tray-slate-grey",
      "smooth-pvc-shower-hose-1-5m-brushed-brass-flexible-anti-kink-hose",
      "smooth-pvc-shower-hose-1-5m-flexible-anti-kink-bathroom-hose",
      "smooth-pvc-shower-hose-1-5m-matt-black-flexible-anti-kink-hose",
      "square-abs-shower-handset-lightweight-modern-bathroom-handheld-shower",
      "square-abs-shower-handset-lightweight-modern-bathroom-handheld-shower-1",
      "square-abs-shower-head-200mm-modern-bathroom-rainfall-shower-easy-install",
      "square-adjustable-shower-handset-wall-bracket-modern-bathroom-fixture",
      "square-brass-shower-head-200mm-modern-bathroom-rainfall-fitting-easy-install",
      "square-brass-ultra-slim-shower-head-250mm-elegant-bathroom-rainfall-design",
      "square-chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "square-exposed-riser-rail-kit-chrome-finish",
      "square-exposed-riser-rail-kit-matt-black-finish",
      "square-matte-black-thermostatic-shower-bar-valve-with-single-outlet",
      "square-shower-handset-wall-bracket-with-wall-outlet-modern-bathroom-fixture",
      "square-shower-handset-wall-bracket-with-wall-outlet-modern-bathroom-fixture-1",
      "square-shower-handset-wall-bracket-with-wall-outlet-modern-bathroom-fixture-2",
      "square-shower-handset-with-hose-wall-outlet-brushed-brass-modern-bathroom-set",
      "square-shower-handset-with-hose-wall-outlet-matt-black-modern-bathroom-set",
      "square-shower-handset-with-hose-wall-outlet-modern-bathroom-set",
      "square-shower-outlet-elbow-chrome-wall-mounted-hand-shower-connector",
      "square-slider-rail-kit-chrome-finish-adjustable-wall-mounted-shower-rail",
      "square-slider-rail-kit-matt-black-finish-adjustable-wall-mounted-shower-rail",
      "square-ultra-slim-rainfall-shower-head-200mm-matt-black",
      "square-ultra-slim-rainfall-shower-head-200mm-stainless-steel",
      "square-ultra-slim-rainfall-shower-head-250mm-brushed-brass",
      "square-ultra-slim-rainfall-shower-head-250mm-matt-black",
      "square-ultra-slim-rainfall-shower-head-250mm-stainless-steel",
      "square-ultra-slim-rainfall-shower-head-300mm-stainless-steel",
      "square-wall-mounted-shower-arm-polished-chrome-finish",
      "square-wall-mounted-shower-outlet-elbow-matte-black-brass-connector",
      "stainless-steel-shower-hose-1-2m-flexible-anti-kink-bathroom-hose",
      "stainless-steel-shower-hose-1-2m-matt-black-flexible-anti-kink-hose",
      "stainless-steel-shower-hose-1-5m-flexible-anti-kink-bathroom-hose",
      "stainless-steel-shower-hose-1-5m-large-bore-flexible-anti-kink-hose",
      "stainless-steel-shower-hose-2m-extra-long-flexible-anti-kink-hose",
      "the-pantiles-dual-control-wall-mounted-exposed-thermostatic-shower-mixer-chrome-white",
      "thermostatic-round-shower-mixer-valve-with-multi-function-handset-chrome",
      "thermostatic-round-shower-mixer-valve-with-slider-rail-kit-modern-chrome-finish",
      "thermostatic-shower-mixer-valve-wall-mounted-chrome-bathroom-faucet",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-brushed-brass-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-chrome-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-matt-black-finish",
      "titan-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "traditional-3-dial-2-way-concealed-thermostatic-shower-valve-brass-chrome",
      "traditional-brass-slider-rail-kit-vintage-elegance-lasting-quality",
      "traditional-round-shower-head-200mm-classic-bathroom-rainfall-design",
      "triple-outlet-thermostatic-mixer-with-round-arm-slim-head-hose-6-body-jets",
      "triple-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-accessories",
      "triple-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-bath-spout",
      "triple-round-handle-2-oulet-concealed-valve-brushed-brass",
      "triple-round-handle-3-oulet-concealed-valve-matt-black",
      "triple-square-handle-2-oulet-concealed-valve-brushed-brass",
      "triple-square-handle-2-outlet-concealed-valve-matt-black",
      "triple-square-handle-3-oulet-concealed-valve",
      "triple-square-handle-3-oulet-concealed-valve-brushed-brass",
      "twin-round-handle-1-outlet-concealed-valve-brushed-brass",
      "twin-round-handle-2-outlet-concealed-valve-brushed-brass",
      "twin-square-handle-2-outlet-concealed-valve-brushed-brass",
      "twin-square-handle-2-outlet-concealed-valve-matt-black",
      "two-outlet-thermostatic-mixer-with-300mm-round-arm-slim-head-hand-shower",
      "two-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-hand-shower",
      "universal-wall-mounted-concealed-thermostati-shower-mixer-3-outlets-3-handles",
      "vista-bath-shower-mixer-tap-with-shower-kit-chrome-finish",
      "walk-in-shower-tray-rectangle-slimline-gloss-white",
      "walk-in-shower-tray-rectangle-slimline-slate-grey",
      "york-freestanding-traditional-bath-shower-mixer-tap-with-handset-chrome",
      "york-traditional-bath-shower-mixer-tap-with-shower-kit-wall-bracket-chrome",
      "zenith-bath-shower-mixer-tap-matt-black-with-shower-kit-bracket",
      "zenith-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "zenith-freestanding-bath-shower-mixer-tap-with-handset-chrome-finish",
      "zenith-wall-mounted-basin-shower-mixer-tap-with-waterfall-spout-shower-kit",
      "zenith-wall-mounted-bath-shower-mixer-tap-with-kit-wall-bracket-chrome"
    ]
  },
  {
    "handle": "concealed-showers",
    "title": "Concealed Showers",
    "parentCategory": "Showers",
    "productCount": 30,
    "description": "Shop concealed showers at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-outlet-concealed-shower-valve-with-round-handles-and-diverter",
      "arezzo-round-triple-concealed-thermostatic-shower-valve-with-diverter-matt-black",
      "arezzo-square-modern-twin-concealed-shower-valve-with-diverter-brushed-brass",
      "black-triple-handle-2-outlet-concealed-valve",
      "cambridge-chrome-single-outlet-concealed-shower-valve",
      "concealed-shower-valve-trimset-1-outlet-brushed-gunmetal",
      "concealed-thermo-mixer-valve-square-taurus-double-outlet-2-knob",
      "dual-concealed-thermostatic-shower-valve-matt-black",
      "leda-concealed-3-way-thermostatic-shower-valve-chrome",
      "luxury-concealed-thermostatic-shower-set-with-overhead-rain-shower-handheld-kit-chrome-finish",
      "luxury-concealed-thermostatic-shower-system-with-rain-shower-handset-6-body-jets-chrome-finish",
      "lyra-thermostatic-shower-valve-with-handset-two-outlet",
      "modern-concealed-thermostatic-shower-set-with-rain-shower-handset-rectangular-bath-spout-chrome-finish",
      "quadro-thermostatic-valve-with-3-4-ceramic-disc-volume-control-matt-black",
      "round-2-outlet-3-handle-thermostatic-concealed-shower-valve",
      "round-triple-outlet-3-handle-thermostatic-concealed-shower-valve",
      "single-outlet-thermostatic-mixer-with-300mm-arm-200mm-ultra-slim-shower",
      "traditional-3-dial-2-way-concealed-thermostatic-shower-valve-brass-chrome",
      "triple-round-handle-2-oulet-concealed-valve-brushed-brass",
      "triple-round-handle-3-oulet-concealed-valve-matt-black",
      "triple-square-handle-2-oulet-concealed-valve-brushed-brass",
      "triple-square-handle-2-outlet-concealed-valve-matt-black",
      "triple-square-handle-3-oulet-concealed-valve",
      "triple-square-handle-3-oulet-concealed-valve-brushed-brass",
      "twin-round-handle-1-outlet-concealed-valve-brushed-brass",
      "twin-round-handle-2-outlet-concealed-valve-brushed-brass",
      "twin-square-handle-2-outlet-concealed-valve-brushed-brass",
      "twin-square-handle-2-outlet-concealed-valve-matt-black",
      "two-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-hand-shower",
      "universal-wall-mounted-concealed-thermostati-shower-mixer-3-outlets-3-handles"
    ]
  },
  {
    "handle": "exposed-showers",
    "title": "Exposed Showers",
    "parentCategory": "Showers",
    "productCount": 10,
    "description": "Shop exposed showers at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "cross-traditional-bathroom-shower-thermostatic-exposed-shower-valve",
      "emso-round-exposed-thermostatic-shower-valve-with-bottom-outlet",
      "exposed-thermostatic-shower-system-chrome-rainfall-shower-with-handheld",
      "exposed-thermostatic-shower-system-chrome-wall-mounted-rainfall-shower-set",
      "gold-exposed-thermostatic-shower-system-rainfall-shower-with-handheld",
      "round-exposed-shower-riser-rail-kit-chrome-finish",
      "round-exposed-shower-riser-rail-kit-matt-black-adjustable",
      "square-exposed-riser-rail-kit-chrome-finish",
      "square-exposed-riser-rail-kit-matt-black-finish",
      "the-pantiles-dual-control-wall-mounted-exposed-thermostatic-shower-mixer-chrome-white"
    ]
  },
  {
    "handle": "thermostatic-showers",
    "title": "Thermostatic Showers",
    "parentCategory": "Showers",
    "productCount": 41,
    "description": "Shop thermostatic showers at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "arezzo-round-triple-concealed-thermostatic-shower-valve-with-diverter-matt-black",
      "bathroom-fort-thermostatic-round-shower-mixer-slider-rail-kit-brushed-brass",
      "bathroom-fort-thermostatic-round-shower-mixer-valve-slider-rail-kit-chrome",
      "bathroom-fort-thermostatic-round-shower-mixer-valve-slider-rail-kit-matt-black",
      "biava-wall-mounted-thermostatic-bath-shower-mixer-bsm-tap",
      "cross-traditional-bathroom-shower-thermostatic-exposed-shower-valve",
      "dual-concealed-thermostatic-shower-valve-matt-black",
      "emso-round-exposed-thermostatic-shower-valve-with-bottom-outlet",
      "exposed-thermostatic-shower-system-chrome-rainfall-shower-with-handheld",
      "exposed-thermostatic-shower-system-chrome-wall-mounted-rainfall-shower-set",
      "gold-exposed-thermostatic-shower-system-rainfall-shower-with-handheld",
      "leda-concealed-3-way-thermostatic-shower-valve-chrome",
      "libra-thermostatic-wall-mounted-modern-chrome-bath-shower-mixer-tap",
      "luxury-concealed-thermostatic-shower-set-with-overhead-rain-shower-handheld-kit-chrome-finish",
      "luxury-concealed-thermostatic-shower-system-with-rain-shower-handset-6-body-jets-chrome-finish",
      "lyra-thermostatic-shower-valve-with-handset-two-outlet",
      "matt-black-round-rigid-riser-shower-kit-with-thermostatic-control-middleton",
      "matte-black-round-thermostatic-shower-bar-valve-with-single-outlet",
      "mini-thermostatic-shower-mixing-valve-temperature-control-faucet-valve",
      "mode-harrison-square-twin-thermostatic-shower-valve-chrome-shower-valve-square-shower-valves-showers",
      "modern-concealed-thermostatic-shower-set-with-rain-shower-handset-rectangular-bath-spout-chrome-finish",
      "nuie-reef-thermostatic-bath-shower-mixer-modern-wall-mounted-faucet",
      "quadro-thermostatic-valve-with-3-4-ceramic-disc-volume-control-matt-black",
      "round-2-outlet-3-handle-thermostatic-concealed-shower-valve",
      "round-triple-outlet-3-handle-thermostatic-concealed-shower-valve",
      "single-outlet-thermostatic-mixer-with-300mm-arm-200mm-ultra-slim-shower",
      "single-outlet-thermostatic-mixer-with-300mm-square-arm-200mm-square-head",
      "square-matte-black-thermostatic-shower-bar-valve-with-single-outlet",
      "the-pantiles-dual-control-wall-mounted-exposed-thermostatic-shower-mixer-chrome-white",
      "thermostatic-round-shower-mixer-valve-with-multi-function-handset-chrome",
      "thermostatic-round-shower-mixer-valve-with-slider-rail-kit-modern-chrome-finish",
      "thermostatic-shower-mixer-valve-wall-mounted-chrome-bathroom-faucet",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-brushed-brass-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-chrome-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-matt-black-finish",
      "traditional-3-dial-2-way-concealed-thermostatic-shower-valve-brass-chrome",
      "triple-outlet-thermostatic-mixer-with-round-arm-slim-head-hose-6-body-jets",
      "triple-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-accessories",
      "triple-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-bath-spout",
      "two-outlet-thermostatic-mixer-with-300mm-round-arm-slim-head-hand-shower",
      "two-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-hand-shower"
    ]
  },
  {
    "handle": "shower-valves",
    "title": "Shower Valves",
    "parentCategory": "Showers",
    "productCount": 50,
    "description": "Shop shower valves at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-outlet-concealed-shower-valve-with-round-handles-and-diverter",
      "arezzo-round-triple-concealed-thermostatic-shower-valve-with-diverter-matt-black",
      "arezzo-square-modern-twin-concealed-shower-valve-with-diverter-brushed-brass",
      "bar-valve-fixing-plate-durable-bathroom-mounting-hardware-stainless-steel-brass",
      "bathroom-fort-thermostatic-round-shower-mixer-valve-slider-rail-kit-chrome",
      "bathroom-fort-thermostatic-round-shower-mixer-valve-slider-rail-kit-matt-black",
      "biava-wall-mounted-thermostatic-bath-shower-mixer-bsm-tap",
      "black-triple-handle-2-outlet-concealed-valve",
      "cambridge-chrome-single-outlet-concealed-shower-valve",
      "concealed-shower-valve-trimset-1-outlet-brushed-gunmetal",
      "concealed-thermo-mixer-valve-square-taurus-double-outlet-2-knob",
      "cross-traditional-bathroom-shower-thermostatic-exposed-shower-valve",
      "dual-concealed-thermostatic-shower-valve-matt-black",
      "emso-round-exposed-thermostatic-shower-valve-with-bottom-outlet",
      "fairford-carton-deck-mounted-thermostic-bath-shower-mixer",
      "leda-concealed-3-way-thermostatic-shower-valve-chrome",
      "lyra-thermostatic-shower-valve-with-handset-two-outlet",
      "matte-black-round-thermostatic-shower-bar-valve-with-single-outlet",
      "mini-bar-valve-fixing-kit-plate-brushed-brass-shower-bar-valve-support",
      "mini-bar-valve-fixing-kit-plate-brushed-brass-shower-bar-valve-support-1",
      "mini-bar-valve-fixing-kit-plate-matt-black-shower-bar-valve-support",
      "mini-bar-valve-fixing-kit-plate-secure-shower-bar-valve-installation",
      "mini-thermostatic-shower-mixing-valve-temperature-control-faucet-valve",
      "mode-harrison-square-twin-thermostatic-shower-valve-chrome-shower-valve-square-shower-valves-showers",
      "modern-chrome-vema-round-single-outlet-thermostatic-bar-valve-wall-mounted-bathroom-faucet",
      "quadro-thermostatic-valve-with-3-4-ceramic-disc-volume-control-matt-black",
      "rex-chrome-exposed-thermostatic-bar-mixer-valve-modern-wall-mounted-faucet",
      "round-2-outlet-3-handle-thermostatic-concealed-shower-valve",
      "round-triple-outlet-3-handle-thermostatic-concealed-shower-valve",
      "square-matte-black-thermostatic-shower-bar-valve-with-single-outlet",
      "square-thermostatic-bar-valve-single-outlet-modern-wall-mounted-faucet",
      "thermostatic-round-shower-mixer-valve-with-multi-function-handset-chrome",
      "thermostatic-round-shower-mixer-valve-with-slider-rail-kit-modern-chrome-finish",
      "thermostatic-shower-mixer-valve-wall-mounted-chrome-bathroom-faucet",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-brushed-brass-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-chrome-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-matt-black-finish",
      "traditional-3-dial-2-way-concealed-thermostatic-shower-valve-brass-chrome",
      "triple-round-handle-2-oulet-concealed-valve-brushed-brass",
      "triple-round-handle-3-oulet-concealed-valve-matt-black",
      "triple-square-handle-2-oulet-concealed-valve-brushed-brass",
      "triple-square-handle-2-outlet-concealed-valve-matt-black",
      "triple-square-handle-3-oulet-concealed-valve",
      "triple-square-handle-3-oulet-concealed-valve-brushed-brass",
      "twin-round-handle-1-outlet-concealed-valve-brushed-brass",
      "twin-round-handle-2-outlet-concealed-valve-brushed-brass",
      "twin-square-handle-2-outlet-concealed-valve-brushed-brass",
      "twin-square-handle-2-outlet-concealed-valve-matt-black",
      "two-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-hand-shower",
      "universal-wall-mounted-concealed-thermostati-shower-mixer-3-outlets-3-handles"
    ]
  },
  {
    "handle": "concealed-shower-valves",
    "title": "Concealed Shower Valves",
    "parentCategory": "Showers",
    "productCount": 32,
    "description": "Shop concealed shower valves at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-outlet-concealed-shower-valve-with-round-handles-and-diverter",
      "arezzo-round-triple-concealed-thermostatic-shower-valve-with-diverter-matt-black",
      "arezzo-square-modern-twin-concealed-shower-valve-with-diverter-brushed-brass",
      "black-triple-handle-2-outlet-concealed-valve",
      "cambridge-chrome-single-outlet-concealed-shower-valve",
      "concealed-shower-valve-trimset-1-outlet-brushed-gunmetal",
      "concealed-thermo-mixer-valve-round-taurus-single-outlet-2-knob-1-way-diverter-round-plate",
      "concealed-thermo-mixer-valve-square-taurus-double-outlet-2-knob",
      "dual-concealed-thermostatic-shower-valve-matt-black",
      "gio-basin-sink-mixer-tap-wall-mounted-concealed-valve-hot-and-cold-mixer-and-w",
      "leda-concealed-3-way-thermostatic-shower-valve-chrome",
      "lyra-thermostatic-shower-valve-with-handset-two-outlet",
      "quadro-thermostatic-valve-with-3-4-ceramic-disc-volume-control-matt-black",
      "round-2-outlet-3-handle-thermostatic-concealed-shower-valve",
      "round-triple-outlet-3-handle-thermostatic-concealed-shower-valve",
      "traditional-3-dial-2-way-concealed-thermostatic-shower-valve-brass-chrome",
      "triple-round-handle-2-oulet-concealed-valve-brushed-brass",
      "triple-round-handle-3-oulet-concealed-valve-matt-black",
      "triple-square-handle-2-oulet-concealed-valve-brushed-brass",
      "triple-square-handle-2-outlet-concealed-valve-matt-black",
      "triple-square-handle-3-oulet-concealed-valve",
      "triple-square-handle-3-oulet-concealed-valve-brushed-brass",
      "twin-round-handle-1-outlet-concealed-valve-brushed-brass",
      "twin-round-handle-2-outlet-concealed-valve-brushed-brass",
      "twin-square-handle-2-outlet-concealed-valve",
      "twin-square-handle-2-outlet-concealed-valve-brushed-brass",
      "twin-square-handle-2-outlet-concealed-valve-matt-black",
      "two-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-hand-shower",
      "universal-wall-mounted-concealed-thermostati-shower-mixer-3-outlets-3-handles",
      "wall-mounted-concealed-mixer-valve-chrome-single-lever-control",
      "wall-mounted-concealed-mixer-valve-chrome-square-backplate",
      "wall-mounted-concealed-mixer-valve-chrome-square-flat-lever"
    ]
  },
  {
    "handle": "bar-valves",
    "title": "Bar Valves",
    "parentCategory": "Showers",
    "productCount": 13,
    "description": "Shop bar valves at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "bar-valve-fixing-plate-durable-bathroom-mounting-hardware-stainless-steel-brass",
      "biava-wall-mounted-thermostatic-bath-shower-mixer-bsm-tap",
      "fairford-carton-deck-mounted-thermostic-bath-shower-mixer",
      "matte-black-round-thermostatic-shower-bar-valve-with-single-outlet",
      "mini-bar-valve-fixing-kit-plate-brushed-brass-shower-bar-valve-support",
      "mini-bar-valve-fixing-kit-plate-brushed-brass-shower-bar-valve-support-1",
      "mini-bar-valve-fixing-kit-plate-matt-black-shower-bar-valve-support",
      "mini-bar-valve-fixing-kit-plate-secure-shower-bar-valve-installation",
      "modern-chrome-vema-round-single-outlet-thermostatic-bar-valve-wall-mounted-bathroom-faucet",
      "rex-chrome-exposed-thermostatic-bar-mixer-valve-modern-wall-mounted-faucet",
      "square-matte-black-thermostatic-shower-bar-valve-with-single-outlet",
      "square-thermostatic-bar-valve-single-outlet-modern-wall-mounted-faucet",
      "thermostatic-shower-mixer-valve-wall-mounted-chrome-bathroom-faucet"
    ]
  },
  {
    "handle": "shower-kits",
    "title": "Shower Kits",
    "parentCategory": "Showers",
    "productCount": 56,
    "description": "Shop shower kits at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "bathroom-fort-round-rigid-riser-shower-kit-brushed-brass-finish",
      "bathroom-fort-round-rigid-riser-shower-kit-matt-black-finish",
      "bathroom-fort-round-rigid-riser-shower-kit-modern-chrome-finish",
      "bathroom-fort-round-rigid-riser-shower-kit-with-bath-filler-modern-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-brushed-brass-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-matt-black-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-matt-black-finish-1",
      "bathroom-fort-square-rigid-riser-shower-kit-modern-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-with-bath-filler-chrome-finish",
      "bathroom-fort-thermostatic-round-shower-mixer-slider-rail-kit-brushed-brass",
      "bathroom-fort-thermostatic-round-shower-mixer-valve-slider-rail-kit-chrome",
      "bathroom-fort-thermostatic-round-shower-mixer-valve-slider-rail-kit-matt-black",
      "bristol-bath-shower-mixer-chrome-with-shower-kit-wall-bracket",
      "cascade-bath-shower-mixer-brushed-brass-with-shower-kit-wall-bracket-luxury-tap",
      "cascade-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-tap",
      "cascade-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "classic-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "classic-bath-shower-mixer-tap-with-shower-kit-wall-bracket-traditional-bathtub-tap",
      "classsic-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "crystal-bath-shower-mixer-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "deluxe-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "deluxe-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-luxury-tap",
      "deluxe-bath-shower-mixer-with-shower-kit-wall-bracket-luxury-bathtub-tap",
      "descent-chrome-bath-shower-mixer-with-shower-kit",
      "elite-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "essence-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "essence-bath-shower-mixer-shower-kit-wall-bracket-included",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish-1",
      "imperial-bath-shower-mixer-shower-kit-wall-bracket-included",
      "matt-black-round-rigid-riser-shower-kit-with-thermostatic-control-middleton",
      "noble-5-hole-deck-mounted-bath-shower-mixer-waterfall-spout-with-hand-shower-kit-wall-bracket",
      "oxford-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "prestige-bath-shower-mixer-matt-black-tap-with-shower-kit-wall-bracket",
      "prestige-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "pure-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "qubec-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "round-slider-rail-kit-matt-black-finish-modern-adjustable-shower-rail",
      "round-slider-rail-kit-sleek-design-easy-adjustment",
      "sleek-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "sleek-matt-black-bath-shower-mixer-tap-with-shower-kit-wall-bracket",
      "square-slider-rail-kit-chrome-finish-adjustable-wall-mounted-shower-rail",
      "square-slider-rail-kit-matt-black-finish-adjustable-wall-mounted-shower-rail",
      "thermostatic-round-shower-mixer-valve-with-slider-rail-kit-modern-chrome-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-brushed-brass-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-chrome-finish",
      "thermostatic-square-shower-mixer-valve-with-slider-rail-kit-matt-black-finish",
      "titan-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "traditional-brass-slider-rail-kit-vintage-elegance-lasting-quality",
      "vista-bath-shower-mixer-tap-with-shower-kit-chrome-finish",
      "york-traditional-bath-shower-mixer-tap-with-shower-kit-wall-bracket-chrome",
      "zenith-bath-shower-mixer-tap-matt-black-with-shower-kit-bracket",
      "zenith-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "zenith-wall-mounted-basin-shower-mixer-tap-with-waterfall-spout-shower-kit"
    ]
  },
  {
    "handle": "shower-systems",
    "title": "Shower Systems",
    "parentCategory": "Showers",
    "productCount": 11,
    "description": "Shop shower systems at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "exposed-thermostatic-shower-system-chrome-rainfall-shower-with-handheld",
      "exposed-thermostatic-shower-system-chrome-wall-mounted-rainfall-shower-set",
      "gold-exposed-thermostatic-shower-system-rainfall-shower-with-handheld",
      "luxury-concealed-thermostatic-shower-system-with-rain-shower-handset-6-body-jets-chrome-finish",
      "single-outlet-thermostatic-mixer-with-300mm-arm-200mm-ultra-slim-shower",
      "single-outlet-thermostatic-mixer-with-300mm-square-arm-200mm-square-head",
      "triple-outlet-thermostatic-mixer-with-round-arm-slim-head-hose-6-body-jets",
      "triple-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-accessories",
      "triple-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-bath-spout",
      "two-outlet-thermostatic-mixer-with-300mm-round-arm-slim-head-hand-shower",
      "two-outlet-thermostatic-mixer-with-round-arm-ultra-slim-head-hand-shower"
    ]
  },
  {
    "handle": "shower-handsets",
    "title": "Shower Handsets",
    "parentCategory": "Showers",
    "productCount": 30,
    "description": "Shop shower handsets at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "2-outlet-concealed-shower-valve-with-round-handles-and-diverter",
      "aqua-freestanding-bath-shower-mixer-modern-chrome-finish-with-handset-hose",
      "breeze-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "eden-freestanding-bath-shower-mixer-tap-with-handset-brushed-brass",
      "luxury-concealed-thermostatic-shower-system-with-rain-shower-handset-6-body-jets-chrome-finish",
      "lyra-thermostatic-shower-valve-with-handset-two-outlet",
      "modern-concealed-thermostatic-shower-set-with-rain-shower-handset-rectangular-bath-spout-chrome-finish",
      "prestige-freestanding-bath-shower-mixer-modern-floor-mounted-tap-with-handset",
      "pure-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "rectangular-brass-shower-handset-modern-bathroom-handheld-shower-fixture",
      "round-abs-shower-handset-lightweight-modern-bathroom-handheld-shower",
      "round-adjustable-shower-handset-wall-bracket-modern-bathroom-fixture",
      "round-adjustable-shower-handset-wall-bracket-modern-bathroom-fixture-1",
      "round-brass-shower-handset-modern-bathroom-handheld-shower-fixture",
      "round-shower-handset-wall-bracket-with-wall-outlet-modern-bathroom-fixture",
      "round-shower-handset-with-hose-wall-outlet-brushed-brass-modern-bathroom-set",
      "round-shower-handset-with-hose-wall-outlet-matt-black-modern-bathroom-set",
      "round-shower-handset-with-hose-wall-outlet-modern-bathroom-set",
      "square-abs-shower-handset-lightweight-modern-bathroom-handheld-shower",
      "square-abs-shower-handset-lightweight-modern-bathroom-handheld-shower-1",
      "square-adjustable-shower-handset-wall-bracket-modern-bathroom-fixture",
      "square-shower-handset-wall-bracket-with-wall-outlet-modern-bathroom-fixture",
      "square-shower-handset-wall-bracket-with-wall-outlet-modern-bathroom-fixture-1",
      "square-shower-handset-wall-bracket-with-wall-outlet-modern-bathroom-fixture-2",
      "square-shower-handset-with-hose-wall-outlet-brushed-brass-modern-bathroom-set",
      "square-shower-handset-with-hose-wall-outlet-matt-black-modern-bathroom-set",
      "square-shower-handset-with-hose-wall-outlet-modern-bathroom-set",
      "thermostatic-round-shower-mixer-valve-with-multi-function-handset-chrome",
      "york-freestanding-traditional-bath-shower-mixer-tap-with-handset-chrome",
      "zenith-freestanding-bath-shower-mixer-tap-with-handset-chrome-finish"
    ]
  },
  {
    "handle": "shower-hoses",
    "title": "Shower Hoses",
    "parentCategory": "Showers",
    "productCount": 16,
    "description": "Shop shower hoses at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-freestanding-bath-shower-mixer-modern-chrome-finish-with-handset-hose",
      "round-shower-handset-with-hose-wall-outlet-brushed-brass-modern-bathroom-set",
      "round-shower-handset-with-hose-wall-outlet-matt-black-modern-bathroom-set",
      "round-shower-handset-with-hose-wall-outlet-modern-bathroom-set",
      "smooth-pvc-shower-hose-1-5m-brushed-brass-flexible-anti-kink-hose",
      "smooth-pvc-shower-hose-1-5m-flexible-anti-kink-bathroom-hose",
      "smooth-pvc-shower-hose-1-5m-matt-black-flexible-anti-kink-hose",
      "square-shower-handset-with-hose-wall-outlet-brushed-brass-modern-bathroom-set",
      "square-shower-handset-with-hose-wall-outlet-matt-black-modern-bathroom-set",
      "square-shower-handset-with-hose-wall-outlet-modern-bathroom-set",
      "stainless-steel-shower-hose-1-2m-flexible-anti-kink-bathroom-hose",
      "stainless-steel-shower-hose-1-2m-matt-black-flexible-anti-kink-hose",
      "stainless-steel-shower-hose-1-5m-flexible-anti-kink-bathroom-hose",
      "stainless-steel-shower-hose-1-5m-large-bore-flexible-anti-kink-hose",
      "stainless-steel-shower-hose-2m-extra-long-flexible-anti-kink-hose",
      "triple-outlet-thermostatic-mixer-with-round-arm-slim-head-hose-6-body-jets"
    ]
  },
  {
    "handle": "shower-heads",
    "title": "Shower Heads",
    "parentCategory": "Showers",
    "productCount": 21,
    "description": "Shop shower heads at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "round-abs-ultra-slim-shower-head-200mm-modern-lightweight-bathroom-design",
      "round-brass-ultra-slim-shower-head-200mm-elegant-bathroom-rainfall-design",
      "round-brass-ultra-slim-shower-head-250mm-elegant-bathroom-rainfall-design",
      "round-ultra-slim-rainfall-shower-head-200mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-200mm-stainless-steel",
      "round-ultra-slim-rainfall-shower-head-250mm-brushed-brass",
      "round-ultra-slim-rainfall-shower-head-250mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-250mm-stainless-steel",
      "round-ultra-slim-rainfall-shower-head-300mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-300mm-stainless-steel",
      "round-ultra-slim-shower-head-200mm-chrome-modern-bathroom-fitting",
      "square-abs-shower-head-200mm-modern-bathroom-rainfall-shower-easy-install",
      "square-brass-shower-head-200mm-modern-bathroom-rainfall-fitting-easy-install",
      "square-brass-ultra-slim-shower-head-250mm-elegant-bathroom-rainfall-design",
      "square-ultra-slim-rainfall-shower-head-200mm-matt-black",
      "square-ultra-slim-rainfall-shower-head-200mm-stainless-steel",
      "square-ultra-slim-rainfall-shower-head-250mm-brushed-brass",
      "square-ultra-slim-rainfall-shower-head-250mm-matt-black",
      "square-ultra-slim-rainfall-shower-head-250mm-stainless-steel",
      "square-ultra-slim-rainfall-shower-head-300mm-stainless-steel",
      "traditional-round-shower-head-200mm-classic-bathroom-rainfall-design"
    ]
  },
  {
    "handle": "square-shower-heads",
    "title": "Square Shower Heads",
    "parentCategory": "Showers",
    "productCount": 10,
    "description": "Shop square shower heads at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "round-ultra-slim-shower-head-200mm-chrome-modern-bathroom-fitting",
      "square-abs-shower-head-200mm-modern-bathroom-rainfall-shower-easy-install",
      "square-brass-shower-head-200mm-modern-bathroom-rainfall-fitting-easy-install",
      "square-brass-ultra-slim-shower-head-250mm-elegant-bathroom-rainfall-design",
      "square-ultra-slim-rainfall-shower-head-200mm-matt-black",
      "square-ultra-slim-rainfall-shower-head-200mm-stainless-steel",
      "square-ultra-slim-rainfall-shower-head-250mm-brushed-brass",
      "square-ultra-slim-rainfall-shower-head-250mm-matt-black",
      "square-ultra-slim-rainfall-shower-head-250mm-stainless-steel",
      "square-ultra-slim-rainfall-shower-head-300mm-stainless-steel"
    ]
  },
  {
    "handle": "round-shower-heads",
    "title": "Round Shower Heads",
    "parentCategory": "Showers",
    "productCount": 11,
    "description": "Shop round shower heads at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "round-abs-ultra-slim-shower-head-200mm-modern-lightweight-bathroom-design",
      "round-brass-ultra-slim-shower-head-200mm-elegant-bathroom-rainfall-design",
      "round-brass-ultra-slim-shower-head-250mm-elegant-bathroom-rainfall-design",
      "round-ultra-slim-rainfall-shower-head-200mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-200mm-stainless-steel",
      "round-ultra-slim-rainfall-shower-head-250mm-brushed-brass",
      "round-ultra-slim-rainfall-shower-head-250mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-250mm-stainless-steel",
      "round-ultra-slim-rainfall-shower-head-300mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-300mm-stainless-steel",
      "traditional-round-shower-head-200mm-classic-bathroom-rainfall-design"
    ]
  },
  {
    "handle": "brass-shower-heads",
    "title": "Brass Shower Heads",
    "parentCategory": "Showers",
    "productCount": 6,
    "description": "Shop brass shower heads at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "round-brass-ultra-slim-shower-head-200mm-elegant-bathroom-rainfall-design",
      "round-brass-ultra-slim-shower-head-250mm-elegant-bathroom-rainfall-design",
      "round-ultra-slim-rainfall-shower-head-250mm-brushed-brass",
      "square-brass-shower-head-200mm-modern-bathroom-rainfall-fitting-easy-install",
      "square-brass-ultra-slim-shower-head-250mm-elegant-bathroom-rainfall-design",
      "square-ultra-slim-rainfall-shower-head-250mm-brushed-brass"
    ]
  },
  {
    "handle": "black-shower-heads",
    "title": "Black Shower Heads",
    "parentCategory": "Showers",
    "productCount": 6,
    "description": "Shop black shower heads at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "round-ultra-slim-rainfall-shower-head-200mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-250mm-matt-black",
      "round-ultra-slim-rainfall-shower-head-300mm-matt-black",
      "round-ultra-slim-shower-head-200mm-chrome-modern-bathroom-fitting",
      "square-ultra-slim-rainfall-shower-head-200mm-matt-black",
      "square-ultra-slim-rainfall-shower-head-250mm-matt-black"
    ]
  },
  {
    "handle": "shower-arms",
    "title": "Shower Arms",
    "parentCategory": "Showers",
    "productCount": 18,
    "description": "Shop shower arms at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "brushed-brass-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "brushed-brass-square-wall-mounted-shower-arm-modern-bathroom-fitting",
      "brushed-brass-wall-mounted-shower-arm-with-flange-l-shaped-extension-pipe",
      "brushed-nickel-wall-mounted-shower-arm-380mm-with-flange-modern-bathroom-fixture",
      "chrome-ceiling-shower-arm-12-inch-extension-pipe-with-flange",
      "chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange-1",
      "chrome-wall-mounted-shower-arm-l-shaped-extension-pipe-with-flange",
      "matte-black-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "matte-black-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "matte-black-wall-mounted-shower-arm-l-shaped-extension-pipe-with-flange",
      "polished-chrome-ceiling-shower-arm-12-inch-extension-pipe-with-flange",
      "polished-chrome-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "round-ceiling-shower-arm-brushed-brass-120mm",
      "round-ceiling-shower-arm-matte-black-120mm",
      "round-ceiling-shower-arm-stainless-steel-120mm",
      "square-chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "square-wall-mounted-shower-arm-polished-chrome-finish"
    ]
  },
  {
    "handle": "ceiling-shower-arms",
    "title": "Ceiling Shower Arms",
    "parentCategory": "Showers",
    "productCount": 10,
    "description": "Shop ceiling shower arms at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "brushed-brass-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "chrome-ceiling-shower-arm-12-inch-extension-pipe-with-flange",
      "chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange-1",
      "matte-black-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "polished-chrome-ceiling-shower-arm-12-inch-extension-pipe-with-flange",
      "round-ceiling-shower-arm-brushed-brass-120mm",
      "round-ceiling-shower-arm-matte-black-120mm",
      "round-ceiling-shower-arm-stainless-steel-120mm",
      "square-chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange"
    ]
  },
  {
    "handle": "wall-mounted-shower-arms",
    "title": "Wall Mounted Shower Arms",
    "parentCategory": "Showers",
    "productCount": 8,
    "description": "Shop wall mounted shower arms at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "brushed-brass-square-wall-mounted-shower-arm-modern-bathroom-fitting",
      "brushed-brass-wall-mounted-shower-arm-with-flange-l-shaped-extension-pipe",
      "brushed-nickel-wall-mounted-shower-arm-380mm-with-flange-modern-bathroom-fixture",
      "chrome-wall-mounted-shower-arm-l-shaped-extension-pipe-with-flange",
      "matte-black-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "matte-black-wall-mounted-shower-arm-l-shaped-extension-pipe-with-flange",
      "polished-chrome-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "square-wall-mounted-shower-arm-polished-chrome-finish"
    ]
  },
  {
    "handle": "square-shower-arms",
    "title": "Square Shower Arms",
    "parentCategory": "Showers",
    "productCount": 7,
    "description": "Shop square shower arms at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "brushed-brass-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "brushed-brass-square-wall-mounted-shower-arm-modern-bathroom-fitting",
      "matte-black-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "matte-black-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "polished-chrome-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "square-chrome-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "square-wall-mounted-shower-arm-polished-chrome-finish"
    ]
  },
  {
    "handle": "round-shower-arms",
    "title": "Round Shower Arms",
    "parentCategory": "Showers",
    "productCount": 3,
    "description": "Shop round shower arms at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "round-ceiling-shower-arm-brushed-brass-120mm",
      "round-ceiling-shower-arm-matte-black-120mm",
      "round-ceiling-shower-arm-stainless-steel-120mm"
    ]
  },
  {
    "handle": "brass-shower-arms",
    "title": "Brass Shower Arms",
    "parentCategory": "Showers",
    "productCount": 4,
    "description": "Shop brass shower arms at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "brushed-brass-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "brushed-brass-square-wall-mounted-shower-arm-modern-bathroom-fitting",
      "brushed-brass-wall-mounted-shower-arm-with-flange-l-shaped-extension-pipe",
      "round-ceiling-shower-arm-brushed-brass-120mm"
    ]
  },
  {
    "handle": "black-shower-arms",
    "title": "Black Shower Arms",
    "parentCategory": "Showers",
    "productCount": 4,
    "description": "Shop black shower arms at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "matte-black-square-ceiling-shower-arm-8-inch-extension-pipe-with-flange",
      "matte-black-square-wall-mounted-shower-arm-modern-bathroom-fixture",
      "matte-black-wall-mounted-shower-arm-l-shaped-extension-pipe-with-flange",
      "round-ceiling-shower-arm-matte-black-120mm"
    ]
  },
  {
    "handle": "shower-enclosures",
    "title": "Shower Enclosures",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 16,
    "description": "Shop shower enclosures at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "1200mm-support-bar-straight-round-wetroom-shower-enclosure",
      "700mm-support-bar-straight-round-wetroom-shower-enclosure",
      "adjustable-support-bar-970-660mm-straight-square-wetroom-shower-enclosure",
      "clear-135-magnetic-shower-enclosure-seal-10mm-glass-2000mm-length",
      "clear-135-magnetic-shower-enclosure-seal-6mm-glass-2000mm-length",
      "clear-135-magnetic-shower-enclosure-seal-8mm-x-2000mm",
      "clear-180-magnetic-shower-enclosure-seal-10mm-glass-2000mm-length",
      "clear-180-magnetic-shower-enclosure-seal-6mm-glass-2000mm-length",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-brushed-brass",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-chrome",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-matt-black",
      "marina-6-quadrant-6mm-clear-glass-brushed-brass",
      "marina-6-quadrant-6mm-clear-glass-chrome",
      "marina-6-quadrant-shower-enclosure-6mm-clear-glass-with-matt-black-frame",
      "marina-8-frameless-quadrant-door-8mm-clear-glass-chrome",
      "marina-8-wet-room-8mm-clear-glass-shower-enclosure-with-brushed-brass-frame"
    ]
  },
  {
    "handle": "shower-doors",
    "title": "Shower Doors",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 12,
    "description": "Shop shower doors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "4-folding-glass-panel-door-bath-shower-screen-4mm-thick",
      "4-folding-glass-panel-door-bath-shower-screen-matt-black-4mm-thick",
      "a-pair-of-universal-rounded-chrome-160-mm-shower-door-handles",
      "marina-6-bi-fold-shower-door-6mm-clear-glass-with-brushed-brass-frame",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-brushed-brass",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-chrome",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-matt-black",
      "marina-6-shower-slider-door-6mm-clear-glass-brushed-brass",
      "marina-6-shower-slider-door-6mm-clear-glass-matt-black",
      "marina-6-slider-shower-door-6mm-clear-tempered-glass-chrome-frame-bathroom",
      "marina-8-frameless-quadrant-door-8mm-clear-glass-chrome",
      "round-shower-door-handle-pair-matt-black-finish"
    ]
  },
  {
    "handle": "sliding-shower-doors",
    "title": "Sliding Shower Doors",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 1,
    "description": "Shop sliding shower doors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "marina-6-slider-shower-door-6mm-clear-tempered-glass-chrome-frame-bathroom"
    ]
  },
  {
    "handle": "pivot-shower-doors",
    "title": "Pivot Shower Doors",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 3,
    "description": "Shop pivot shower doors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-brushed-brass",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-chrome",
      "marina-6-pivot-shower-door-enclosure-screen-6mm-clear-glass-matt-black"
    ]
  },
  {
    "handle": "quadrant-shower-enclosures",
    "title": "Quadrant Shower Enclosures",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 17,
    "description": "Shop quadrant shower enclosures at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "adjustable-leg-set-for-1000-1200mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays-1",
      "marina-6-quadrant-6mm-clear-glass-brushed-brass",
      "marina-6-quadrant-6mm-clear-glass-chrome",
      "marina-6-quadrant-corner-shower-6mm-clear-glass-matt-black",
      "marina-6-quadrant-quadrant-corner-shower-6mm-clear-glass-brushed-brass",
      "marina-6-quadrant-quadrant-corner-shower-6mm-clear-glass-chrome",
      "marina-6-quadrant-shower-enclosure-6mm-clear-glass-with-matt-black-frame",
      "marina-8-frameless-quadrant-door-8mm-clear-glass-chrome",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays-1",
      "shower-tray-leg-set-suitable-for-1100-1200mm-quadrant-offset-trays-black",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays-black",
      "slim-line-quadrant-shower-tray-gloss-white",
      "slim-line-quadrant-shower-tray-slate-grey"
    ]
  },
  {
    "handle": "side-panels",
    "title": "Side Panels",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 4,
    "description": "Shop side panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "marina-6-side-panel-6mm-clear-glass-brushed-brass",
      "marina-6-side-panel-6mm-clear-glass-chrome",
      "marina-6-side-panel-6mm-clear-glass-matt-black",
      "marina-8-frameless-8mm-clear-glass-side-panel-for-sliding-door-sd8f-chrome"
    ]
  },
  {
    "handle": "wetroom-screens",
    "title": "Wetroom Screens",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 11,
    "description": "Shop wetroom screens at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "1200-mm-support-bar-wetroom-enclosure-straight-square",
      "1200mm-support-bar-straight-round-wetroom-shower-enclosure",
      "700mm-support-bar-straight-round-wetroom-shower-enclosure",
      "adjustable-support-bar-970-660mm-straight-square-wetroom-shower-enclosure",
      "marina-8-wet-room-8mm-clear-glass-chrome",
      "marina-8-wet-room-8mm-clear-glass-shower-enclosure-with-brushed-brass-frame",
      "marina-8-wet-room-8mm-clear-glass-swivel-return-panel-brushed-brass-300-x-1900mm",
      "marina-8-wet-room-8mm-clear-glass-swivel-return-panel-chrome-300x1900mm",
      "marina-8-wet-room-8mm-clear-glass-swivel-return-panel-matt-black-300-x-1900mm",
      "marina-8-wet-room-glass-screen-8mm-clear-glass-matt-black",
      "marina-8-wet-room-shower-screen-8mm-black-grid"
    ]
  },
  {
    "handle": "shower-trays",
    "title": "Shower Trays",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 35,
    "description": "Shop shower trays at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "90mm-black-top-fast-flow-shower-tray-waste",
      "90mm-brushed-brass-top-fast-flow-shower-tray-waste",
      "90mm-chrome-top-fast-flow-shower-tray-waste",
      "adjustable-leg-set-for-1000-1200mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-1000mm-square-rectangular-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays-1",
      "adjustable-shower-tray-leg-set-for-1300-1800mm-rectangular-walk-in-trays",
      "easy-plumb-kit-for-1100-1200mm-rectangular-trays-slate-grey-leg3s",
      "hudson-reed-leg-set-suitable-for-1300-1800-rectangular-walk-in-trays-slate-grey",
      "leg-set-for-1000-1200-quad-offset-trays-durable-easy-installation",
      "nuie-shower-tray-leg-set-plinth-for-square-rectangle-shower-trays-700-900mm",
      "rectangular-acrylic-shower-base-with-corner-drain-low-profile-slip-resistant-easy-clean",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays-1",
      "shower-tray-leg-set-suitable-for-1000mm-square-rectangular-tray",
      "shower-tray-leg-set-suitable-for-1100-1200mm-quadrant-offset-trays-black",
      "shower-tray-leg-set-suitable-for-1100-1200mm-rectangular-trays-black",
      "shower-tray-leg-set-suitable-for-1300-1800mm-rectangular-walk-in-tray",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays-black",
      "slim-line-quadrant-shower-tray-gloss-white",
      "slim-line-quadrant-shower-tray-slate-grey",
      "slip-resistant-offset-quad-shower-tray-lh-gloss-white",
      "slip-resistant-offset-quad-shower-tray-lh-gloss-white-1",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white-1",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white-2",
      "slip-resistant-rectangular-shower-tray-gloss-white",
      "slip-resistant-rectangular-shower-tray-gloss-white-1",
      "slip-resistant-rectangular-shower-tray-slate-grey",
      "slip-resistant-rectangular-shower-tray-slate-grey-1",
      "slip-resistant-square-bathroom-shower-tray-slate-grey",
      "walk-in-shower-tray-rectangle-slimline-gloss-white",
      "walk-in-shower-tray-rectangle-slimline-slate-grey"
    ]
  },
  {
    "handle": "square-shower-trays",
    "title": "Square Shower Trays",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 5,
    "description": "Shop square shower trays at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "adjustable-leg-set-for-1000mm-square-rectangular-shower-trays",
      "adjustable-leg-set-for-700-900mm-square-rectangular-shower-trays-black-chrome-finish",
      "nuie-shower-tray-leg-set-plinth-for-square-rectangle-shower-trays-700-900mm",
      "shower-tray-leg-set-suitable-for-1000mm-square-rectangular-tray",
      "slip-resistant-square-bathroom-shower-tray-slate-grey"
    ]
  },
  {
    "handle": "rectangular-shower-trays",
    "title": "Rectangular Shower Trays",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 16,
    "description": "Shop rectangular shower trays at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "adjustable-leg-set-for-1000mm-square-rectangular-shower-trays",
      "adjustable-leg-set-for-700-900mm-square-rectangular-shower-trays-black-chrome-finish",
      "adjustable-shower-tray-leg-set-for-1300-1800mm-rectangular-walk-in-trays",
      "easy-plumb-kit-for-1100-1200mm-rectangular-trays-slate-grey-leg3s",
      "hudson-reed-leg-set-suitable-for-1300-1800-rectangular-walk-in-trays-slate-grey",
      "nuie-shower-tray-leg-set-plinth-for-square-rectangle-shower-trays-700-900mm",
      "rectangular-acrylic-shower-base-with-corner-drain-low-profile-slip-resistant-easy-clean",
      "shower-tray-leg-set-suitable-for-1000mm-square-rectangular-tray",
      "shower-tray-leg-set-suitable-for-1100-1200mm-rectangular-trays-black",
      "shower-tray-leg-set-suitable-for-1300-1800mm-rectangular-walk-in-tray",
      "slip-resistant-rectangular-shower-tray-gloss-white",
      "slip-resistant-rectangular-shower-tray-gloss-white-1",
      "slip-resistant-rectangular-shower-tray-slate-grey",
      "slip-resistant-rectangular-shower-tray-slate-grey-1",
      "walk-in-shower-tray-rectangle-slimline-gloss-white",
      "walk-in-shower-tray-rectangle-slimline-slate-grey"
    ]
  },
  {
    "handle": "quadrant-shower-trays",
    "title": "Quadrant Shower Trays",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 18,
    "description": "Shop quadrant shower trays at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "adjustable-leg-set-for-1000-1200mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays-1",
      "leg-set-for-1000-1200-quad-offset-trays-durable-easy-installation",
      "offset-quad-tray-lh-slate-grey",
      "offset-quad-tray-rh-slate-grey",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays-1",
      "shower-tray-leg-set-suitable-for-1100-1200mm-quadrant-offset-trays-black",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays-black",
      "slim-line-quadrant-shower-tray-gloss-white",
      "slim-line-quadrant-shower-tray-slate-grey",
      "slip-resistant-offset-quad-shower-tray-lh-gloss-white",
      "slip-resistant-offset-quad-shower-tray-lh-gloss-white-1",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white-1",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white-2"
    ]
  },
  {
    "handle": "offset-quadrant-shower-trays",
    "title": "Offset Quadrant Shower Trays",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 16,
    "description": "Shop offset quadrant shower trays at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "adjustable-leg-set-for-1000-1200mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays-1",
      "leg-set-for-1000-1200-quad-offset-trays-durable-easy-installation",
      "offset-quad-tray-lh-slate-grey",
      "offset-quad-tray-rh-slate-grey",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays-1",
      "shower-tray-leg-set-suitable-for-1100-1200mm-quadrant-offset-trays-black",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays-black",
      "slip-resistant-offset-quad-shower-tray-lh-gloss-white",
      "slip-resistant-offset-quad-shower-tray-lh-gloss-white-1",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white-1",
      "slip-resistant-offset-quad-shower-tray-rh-gloss-white-2"
    ]
  },
  {
    "handle": "walk-in-shower-trays",
    "title": "Walk In Shower Trays",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 5,
    "description": "Shop walk in shower trays at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "adjustable-shower-tray-leg-set-for-1300-1800mm-rectangular-walk-in-trays",
      "hudson-reed-leg-set-suitable-for-1300-1800-rectangular-walk-in-trays-slate-grey",
      "shower-tray-leg-set-suitable-for-1300-1800mm-rectangular-walk-in-tray",
      "walk-in-shower-tray-rectangle-slimline-gloss-white",
      "walk-in-shower-tray-rectangle-slimline-slate-grey"
    ]
  },
  {
    "handle": "shower-tray-legs-and-plinths",
    "title": "Shower Tray Legs & Plinths",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 17,
    "description": "Shop shower tray legs & plinths at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "adjustable-leg-set-for-1000-1200mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-1000mm-square-rectangular-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays",
      "adjustable-leg-set-for-700-900mm-quadrant-offset-shower-trays-1",
      "adjustable-leg-set-for-700-900mm-square-rectangular-shower-trays-black-chrome-finish",
      "adjustable-shower-tray-leg-set-for-1300-1800mm-rectangular-walk-in-trays",
      "hudson-reed-leg-set-suitable-for-1300-1800-rectangular-walk-in-trays-slate-grey",
      "leg-set-for-1000-1200-quad-offset-trays-durable-easy-installation",
      "nuie-shower-tray-leg-set-plinth-for-square-rectangle-shower-trays-700-900mm",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-1000-1200mm-quadrant-offset-trays-1",
      "shower-tray-leg-set-suitable-for-1000mm-square-rectangular-tray",
      "shower-tray-leg-set-suitable-for-1100-1200mm-quadrant-offset-trays-black",
      "shower-tray-leg-set-suitable-for-1100-1200mm-rectangular-trays-black",
      "shower-tray-leg-set-suitable-for-1300-1800mm-rectangular-walk-in-tray",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays",
      "shower-tray-leg-set-suitable-for-700-900mm-quadrant-offset-trays-black"
    ]
  },
  {
    "handle": "shower-door-handles",
    "title": "Shower Door Handles",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 1,
    "description": "Shop shower door handles at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "round-shower-door-handle-pair-matt-black-finish"
    ]
  },
  {
    "handle": "shower-seals",
    "title": "Shower Seals",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 6,
    "description": "Shop shower seals at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "angled-180-magnetic-shower-seal-8mm-to-8mm-glass-2000mm-length",
      "clear-135-magnetic-shower-enclosure-seal-10mm-glass-2000mm-length",
      "clear-135-magnetic-shower-enclosure-seal-6mm-glass-2000mm-length",
      "clear-135-magnetic-shower-enclosure-seal-8mm-x-2000mm",
      "clear-180-magnetic-shower-enclosure-seal-10mm-glass-2000mm-length",
      "clear-180-magnetic-shower-enclosure-seal-6mm-glass-2000mm-length"
    ]
  },
  {
    "handle": "extension-profiles",
    "title": "Extension Profiles",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 3,
    "description": "Shop extension profiles at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "1900mm-chrome-profile-extension-up-to-20mm-wall-adjustment-kit-shower-enclosures",
      "extension-profile-1900mm-20mm-wall-adjustment-brushed-brass-finish",
      "extension-profile-1900mm-20mm-wall-adjustment-matt-black-finish"
    ]
  },
  {
    "handle": "wetroom-support-bars",
    "title": "Wetroom Support Bars",
    "parentCategory": "Shower Enclosures & Wetrooms",
    "productCount": 4,
    "description": "Shop wetroom support bars at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "1200-mm-support-bar-wetroom-enclosure-straight-square",
      "1200mm-support-bar-straight-round-wetroom-shower-enclosure",
      "700mm-support-bar-straight-round-wetroom-shower-enclosure",
      "adjustable-support-bar-970-660mm-straight-square-wetroom-shower-enclosure"
    ]
  },
  {
    "handle": "bathroom-taps",
    "title": "Bathroom Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 246,
    "description": "Shop bathroom taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "3-in-1-instant-boiling-water-filter-kitchen-tap-with-heating-tank",
      "3-in-1-instant-boiling-water-filter-kitchen-tap-with-heating-tank-filter",
      "anzzi-revere-1-2-gpm-deck-mounted-single-hole-bathroom-faucet",
      "aqua-bath-filler-tap-stylish-chrome-finish-durable-mixer-for-modern-bathtubs",
      "aqua-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "aqua-bath-taps-pair-of-modern-chrome-finish-bathroom-taps-for-bathtubs",
      "aqua-bath-taps-pair-of-modern-chrome-finish-bathroom-taps-for-bathtubs-1",
      "aqua-freestanding-bath-shower-mixer-modern-chrome-finish-with-handset-hose",
      "aqua-mono-basin-mixer-tap-with-waste-modern-chrome-finish-bathroom-sink-tap",
      "basin-taps-waterfall-with-pop-up-waste-square-bathroom-sink-mixer-taps-chrome-uk",
      "bathroom-fort-round-rigid-riser-shower-kit-with-bath-filler-modern-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-with-bath-filler-chrome-finish",
      "better-bathrooms-cube-freestanding-bath-shower-mixer-15032-spare-parts",
      "boston-bathroom-basin-sink-mono-mixer-tap-chrome-solid-brass-ceramic-discs",
      "boston-modern-set-of-chrome-hot-cold-twin-bath-taps-deck-mounted-brass",
      "brayton-cube-bathroom-deck-mounted-chrome-bath-filler-mixer-tap",
      "breeze-basin-taps-pair-of-chrome-finish-modern-bathroom-sink-taps",
      "breeze-bath-filler-tap-durable-chrome-finish-modern-bathroom-mixer-for-tubs",
      "breeze-bath-taps-pair-of-chrome-finish-modern-bathroom-taps-for-bathtubs",
      "breeze-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "bristan-blitz-modern-small-basin-mixer-chrome-btz-smbas-c",
      "bristol-basin-taps-traditional-chrome-bathroom-sink-taps-pair",
      "bristol-bath-shower-mixer-chrome-with-shower-kit-wall-bracket",
      "bristol-bath-taps-traditional-chrome-hot-cold-bathroom-taps-pair",
      "bristol-mono-basin-mixer-tap-with-waste-modern-chrome-bathroom-faucet",
      "bristol-traditional-freestanding-bath-shower-mixer-tap-with-handheld-shower-chrome",
      "casa-bano-distro-wall-mounted-basin-mixer",
      "cascade-bath-filler-tap-brushed-brass-luxury-modern-bathtub-mixer-for-bathrooms",
      "cascade-bath-filler-tap-durable-chrome-finish-modern-mixer-for-bathtubs",
      "cascade-bath-filler-tap-matt-black-durable-modern-bathtub-mixer-for-bathrooms",
      "cascade-bath-shower-mixer-brushed-brass-with-shower-kit-wall-bracket-luxury-tap",
      "cascade-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-tap",
      "cascade-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "cascade-mini-mono-basin-mixer-tap-brushed-brass-with-waste-cloakroom-sink-tap",
      "cascade-mini-mono-basin-mixer-tap-brushed-brass-with-waste-compact-sink-tap",
      "cascade-mini-mono-basin-mixer-tap-matt-black-with-waste-compact-sink-tap",
      "cascade-mono-basin-mixer-tap-brushed-brass-with-waste-luxury-bathroom-sink-tap",
      "cascade-mono-basin-mixer-tap-matt-black-with-waste-modern-bathroom-sink-tap",
      "cascade-mono-basin-mixer-tap-with-waste-chrome-finish-modern-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-brushed-brass-countertop-bathroom-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-matt-black-modern-countertop-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-modern-chrome-finish-bathroom-sink-tap",
      "charlton-matt-black-deck-mounted-mono-tall-basin-mixer-tap",
      "chrome-bathroom-basin-mixer-tap-bath-shower-mixer-tap-waste",
      "classic-bath-filler-matt-black-traditional-dual-handle-bathtub-mixer-tap",
      "classic-bath-filler-tap-traditional-dual-handle-bathtub-mixer-for-elegant-bathrooms",
      "classic-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "classic-bath-shower-mixer-tap-with-shower-kit-wall-bracket-traditional-bathtub-tap",
      "classic-mini-mono-basin-mixer-matt-black-with-waste-cloakroom-sink-tap",
      "classic-mini-mono-basin-mixer-tap-with-waste-traditional-cloakroom-sink-tap",
      "classic-mono-basin-mixer-matt-black-with-waste-traditional-bathroom-sink-tap",
      "classic-mono-basin-mixer-tap-with-waste-traditional-bathroom-sink-mixer-tap",
      "classic-tall-mono-basin-mixer-matt-black-traditional-countertop-bathroom-tap",
      "classic-tall-mono-basin-mixer-tap-traditional-countertop-bathroom-sink-tap",
      "classic-wall-mounted-basin-mixer-matt-black-traditional-bathroom-sink-tap",
      "classic-wall-mounted-basin-mixer-tap-traditional-bathroom-sink-mixer-for-timeless-style",
      "classsic-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "classsic-mini-mono-basin-mixer-matt-black-waste-included",
      "classsic-mono-basin-mixer-matt-black-waste-included",
      "commercial-pull-out-kitchen-tap-spring-coil-mixer-faucet-with-spray-head",
      "crystal-bath-filler-traditional-dual-handle-bathtub-mixer-tap",
      "crystal-bath-shower-mixer-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "crystal-mini-mono-basin-mixer-waste-included",
      "crystal-mini-mono-basin-mixer-with-waste-compact-cloakroom-sink-tap",
      "crystal-mono-basin-mixer-with-waste-stylish-bathroom-sink-mixer-tap",
      "deck-mounted-bath-pillar-modern-bathroom-tap-fixture-stainless-steel-brass",
      "deck-mounted-bath-pillar-modern-bathroom-tap-fixture-stainless-steel-brass-1",
      "deluxe-bath-filler-luxury-dual-handle-bathtub-mixer-tap-for-elegant-bathrooms",
      "deluxe-bath-filler-matt-black-premium-dual-handle-bathtub-mixer-tap",
      "deluxe-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-luxury-tap",
      "deluxe-bath-shower-mixer-with-shower-kit-wall-bracket-luxury-bathtub-tap",
      "deluxe-mono-basin-mixer-matt-black-with-waste-luxury-bathroom-sink-tap",
      "deluxe-mono-basin-mixer-with-waste-luxury-bathroom-sink-mixer-tap",
      "descent-chrome-bath-shower-mixer-with-shower-kit",
      "devon-bathroom-bath-shower-mixer-waterfall-style-chrome-twin-handle-tap",
      "eclipse-contemporary-matte-black-basin-sink-mono-mixer-tap",
      "eden-freestanding-bath-shower-mixer-chrome",
      "eden-freestanding-bath-shower-mixer-tap-with-handset-brushed-brass",
      "eden-freestanding-bath-shower-mixer-with-hand-shower-matt-black",
      "eden-wall-mounted-basin-mixer-brushed-brass-luxury-tap",
      "eden-wall-mounted-basin-mixer-matt-black-modern-bathroom-tap",
      "eden-wall-mounted-basin-mixer-modern-chrome-bathroom-tap-set",
      "elite-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "elite-chrome-dual-handle-bath-filler-tap-modern-deck-mounted-mixer",
      "elite-chrome-mono-basin-mixer-tap-modern-single-lever-with-waste",
      "ellena-chrome-bathroom-taps-basin-mixer-bath-filler-shower-tap-wide-waterfall",
      "ergo-lever-wall-mounted-basin-mixer-chrome",
      "essence-bath-shower-mixer-shower-kit-wall-bracket-included",
      "essence-mini-mono-basin-mixer-matt-black-waste-included",
      "essence-mono-basin-mixer-matt-black-waste-included",
      "essence-mono-basin-mixer-waste-included",
      "febia-traditional-twin-hot-and-cold-basin-sink-taps",
      "fiona-modern-bridge-bath-filler-mixer-tap",
      "fray-basin-mono-tap-with-clicker-waste-in-chrome",
      "freestanding-bath-shower-mixer-tap-matt-black-modern-waterfall-design",
      "freestanding-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "gio-basin-sink-mixer-tap-wall-mounted-concealed-valve-hot-and-cold-mixer-and-w",
      "hecto-bath-filler-tap-stylish-chrome-finish-bathroom-mixer-for-modern-baths",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish-1",
      "hecto-mono-basin-mixer-tap-with-waste-modern-chrome-finish-bathroom-sink-mixer",
      "imperial-bath-shower-mixer-shower-kit-wall-bracket-included",
      "libra-thermostatic-wall-mounted-modern-chrome-bath-shower-mixer-tap",
      "luxe-mini-mono-basin-mixer-waste-included",
      "matt-black-bath-filler-mixer-tap-modern-round-twin-lever-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-modern-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-waterfall-design",
      "medical-basin-mono-tap-with-extended-lever-chrome-finish",
      "mini-thermostatic-bidet-mixing-valve-bathroom-temperature-control-faucet",
      "mini-thermostatic-shower-mixing-valve-temperature-control-faucet-valve",
      "modern-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "modern-chrome-waterfall-bath-filler-tap-dual-lever-mixer",
      "modern-chrome-waterfall-bath-filler-tap-stylish-square-basin-mixer-faucet",
      "modern-pull-out-kitchen-tap-chrome-finish-sink-mixer-faucet-with-spray",
      "modern-single-handle-kitchen-faucet-chrome-high-arc-swivel-sink-tap",
      "modern-single-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "modern-single-handle-kitchen-sink-faucet-sleek-chrome-mixer-tap",
      "modern-waterfall-basin-mixer-tap-chrome-finish",
      "mono-basin-mixer-tap-with-waste-stylish-chrome-finish-bathroom-sink-mixer",
      "nes-home-kento-chrome-square-bath-filler-mixer-tap",
      "nes-home-kento-chrome-square-bath-shower-mixer-tap-with-handheld",
      "noble-3-hole-deck-mounted-basin-mixer-tap-square-handles-waterfall-spout",
      "noble-3-hole-deck-mounted-bath-filler-tap-square-handles-waterfall-spout",
      "noble-5-hole-deck-mounted-bath-shower-mixer-waterfall-spout-with-hand-shower-kit-wall-bracket",
      "nuie-reef-thermostatic-bath-shower-mixer-modern-wall-mounted-faucet",
      "origin-black-2-hole-single-lever-wall-mounted-basin-mixer-tap",
      "oxford-deck-mounted-bath-filler-tap-dual-handle-chrome-waterfall-spout",
      "oxford-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "oxford-mini-mono-basin-mixer-tap-compact-chrome-tap-with-waste-included",
      "oxford-mono-basin-mixer-tap-chrome-single-lever-with-waste-included",
      "pair-of-modern-basin-pillar-taps-chrome-finish",
      "premium-pull-out-kitchen-tap-modern-chrome-finish-mixer-faucet-for-sink",
      "prestige-3-hole-deck-mounted-bath-mixer-contemporary-chrome-tap-set",
      "prestige-3-hole-deck-mounted-bath-mixer-modern-matt-black-tap-set",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-modern-chrome-finish-without-hand-shower",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-with-hand-shower-modern-chrome-finish",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-matt-black-tap-set-with-handheld-shower",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-hand-shower",
      "prestige-bath-filler-brushed-brass",
      "prestige-bath-filler-tap-brushed-brass-luxury-modern-bathroom-mixer",
      "prestige-bath-filler-tap-matte-black-finish",
      "prestige-bath-shower-mixer-matt-black-tap-with-shower-kit-wall-bracket",
      "prestige-bath-shower-mixer-with-kit-brushed-brass",
      "prestige-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "prestige-freestanding-bath-shower-mixer-matte-black-finish",
      "prestige-freestanding-bath-shower-mixer-modern-brushed-brass-faucet",
      "prestige-freestanding-bath-shower-mixer-modern-floor-mounted-tap-with-handset",
      "prestige-mini-mono-basin-mixer-tap-brushed-brass-with-waste-included",
      "prestige-mini-mono-basin-mixer-tap-compact-chrome-mixer-with-waste-included",
      "prestige-mini-mono-basin-mixer-tap-matt-black-waste-included",
      "prestige-modern-bath-filler-tap-chrome-deck-mounted-mixer",
      "prestige-mono-basin-mixer-brushed-brass-with-waste",
      "prestige-mono-basin-mixer-matt-black-tap-with-matching-waste",
      "prestige-mono-basin-mixer-tap-chrome-single-lever-with-waste-included",
      "prestige-tall-mono-basin-mixer-tap-brushed-brass-finish-modern-bathroom",
      "prestige-tall-mono-basin-mixer-tap-high-rise-chrome-tap-for-countertop-basins",
      "prestige-tall-mono-basin-mixer-tap-matt-black",
      "prestige-wall-mounted-basin-mixer-modern-chrome-bathroom-tap",
      "prestige-wall-mounted-basin-mixer-tap-brushed-brass-modern-bathroom-faucet",
      "prestige-wall-mounted-basin-mixer-tap-matte-black-finish",
      "pull-out-hose-kitchen-tap-chrome-flexible-sink-mixer-faucet-with-spray",
      "pull-out-kitchen-tap-chrome-sink-mixer-faucet-with-dual-handles-spray",
      "pull-out-single-handle-kitchen-faucet-brushed-brass-luxury-mixer-tap",
      "pull-out-single-handle-kitchen-faucet-brushed-stainless-steel-mixer-tap",
      "pull-out-single-handle-kitchen-faucet-matt-black-modern-mixer-tap",
      "pure-basin-taps-pair-with-cross-handles-chrome-finish",
      "pure-bath-filler-tap-with-dual-cross-handles-chrome-finish",
      "pure-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "pure-chrome-bath-taps-set-durable-brass-pair-with-3-5-year-guarantee",
      "pure-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "pure-mono-basin-mixer-tap-with-dual-handle-waste-included",
      "qubec-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "qubec-mini-mono-basin-mixer-tap-compact-chrome-finish-for-small-basins",
      "qubec-mono-basin-mixer-tap-chrome-finish-with-waste-included",
      "raldo-modern-chrome-bathroom-basin-sink-square-mixer-luxury-single-lever-tap",
      "rectangular-bath-filler-spout-wall-mounted-chrome-bathroom-tap",
      "round-bath-filler-spout-modern-wall-mounted-chrome-finish",
      "single-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "single-handle-kitchen-tap-brushed-brass-modern-mixer",
      "single-handle-kitchen-tap-brushed-stainless-steel-modern-mixer",
      "single-handle-kitchen-tap-matt-black-modern-mixer",
      "sleek-bath-filler-tap-modern-matt-black-bathroom-mixer-for-bathtubs",
      "sleek-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "sleek-chrome-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "sleek-matt-black-bath-shower-mixer-tap-with-shower-kit-wall-bracket",
      "sleek-matt-black-mono-basin-mixer-tap-modern-bathroom-tap-with-waste-included",
      "sleek-mini-mono-basin-mixer-tap-matt-black-bathroom-faucet-with-waste",
      "sleek-mini-mono-basin-mixer-tap-with-waste-modern-chrome-bathroom-faucet",
      "sleek-modern-bath-filler-tap-chrome-finish-dual-lever-mixer-for-bathroom",
      "sleek-tall-basin-mono-mixer-tap-modern-bathroom-faucet-matt-black-finish",
      "sleek-tall-basin-mono-mixer-tap-modern-chrome-bathroom-sink-faucet",
      "square-modern-chrome-bathroom-bath-filler-mixer",
      "swivel-spout-kitchen-tap-stainless-steel-mixer-faucet-with-pull-down-spray",
      "tall-basin-mixer-tap-modern-chrome-waterfall-faucet-for-countertop-sinks",
      "tall-chrome-basin-mixer-tap-bathroom-sink-faucet-single-lever-modern-design",
      "tall-matte-black-basin-mixer-tap-modern-waterfall-design",
      "titan-basin-mono-mixer-tap-with-waste-40mm-cartridge-chrome-finish",
      "titan-basin-taps-chrome-hot-cold-water-bathroom-tap-set",
      "titan-bath-filler-mixer-tap-dual-handle-chrome-finish-bathroom-faucet",
      "titan-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "titan-bath-taps-modern-chrome-basin-taps-set-hot-cold-water",
      "twin-handle-kitchen-mixer-tap-brushed-stainless-steel-swivel-spout-faucet",
      "twin-handle-kitchen-mixer-tap-chrome-crosshead-levers-with-swivel-spout",
      "twin-handle-kitchen-mixer-tap-chrome-deck-mounted-with-swivel-spout",
      "twin-handle-kitchen-mixer-tap-chrome-finish-with-360-swivel-spout-faucet",
      "twin-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "twin-handle-kitchen-tap-brushed-brass-traditional-mixer",
      "twin-handle-kitchen-tap-brushed-copper-with-white-levers",
      "twin-handle-kitchen-tap-brushed-nickel-swivel-spout-mixer",
      "twin-handle-kitchen-tap-chrome-cross-handle-swivel-spout",
      "twin-handle-kitchen-tap-chrome-lever-handle-swivel-spout",
      "twin-handle-kitchen-tap-classic-chrome-with-white-levers",
      "twin-handle-kitchen-tap-matt-black-modern-swivel-spout",
      "twin-handle-kitchen-tap-matt-black-with-white-levers",
      "twin-handle-kitchen-tap-modern-swivel-spout-mixer",
      "urban-desk-mounted-sensor-tap-chrome-automatic-infrared-basin-mixer",
      "urban-desk-mounted-sensor-tap-modern-touchless-infrared-basin-mixer",
      "urban-desk-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "urban-non-concussive-basin-mixer-water-saving-push-tap-chrome",
      "urban-non-concussive-basin-taps-timed-flow-push-taps-pair-chrome",
      "urban-wall-mounted-sensor-tap-automatic-chrome-touchless-basin-mixer",
      "urban-wall-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "vellamo-reveal-basin-mixer-tap-with-waste",
      "vista-bath-filler-tap-modern-chrome-finish",
      "vista-bath-shower-mixer-tap-with-shower-kit-chrome-finish",
      "vista-mono-basin-mixer-tap-with-waste-35mm-cartridge-chrome",
      "wasserrhythm-basin-taps-square-bathroom-sink-taps-mixers-chrome-brass-monobloc",
      "york-freestanding-traditional-bath-shower-mixer-tap-with-handset-chrome",
      "york-traditional-basin-taps-pair-chrome-finish",
      "york-traditional-bath-filler-tap-chrome-finish",
      "york-traditional-bath-shower-mixer-tap-with-shower-kit-wall-bracket-chrome",
      "york-traditional-bath-taps-pair-chrome-finish",
      "york-traditional-mono-basin-mixer-tap-with-waste-chrome-finish",
      "zenith-bath-filler-tap-matt-black-modern-waterfall-design",
      "zenith-bath-shower-mixer-tap-matt-black-with-shower-kit-bracket",
      "zenith-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "zenith-freestanding-bath-shower-mixer-tap-with-handset-chrome-finish",
      "zenith-mini-mono-basin-mixer-tap-matt-black-with-waste-included",
      "zenith-modern-bath-filler-tap-with-open-waterfall-spout-chrome-finish",
      "zenith-modern-bath-filler-tap-with-waterfall-spout-chrome-finish",
      "zenith-modern-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "zenith-mono-basin-mixer-tap-matt-black-with-waste",
      "zenith-tall-mono-basin-mixer-tap-with-modern-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-mixer-tap-with-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-shower-mixer-tap-with-waterfall-spout-shower-kit",
      "zenith-wall-mounted-bath-shower-mixer-tap-with-kit-wall-bracket-chrome"
    ]
  },
  {
    "handle": "basin-taps",
    "title": "Basin Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 105,
    "description": "Shop basin taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-mono-basin-mixer-tap-with-waste-modern-chrome-finish-bathroom-sink-tap",
      "basin-taps-waterfall-with-pop-up-waste-square-bathroom-sink-mixer-taps-chrome-uk",
      "boston-bathroom-basin-sink-mono-mixer-tap-chrome-solid-brass-ceramic-discs",
      "breeze-basin-taps-pair-of-chrome-finish-modern-bathroom-sink-taps",
      "bristan-blitz-modern-small-basin-mixer-chrome-btz-smbas-c",
      "bristol-basin-taps-traditional-chrome-bathroom-sink-taps-pair",
      "bristol-mono-basin-mixer-tap-with-waste-modern-chrome-bathroom-faucet",
      "casa-bano-distro-wall-mounted-basin-mixer",
      "cascade-mini-mono-basin-mixer-tap-brushed-brass-with-waste-cloakroom-sink-tap",
      "cascade-mini-mono-basin-mixer-tap-brushed-brass-with-waste-compact-sink-tap",
      "cascade-mini-mono-basin-mixer-tap-matt-black-with-waste-compact-sink-tap",
      "cascade-mono-basin-mixer-tap-brushed-brass-with-waste-luxury-bathroom-sink-tap",
      "cascade-mono-basin-mixer-tap-matt-black-with-waste-modern-bathroom-sink-tap",
      "cascade-mono-basin-mixer-tap-with-waste-chrome-finish-modern-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-brushed-brass-countertop-bathroom-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-matt-black-modern-countertop-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-modern-chrome-finish-bathroom-sink-tap",
      "charlton-matt-black-deck-mounted-mono-tall-basin-mixer-tap",
      "chrome-bathroom-basin-mixer-tap-bath-shower-mixer-tap-waste",
      "classic-mini-mono-basin-mixer-matt-black-with-waste-cloakroom-sink-tap",
      "classic-mini-mono-basin-mixer-tap-with-waste-traditional-cloakroom-sink-tap",
      "classic-mono-basin-mixer-matt-black-with-waste-traditional-bathroom-sink-tap",
      "classic-mono-basin-mixer-tap-with-waste-traditional-bathroom-sink-mixer-tap",
      "classic-tall-mono-basin-mixer-matt-black-traditional-countertop-bathroom-tap",
      "classic-tall-mono-basin-mixer-tap-traditional-countertop-bathroom-sink-tap",
      "classic-wall-mounted-basin-mixer-matt-black-traditional-bathroom-sink-tap",
      "classic-wall-mounted-basin-mixer-tap-traditional-bathroom-sink-mixer-for-timeless-style",
      "classsic-mini-mono-basin-mixer-matt-black-waste-included",
      "classsic-mono-basin-mixer-matt-black-waste-included",
      "crystal-mini-mono-basin-mixer-waste-included",
      "crystal-mini-mono-basin-mixer-with-waste-compact-cloakroom-sink-tap",
      "crystal-mono-basin-mixer-with-waste-stylish-bathroom-sink-mixer-tap",
      "deluxe-mono-basin-mixer-matt-black-with-waste-luxury-bathroom-sink-tap",
      "deluxe-mono-basin-mixer-with-waste-luxury-bathroom-sink-mixer-tap",
      "eclipse-contemporary-matte-black-basin-sink-mono-mixer-tap",
      "eden-wall-mounted-basin-mixer-brushed-brass-luxury-tap",
      "eden-wall-mounted-basin-mixer-matt-black-modern-bathroom-tap",
      "eden-wall-mounted-basin-mixer-modern-chrome-bathroom-tap-set",
      "elite-chrome-mono-basin-mixer-tap-modern-single-lever-with-waste",
      "ellena-chrome-bathroom-taps-basin-mixer-bath-filler-shower-tap-wide-waterfall",
      "ergo-lever-wall-mounted-basin-mixer-chrome",
      "essence-mini-mono-basin-mixer-matt-black-waste-included",
      "essence-mono-basin-mixer-matt-black-waste-included",
      "essence-mono-basin-mixer-waste-included",
      "febia-traditional-twin-hot-and-cold-basin-sink-taps",
      "fray-basin-mono-tap-with-clicker-waste-in-chrome",
      "gio-basin-sink-mixer-tap-wall-mounted-concealed-valve-hot-and-cold-mixer-and-w",
      "hecto-mono-basin-mixer-tap-with-waste-modern-chrome-finish-bathroom-sink-mixer",
      "luxe-mini-mono-basin-mixer-waste-included",
      "medical-basin-mono-tap-with-extended-lever-chrome-finish",
      "modern-chrome-waterfall-bath-filler-tap-stylish-square-basin-mixer-faucet",
      "modern-waterfall-basin-mixer-tap-chrome-finish",
      "mono-basin-mixer-tap-with-waste-stylish-chrome-finish-bathroom-sink-mixer",
      "noble-3-hole-deck-mounted-basin-mixer-tap-square-handles-waterfall-spout",
      "origin-black-2-hole-single-lever-wall-mounted-basin-mixer-tap",
      "oxford-mini-mono-basin-mixer-tap-compact-chrome-tap-with-waste-included",
      "oxford-mono-basin-mixer-tap-chrome-single-lever-with-waste-included",
      "pair-of-modern-basin-pillar-taps-chrome-finish",
      "prestige-mini-mono-basin-mixer-tap-brushed-brass-with-waste-included",
      "prestige-mini-mono-basin-mixer-tap-compact-chrome-mixer-with-waste-included",
      "prestige-mini-mono-basin-mixer-tap-matt-black-waste-included",
      "prestige-mono-basin-mixer-brushed-brass-with-waste",
      "prestige-mono-basin-mixer-matt-black-tap-with-matching-waste",
      "prestige-mono-basin-mixer-tap-chrome-single-lever-with-waste-included",
      "prestige-tall-mono-basin-mixer-tap-brushed-brass-finish-modern-bathroom",
      "prestige-tall-mono-basin-mixer-tap-high-rise-chrome-tap-for-countertop-basins",
      "prestige-tall-mono-basin-mixer-tap-matt-black",
      "prestige-wall-mounted-basin-mixer-modern-chrome-bathroom-tap",
      "prestige-wall-mounted-basin-mixer-tap-brushed-brass-modern-bathroom-faucet",
      "prestige-wall-mounted-basin-mixer-tap-matte-black-finish",
      "pure-basin-taps-pair-with-cross-handles-chrome-finish",
      "pure-mono-basin-mixer-tap-with-dual-handle-waste-included",
      "qubec-mini-mono-basin-mixer-tap-compact-chrome-finish-for-small-basins",
      "qubec-mono-basin-mixer-tap-chrome-finish-with-waste-included",
      "raldo-modern-chrome-bathroom-basin-sink-square-mixer-luxury-single-lever-tap",
      "sleek-chrome-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "sleek-matt-black-mono-basin-mixer-tap-modern-bathroom-tap-with-waste-included",
      "sleek-mini-mono-basin-mixer-tap-matt-black-bathroom-faucet-with-waste",
      "sleek-mini-mono-basin-mixer-tap-with-waste-modern-chrome-bathroom-faucet",
      "sleek-tall-basin-mono-mixer-tap-modern-bathroom-faucet-matt-black-finish",
      "sleek-tall-basin-mono-mixer-tap-modern-chrome-bathroom-sink-faucet",
      "tall-basin-mixer-tap-modern-chrome-waterfall-faucet-for-countertop-sinks",
      "tall-chrome-basin-mixer-tap-bathroom-sink-faucet-single-lever-modern-design",
      "tall-matte-black-basin-mixer-tap-modern-waterfall-design",
      "titan-basin-mono-mixer-tap-with-waste-40mm-cartridge-chrome-finish",
      "titan-basin-taps-chrome-hot-cold-water-bathroom-tap-set",
      "titan-bath-taps-modern-chrome-basin-taps-set-hot-cold-water",
      "urban-desk-mounted-sensor-tap-chrome-automatic-infrared-basin-mixer",
      "urban-desk-mounted-sensor-tap-modern-touchless-infrared-basin-mixer",
      "urban-desk-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "urban-non-concussive-basin-mixer-water-saving-push-tap-chrome",
      "urban-non-concussive-basin-taps-timed-flow-push-taps-pair-chrome",
      "urban-wall-mounted-sensor-tap-automatic-chrome-touchless-basin-mixer",
      "urban-wall-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "vellamo-reveal-basin-mixer-tap-with-waste",
      "vista-mono-basin-mixer-tap-with-waste-35mm-cartridge-chrome",
      "wasserrhythm-basin-taps-square-bathroom-sink-taps-mixers-chrome-brass-monobloc",
      "york-traditional-basin-taps-pair-chrome-finish",
      "york-traditional-mono-basin-mixer-tap-with-waste-chrome-finish",
      "zenith-mini-mono-basin-mixer-tap-matt-black-with-waste-included",
      "zenith-modern-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "zenith-mono-basin-mixer-tap-matt-black-with-waste",
      "zenith-tall-mono-basin-mixer-tap-with-modern-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-mixer-tap-with-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-shower-mixer-tap-with-waterfall-spout-shower-kit"
    ]
  },
  {
    "handle": "basin-mixer-taps",
    "title": "Basin Mixer Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 95,
    "description": "Shop basin mixer taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-mono-basin-mixer-tap-with-waste-modern-chrome-finish-bathroom-sink-tap",
      "basin-taps-waterfall-with-pop-up-waste-square-bathroom-sink-mixer-taps-chrome-uk",
      "boston-bathroom-basin-sink-mono-mixer-tap-chrome-solid-brass-ceramic-discs",
      "bristan-blitz-modern-small-basin-mixer-chrome-btz-smbas-c",
      "bristol-mono-basin-mixer-tap-with-waste-modern-chrome-bathroom-faucet",
      "casa-bano-distro-wall-mounted-basin-mixer",
      "cascade-mini-mono-basin-mixer-tap-brushed-brass-with-waste-cloakroom-sink-tap",
      "cascade-mini-mono-basin-mixer-tap-brushed-brass-with-waste-compact-sink-tap",
      "cascade-mini-mono-basin-mixer-tap-matt-black-with-waste-compact-sink-tap",
      "cascade-mono-basin-mixer-tap-brushed-brass-with-waste-luxury-bathroom-sink-tap",
      "cascade-mono-basin-mixer-tap-matt-black-with-waste-modern-bathroom-sink-tap",
      "cascade-mono-basin-mixer-tap-with-waste-chrome-finish-modern-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-brushed-brass-countertop-bathroom-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-matt-black-modern-countertop-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-modern-chrome-finish-bathroom-sink-tap",
      "charlton-matt-black-deck-mounted-mono-tall-basin-mixer-tap",
      "chrome-bathroom-basin-mixer-tap-bath-shower-mixer-tap-waste",
      "classic-mini-mono-basin-mixer-matt-black-with-waste-cloakroom-sink-tap",
      "classic-mini-mono-basin-mixer-tap-with-waste-traditional-cloakroom-sink-tap",
      "classic-mono-basin-mixer-matt-black-with-waste-traditional-bathroom-sink-tap",
      "classic-mono-basin-mixer-tap-with-waste-traditional-bathroom-sink-mixer-tap",
      "classic-tall-mono-basin-mixer-matt-black-traditional-countertop-bathroom-tap",
      "classic-tall-mono-basin-mixer-tap-traditional-countertop-bathroom-sink-tap",
      "classic-wall-mounted-basin-mixer-matt-black-traditional-bathroom-sink-tap",
      "classic-wall-mounted-basin-mixer-tap-traditional-bathroom-sink-mixer-for-timeless-style",
      "classsic-mini-mono-basin-mixer-matt-black-waste-included",
      "classsic-mono-basin-mixer-matt-black-waste-included",
      "crystal-mini-mono-basin-mixer-waste-included",
      "crystal-mini-mono-basin-mixer-with-waste-compact-cloakroom-sink-tap",
      "crystal-mono-basin-mixer-with-waste-stylish-bathroom-sink-mixer-tap",
      "deluxe-mono-basin-mixer-matt-black-with-waste-luxury-bathroom-sink-tap",
      "deluxe-mono-basin-mixer-with-waste-luxury-bathroom-sink-mixer-tap",
      "eclipse-contemporary-matte-black-basin-sink-mono-mixer-tap",
      "eden-wall-mounted-basin-mixer-brushed-brass-luxury-tap",
      "eden-wall-mounted-basin-mixer-matt-black-modern-bathroom-tap",
      "eden-wall-mounted-basin-mixer-modern-chrome-bathroom-tap-set",
      "elite-chrome-mono-basin-mixer-tap-modern-single-lever-with-waste",
      "ellena-chrome-bathroom-taps-basin-mixer-bath-filler-shower-tap-wide-waterfall",
      "ergo-lever-wall-mounted-basin-mixer-chrome",
      "essence-mini-mono-basin-mixer-matt-black-waste-included",
      "essence-mono-basin-mixer-matt-black-waste-included",
      "essence-mono-basin-mixer-waste-included",
      "gio-basin-sink-mixer-tap-wall-mounted-concealed-valve-hot-and-cold-mixer-and-w",
      "hecto-mono-basin-mixer-tap-with-waste-modern-chrome-finish-bathroom-sink-mixer",
      "luxe-mini-mono-basin-mixer-waste-included",
      "medical-basin-mono-tap-with-extended-lever-chrome-finish",
      "modern-chrome-waterfall-bath-filler-tap-stylish-square-basin-mixer-faucet",
      "modern-waterfall-basin-mixer-tap-chrome-finish",
      "mono-basin-mixer-tap-with-waste-stylish-chrome-finish-bathroom-sink-mixer",
      "noble-3-hole-deck-mounted-basin-mixer-tap-square-handles-waterfall-spout",
      "origin-black-2-hole-single-lever-wall-mounted-basin-mixer-tap",
      "oxford-mini-mono-basin-mixer-tap-compact-chrome-tap-with-waste-included",
      "oxford-mono-basin-mixer-tap-chrome-single-lever-with-waste-included",
      "prestige-mini-mono-basin-mixer-tap-brushed-brass-with-waste-included",
      "prestige-mini-mono-basin-mixer-tap-compact-chrome-mixer-with-waste-included",
      "prestige-mini-mono-basin-mixer-tap-matt-black-waste-included",
      "prestige-mono-basin-mixer-brushed-brass-with-waste",
      "prestige-mono-basin-mixer-matt-black-tap-with-matching-waste",
      "prestige-mono-basin-mixer-tap-chrome-single-lever-with-waste-included",
      "prestige-tall-mono-basin-mixer-tap-brushed-brass-finish-modern-bathroom",
      "prestige-tall-mono-basin-mixer-tap-high-rise-chrome-tap-for-countertop-basins",
      "prestige-tall-mono-basin-mixer-tap-matt-black",
      "prestige-wall-mounted-basin-mixer-modern-chrome-bathroom-tap",
      "prestige-wall-mounted-basin-mixer-tap-brushed-brass-modern-bathroom-faucet",
      "prestige-wall-mounted-basin-mixer-tap-matte-black-finish",
      "pure-mono-basin-mixer-tap-with-dual-handle-waste-included",
      "qubec-mini-mono-basin-mixer-tap-compact-chrome-finish-for-small-basins",
      "qubec-mono-basin-mixer-tap-chrome-finish-with-waste-included",
      "raldo-modern-chrome-bathroom-basin-sink-square-mixer-luxury-single-lever-tap",
      "sleek-chrome-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "sleek-matt-black-mono-basin-mixer-tap-modern-bathroom-tap-with-waste-included",
      "sleek-mini-mono-basin-mixer-tap-matt-black-bathroom-faucet-with-waste",
      "sleek-mini-mono-basin-mixer-tap-with-waste-modern-chrome-bathroom-faucet",
      "sleek-tall-basin-mono-mixer-tap-modern-bathroom-faucet-matt-black-finish",
      "sleek-tall-basin-mono-mixer-tap-modern-chrome-bathroom-sink-faucet",
      "tall-basin-mixer-tap-modern-chrome-waterfall-faucet-for-countertop-sinks",
      "tall-chrome-basin-mixer-tap-bathroom-sink-faucet-single-lever-modern-design",
      "tall-matte-black-basin-mixer-tap-modern-waterfall-design",
      "titan-basin-mono-mixer-tap-with-waste-40mm-cartridge-chrome-finish",
      "urban-desk-mounted-sensor-tap-chrome-automatic-infrared-basin-mixer",
      "urban-desk-mounted-sensor-tap-modern-touchless-infrared-basin-mixer",
      "urban-desk-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "urban-non-concussive-basin-mixer-water-saving-push-tap-chrome",
      "urban-non-concussive-basin-taps-timed-flow-push-taps-pair-chrome",
      "urban-wall-mounted-sensor-tap-automatic-chrome-touchless-basin-mixer",
      "urban-wall-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "vellamo-reveal-basin-mixer-tap-with-waste",
      "vista-mono-basin-mixer-tap-with-waste-35mm-cartridge-chrome",
      "york-traditional-mono-basin-mixer-tap-with-waste-chrome-finish",
      "zenith-mini-mono-basin-mixer-tap-matt-black-with-waste-included",
      "zenith-modern-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "zenith-mono-basin-mixer-tap-matt-black-with-waste",
      "zenith-tall-mono-basin-mixer-tap-with-modern-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-mixer-tap-with-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-shower-mixer-tap-with-waterfall-spout-shower-kit"
    ]
  },
  {
    "handle": "tall-basin-mixer-taps",
    "title": "Tall Basin Mixer Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 15,
    "description": "Shop tall basin mixer taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "cascade-tall-mono-basin-mixer-tap-brushed-brass-countertop-bathroom-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-matt-black-modern-countertop-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-modern-chrome-finish-bathroom-sink-tap",
      "charlton-matt-black-deck-mounted-mono-tall-basin-mixer-tap",
      "classic-tall-mono-basin-mixer-matt-black-traditional-countertop-bathroom-tap",
      "classic-tall-mono-basin-mixer-tap-traditional-countertop-bathroom-sink-tap",
      "prestige-tall-mono-basin-mixer-tap-brushed-brass-finish-modern-bathroom",
      "prestige-tall-mono-basin-mixer-tap-high-rise-chrome-tap-for-countertop-basins",
      "prestige-tall-mono-basin-mixer-tap-matt-black",
      "sleek-tall-basin-mono-mixer-tap-modern-bathroom-faucet-matt-black-finish",
      "sleek-tall-basin-mono-mixer-tap-modern-chrome-bathroom-sink-faucet",
      "tall-basin-mixer-tap-modern-chrome-waterfall-faucet-for-countertop-sinks",
      "tall-chrome-basin-mixer-tap-bathroom-sink-faucet-single-lever-modern-design",
      "tall-matte-black-basin-mixer-tap-modern-waterfall-design",
      "zenith-tall-mono-basin-mixer-tap-with-modern-waterfall-spout-chrome-finish"
    ]
  },
  {
    "handle": "wall-mounted-basin-taps",
    "title": "Wall Mounted Basin Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 16,
    "description": "Shop wall mounted basin taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "casa-bano-distro-wall-mounted-basin-mixer",
      "classic-wall-mounted-basin-mixer-matt-black-traditional-bathroom-sink-tap",
      "classic-wall-mounted-basin-mixer-tap-traditional-bathroom-sink-mixer-for-timeless-style",
      "eden-wall-mounted-basin-mixer-brushed-brass-luxury-tap",
      "eden-wall-mounted-basin-mixer-matt-black-modern-bathroom-tap",
      "eden-wall-mounted-basin-mixer-modern-chrome-bathroom-tap-set",
      "ergo-lever-wall-mounted-basin-mixer-chrome",
      "gio-basin-sink-mixer-tap-wall-mounted-concealed-valve-hot-and-cold-mixer-and-w",
      "origin-black-2-hole-single-lever-wall-mounted-basin-mixer-tap",
      "prestige-wall-mounted-basin-mixer-modern-chrome-bathroom-tap",
      "prestige-wall-mounted-basin-mixer-tap-brushed-brass-modern-bathroom-faucet",
      "prestige-wall-mounted-basin-mixer-tap-matte-black-finish",
      "urban-wall-mounted-sensor-tap-automatic-chrome-touchless-basin-mixer",
      "urban-wall-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "zenith-wall-mounted-basin-mixer-tap-with-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-shower-mixer-tap-with-waterfall-spout-shower-kit"
    ]
  },
  {
    "handle": "waterfall-taps",
    "title": "Waterfall Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 22,
    "description": "Shop waterfall taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "basin-taps-waterfall-with-pop-up-waste-square-bathroom-sink-mixer-taps-chrome-uk",
      "devon-bathroom-bath-shower-mixer-waterfall-style-chrome-twin-handle-tap",
      "ellena-chrome-bathroom-taps-basin-mixer-bath-filler-shower-tap-wide-waterfall",
      "freestanding-bath-shower-mixer-tap-matt-black-modern-waterfall-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-waterfall-design",
      "modern-chrome-waterfall-bath-filler-tap-dual-lever-mixer",
      "modern-chrome-waterfall-bath-filler-tap-stylish-square-basin-mixer-faucet",
      "modern-waterfall-basin-mixer-tap-chrome-finish",
      "noble-3-hole-deck-mounted-basin-mixer-tap-square-handles-waterfall-spout",
      "noble-3-hole-deck-mounted-bath-filler-tap-square-handles-waterfall-spout",
      "noble-5-hole-deck-mounted-bath-shower-mixer-waterfall-spout-with-hand-shower-kit-wall-bracket",
      "oxford-deck-mounted-bath-filler-tap-dual-handle-chrome-waterfall-spout",
      "sleek-chrome-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "tall-basin-mixer-tap-modern-chrome-waterfall-faucet-for-countertop-sinks",
      "tall-matte-black-basin-mixer-tap-modern-waterfall-design",
      "zenith-bath-filler-tap-matt-black-modern-waterfall-design",
      "zenith-modern-bath-filler-tap-with-open-waterfall-spout-chrome-finish",
      "zenith-modern-bath-filler-tap-with-waterfall-spout-chrome-finish",
      "zenith-modern-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "zenith-tall-mono-basin-mixer-tap-with-modern-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-mixer-tap-with-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-shower-mixer-tap-with-waterfall-spout-shower-kit"
    ]
  },
  {
    "handle": "bath-taps",
    "title": "Bath Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 90,
    "description": "Shop bath taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-bath-filler-tap-stylish-chrome-finish-durable-mixer-for-modern-bathtubs",
      "aqua-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "aqua-freestanding-bath-shower-mixer-modern-chrome-finish-with-handset-hose",
      "better-bathrooms-cube-freestanding-bath-shower-mixer-15032-spare-parts",
      "boston-modern-set-of-chrome-hot-cold-twin-bath-taps-deck-mounted-brass",
      "breeze-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "bristan-blitz-modern-small-basin-mixer-chrome-btz-smbas-c",
      "bristol-bath-shower-mixer-chrome-with-shower-kit-wall-bracket",
      "bristol-traditional-freestanding-bath-shower-mixer-tap-with-handheld-shower-chrome",
      "cascade-bath-filler-tap-brushed-brass-luxury-modern-bathtub-mixer-for-bathrooms",
      "cascade-bath-filler-tap-durable-chrome-finish-modern-mixer-for-bathtubs",
      "cascade-bath-filler-tap-matt-black-durable-modern-bathtub-mixer-for-bathrooms",
      "cascade-bath-shower-mixer-brushed-brass-with-shower-kit-wall-bracket-luxury-tap",
      "cascade-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-tap",
      "cascade-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "classic-bath-filler-matt-black-traditional-dual-handle-bathtub-mixer-tap",
      "classic-bath-filler-tap-traditional-dual-handle-bathtub-mixer-for-elegant-bathrooms",
      "classic-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "classic-bath-shower-mixer-tap-with-shower-kit-wall-bracket-traditional-bathtub-tap",
      "classsic-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "crystal-bath-filler-traditional-dual-handle-bathtub-mixer-tap",
      "crystal-bath-shower-mixer-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "deluxe-bath-filler-luxury-dual-handle-bathtub-mixer-tap-for-elegant-bathrooms",
      "deluxe-bath-filler-matt-black-premium-dual-handle-bathtub-mixer-tap",
      "deluxe-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-luxury-tap",
      "deluxe-bath-shower-mixer-with-shower-kit-wall-bracket-luxury-bathtub-tap",
      "descent-chrome-bath-shower-mixer-with-shower-kit",
      "eden-freestanding-bath-shower-mixer-chrome",
      "eden-freestanding-bath-shower-mixer-tap-with-handset-brushed-brass",
      "eden-freestanding-bath-shower-mixer-with-hand-shower-matt-black",
      "elite-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "elite-chrome-dual-handle-bath-filler-tap-modern-deck-mounted-mixer",
      "essence-bath-shower-mixer-shower-kit-wall-bracket-included",
      "fiona-modern-bridge-bath-filler-mixer-tap",
      "freestanding-bath-shower-mixer-tap-matt-black-modern-waterfall-design",
      "freestanding-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish-1",
      "imperial-bath-shower-mixer-shower-kit-wall-bracket-included",
      "libra-thermostatic-wall-mounted-modern-chrome-bath-shower-mixer-tap",
      "matt-black-bath-filler-mixer-tap-modern-round-twin-lever-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-modern-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-waterfall-design",
      "modern-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "modern-chrome-waterfall-bath-filler-tap-dual-lever-mixer",
      "modern-chrome-waterfall-bath-filler-tap-stylish-square-basin-mixer-faucet",
      "nes-home-kento-chrome-square-bath-filler-mixer-tap",
      "nes-home-kento-chrome-square-bath-shower-mixer-tap-with-handheld",
      "noble-3-hole-deck-mounted-bath-filler-tap-square-handles-waterfall-spout",
      "noble-5-hole-deck-mounted-bath-shower-mixer-waterfall-spout-with-hand-shower-kit-wall-bracket",
      "nuie-reef-thermostatic-bath-shower-mixer-modern-wall-mounted-faucet",
      "oxford-deck-mounted-bath-filler-tap-dual-handle-chrome-waterfall-spout",
      "oxford-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "prestige-3-hole-deck-mounted-bath-mixer-contemporary-chrome-tap-set",
      "prestige-3-hole-deck-mounted-bath-mixer-modern-matt-black-tap-set",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-modern-chrome-finish-without-hand-shower",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-with-hand-shower-modern-chrome-finish",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-matt-black-tap-set-with-handheld-shower",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-hand-shower",
      "prestige-bath-filler-brushed-brass",
      "prestige-bath-filler-tap-matte-black-finish",
      "prestige-bath-shower-mixer-matt-black-tap-with-shower-kit-wall-bracket",
      "prestige-bath-shower-mixer-with-kit-brushed-brass",
      "prestige-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "prestige-freestanding-bath-shower-mixer-matte-black-finish",
      "prestige-freestanding-bath-shower-mixer-modern-brushed-brass-faucet",
      "prestige-freestanding-bath-shower-mixer-modern-floor-mounted-tap-with-handset",
      "prestige-modern-bath-filler-tap-chrome-deck-mounted-mixer",
      "pure-bath-filler-tap-with-dual-cross-handles-chrome-finish",
      "pure-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "pure-chrome-bath-taps-set-durable-brass-pair-with-3-5-year-guarantee",
      "pure-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "qubec-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "round-bath-filler-spout-modern-wall-mounted-chrome-finish",
      "sleek-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "sleek-matt-black-bath-shower-mixer-tap-with-shower-kit-wall-bracket",
      "titan-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "vista-bath-filler-tap-modern-chrome-finish",
      "vista-bath-shower-mixer-tap-with-shower-kit-chrome-finish",
      "york-freestanding-traditional-bath-shower-mixer-tap-with-handset-chrome",
      "york-traditional-bath-filler-tap-chrome-finish",
      "york-traditional-bath-shower-mixer-tap-with-shower-kit-wall-bracket-chrome",
      "york-traditional-bath-taps-pair-chrome-finish",
      "zenith-bath-filler-tap-matt-black-modern-waterfall-design",
      "zenith-bath-shower-mixer-tap-matt-black-with-shower-kit-bracket",
      "zenith-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "zenith-freestanding-bath-shower-mixer-tap-with-handset-chrome-finish",
      "zenith-modern-bath-filler-tap-with-open-waterfall-spout-chrome-finish",
      "zenith-modern-bath-filler-tap-with-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-bath-shower-mixer-tap-with-kit-wall-bracket-chrome"
    ]
  },
  {
    "handle": "bath-filler-taps",
    "title": "Bath Filler Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 42,
    "description": "Shop bath filler taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-bath-filler-tap-stylish-chrome-finish-durable-mixer-for-modern-bathtubs",
      "bathroom-fort-round-rigid-riser-shower-kit-with-bath-filler-modern-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-with-bath-filler-chrome-finish",
      "brayton-cube-bathroom-deck-mounted-chrome-bath-filler-mixer-tap",
      "breeze-bath-filler-tap-durable-chrome-finish-modern-bathroom-mixer-for-tubs",
      "cascade-bath-filler-tap-brushed-brass-luxury-modern-bathtub-mixer-for-bathrooms",
      "cascade-bath-filler-tap-durable-chrome-finish-modern-mixer-for-bathtubs",
      "cascade-bath-filler-tap-matt-black-durable-modern-bathtub-mixer-for-bathrooms",
      "classic-bath-filler-matt-black-traditional-dual-handle-bathtub-mixer-tap",
      "classic-bath-filler-tap-traditional-dual-handle-bathtub-mixer-for-elegant-bathrooms",
      "crystal-bath-filler-traditional-dual-handle-bathtub-mixer-tap",
      "deluxe-bath-filler-luxury-dual-handle-bathtub-mixer-tap-for-elegant-bathrooms",
      "deluxe-bath-filler-matt-black-premium-dual-handle-bathtub-mixer-tap",
      "elite-chrome-dual-handle-bath-filler-tap-modern-deck-mounted-mixer",
      "ellena-chrome-bathroom-taps-basin-mixer-bath-filler-shower-tap-wide-waterfall",
      "fiona-modern-bridge-bath-filler-mixer-tap",
      "hecto-bath-filler-tap-stylish-chrome-finish-bathroom-mixer-for-modern-baths",
      "imperial-bath-shower-mixer-shower-kit-wall-bracket-included",
      "matt-black-bath-filler-mixer-tap-modern-round-twin-lever-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-modern-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-waterfall-design",
      "modern-chrome-waterfall-bath-filler-tap-dual-lever-mixer",
      "modern-chrome-waterfall-bath-filler-tap-stylish-square-basin-mixer-faucet",
      "nes-home-kento-chrome-square-bath-filler-mixer-tap",
      "noble-3-hole-deck-mounted-bath-filler-tap-square-handles-waterfall-spout",
      "oxford-deck-mounted-bath-filler-tap-dual-handle-chrome-waterfall-spout",
      "prestige-bath-filler-brushed-brass",
      "prestige-bath-filler-tap-brushed-brass-luxury-modern-bathroom-mixer",
      "prestige-bath-filler-tap-matte-black-finish",
      "prestige-modern-bath-filler-tap-chrome-deck-mounted-mixer",
      "pure-bath-filler-tap-with-dual-cross-handles-chrome-finish",
      "rectangular-bath-filler-spout-wall-mounted-chrome-bathroom-tap",
      "round-bath-filler-spout-modern-wall-mounted-chrome-finish",
      "sleek-bath-filler-tap-modern-matt-black-bathroom-mixer-for-bathtubs",
      "sleek-modern-bath-filler-tap-chrome-finish-dual-lever-mixer-for-bathroom",
      "square-modern-chrome-bathroom-bath-filler-mixer",
      "titan-bath-filler-mixer-tap-dual-handle-chrome-finish-bathroom-faucet",
      "vista-bath-filler-tap-modern-chrome-finish",
      "york-traditional-bath-filler-tap-chrome-finish",
      "zenith-bath-filler-tap-matt-black-modern-waterfall-design",
      "zenith-modern-bath-filler-tap-with-open-waterfall-spout-chrome-finish",
      "zenith-modern-bath-filler-tap-with-waterfall-spout-chrome-finish"
    ]
  },
  {
    "handle": "bath-shower-mixer-taps",
    "title": "Bath Shower Mixer Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 58,
    "description": "Shop bath shower mixer taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "aqua-freestanding-bath-shower-mixer-modern-chrome-finish-with-handset-hose",
      "better-bathrooms-cube-freestanding-bath-shower-mixer-15032-spare-parts",
      "breeze-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "bristol-bath-shower-mixer-chrome-with-shower-kit-wall-bracket",
      "bristol-traditional-freestanding-bath-shower-mixer-tap-with-handheld-shower-chrome",
      "cascade-bath-shower-mixer-brushed-brass-with-shower-kit-wall-bracket-luxury-tap",
      "cascade-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-tap",
      "cascade-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "chrome-bathroom-basin-mixer-tap-bath-shower-mixer-tap-waste",
      "classic-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "classic-bath-shower-mixer-tap-with-shower-kit-wall-bracket-traditional-bathtub-tap",
      "classsic-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "crystal-bath-shower-mixer-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "deluxe-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-luxury-tap",
      "deluxe-bath-shower-mixer-with-shower-kit-wall-bracket-luxury-bathtub-tap",
      "descent-chrome-bath-shower-mixer-with-shower-kit",
      "devon-bathroom-bath-shower-mixer-waterfall-style-chrome-twin-handle-tap",
      "eden-freestanding-bath-shower-mixer-chrome",
      "eden-freestanding-bath-shower-mixer-tap-with-handset-brushed-brass",
      "eden-freestanding-bath-shower-mixer-with-hand-shower-matt-black",
      "elite-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "ellena-chrome-bathroom-taps-basin-mixer-bath-filler-shower-tap-wide-waterfall",
      "essence-bath-shower-mixer-shower-kit-wall-bracket-included",
      "freestanding-bath-shower-mixer-tap-matt-black-modern-waterfall-design",
      "freestanding-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish-1",
      "imperial-bath-shower-mixer-shower-kit-wall-bracket-included",
      "libra-thermostatic-wall-mounted-modern-chrome-bath-shower-mixer-tap",
      "modern-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "nes-home-kento-chrome-square-bath-shower-mixer-tap-with-handheld",
      "noble-5-hole-deck-mounted-bath-shower-mixer-waterfall-spout-with-hand-shower-kit-wall-bracket",
      "nuie-reef-thermostatic-bath-shower-mixer-modern-wall-mounted-faucet",
      "oxford-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-modern-chrome-finish-without-hand-shower",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-with-hand-shower-modern-chrome-finish",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-matt-black-tap-set-with-handheld-shower",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-hand-shower",
      "prestige-bath-shower-mixer-matt-black-tap-with-shower-kit-wall-bracket",
      "prestige-bath-shower-mixer-with-kit-brushed-brass",
      "prestige-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "prestige-freestanding-bath-shower-mixer-matte-black-finish",
      "prestige-freestanding-bath-shower-mixer-modern-brushed-brass-faucet",
      "prestige-freestanding-bath-shower-mixer-modern-floor-mounted-tap-with-handset",
      "pure-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "pure-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "qubec-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "sleek-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "sleek-matt-black-bath-shower-mixer-tap-with-shower-kit-wall-bracket",
      "titan-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "vista-bath-shower-mixer-tap-with-shower-kit-chrome-finish",
      "york-freestanding-traditional-bath-shower-mixer-tap-with-handset-chrome",
      "york-traditional-bath-shower-mixer-tap-with-shower-kit-wall-bracket-chrome",
      "zenith-bath-shower-mixer-tap-matt-black-with-shower-kit-bracket",
      "zenith-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "zenith-freestanding-bath-shower-mixer-tap-with-handset-chrome-finish",
      "zenith-wall-mounted-bath-shower-mixer-tap-with-kit-wall-bracket-chrome"
    ]
  },
  {
    "handle": "freestanding-bath-taps",
    "title": "Freestanding Bath Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 15,
    "description": "Shop freestanding bath taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-freestanding-bath-shower-mixer-modern-chrome-finish-with-handset-hose",
      "better-bathrooms-cube-freestanding-bath-shower-mixer-15032-spare-parts",
      "breeze-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "bristol-traditional-freestanding-bath-shower-mixer-tap-with-handheld-shower-chrome",
      "eden-freestanding-bath-shower-mixer-chrome",
      "eden-freestanding-bath-shower-mixer-tap-with-handset-brushed-brass",
      "eden-freestanding-bath-shower-mixer-with-hand-shower-matt-black",
      "freestanding-bath-shower-mixer-tap-matt-black-modern-waterfall-design",
      "freestanding-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "prestige-freestanding-bath-shower-mixer-matte-black-finish",
      "prestige-freestanding-bath-shower-mixer-modern-brushed-brass-faucet",
      "prestige-freestanding-bath-shower-mixer-modern-floor-mounted-tap-with-handset",
      "pure-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "york-freestanding-traditional-bath-shower-mixer-tap-with-handset-chrome",
      "zenith-freestanding-bath-shower-mixer-tap-with-handset-chrome-finish"
    ]
  },
  {
    "handle": "commercial-taps",
    "title": "Commercial Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 1,
    "description": "Shop commercial taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "commercial-pull-out-kitchen-tap-spring-coil-mixer-faucet-with-spray-head"
    ]
  },
  {
    "handle": "kitchen-taps",
    "title": "Kitchen Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 32,
    "description": "Shop kitchen taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "3-in-1-instant-boiling-water-filter-kitchen-tap-with-heating-tank",
      "3-in-1-instant-boiling-water-filter-kitchen-tap-with-heating-tank-filter",
      "commercial-pull-out-kitchen-tap-spring-coil-mixer-faucet-with-spray-head",
      "modern-pull-out-kitchen-tap-chrome-finish-sink-mixer-faucet-with-spray",
      "modern-single-handle-kitchen-faucet-chrome-high-arc-swivel-sink-tap",
      "modern-single-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "modern-single-handle-kitchen-sink-faucet-sleek-chrome-mixer-tap",
      "premium-pull-out-kitchen-tap-modern-chrome-finish-mixer-faucet-for-sink",
      "pull-out-hose-kitchen-tap-chrome-flexible-sink-mixer-faucet-with-spray",
      "pull-out-kitchen-tap-chrome-sink-mixer-faucet-with-dual-handles-spray",
      "pull-out-single-handle-kitchen-faucet-brushed-brass-luxury-mixer-tap",
      "pull-out-single-handle-kitchen-faucet-brushed-stainless-steel-mixer-tap",
      "pull-out-single-handle-kitchen-faucet-matt-black-modern-mixer-tap",
      "single-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "single-handle-kitchen-tap-brushed-brass-modern-mixer",
      "single-handle-kitchen-tap-brushed-stainless-steel-modern-mixer",
      "single-handle-kitchen-tap-matt-black-modern-mixer",
      "swivel-spout-kitchen-tap-stainless-steel-mixer-faucet-with-pull-down-spray",
      "twin-handle-kitchen-mixer-tap-brushed-stainless-steel-swivel-spout-faucet",
      "twin-handle-kitchen-mixer-tap-chrome-crosshead-levers-with-swivel-spout",
      "twin-handle-kitchen-mixer-tap-chrome-deck-mounted-with-swivel-spout",
      "twin-handle-kitchen-mixer-tap-chrome-finish-with-360-swivel-spout-faucet",
      "twin-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "twin-handle-kitchen-tap-brushed-brass-traditional-mixer",
      "twin-handle-kitchen-tap-brushed-copper-with-white-levers",
      "twin-handle-kitchen-tap-brushed-nickel-swivel-spout-mixer",
      "twin-handle-kitchen-tap-chrome-cross-handle-swivel-spout",
      "twin-handle-kitchen-tap-chrome-lever-handle-swivel-spout",
      "twin-handle-kitchen-tap-classic-chrome-with-white-levers",
      "twin-handle-kitchen-tap-matt-black-modern-swivel-spout",
      "twin-handle-kitchen-tap-matt-black-with-white-levers",
      "twin-handle-kitchen-tap-modern-swivel-spout-mixer"
    ]
  },
  {
    "handle": "chrome-taps",
    "title": "Chrome Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 128,
    "description": "Shop chrome taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "aqua-bath-filler-tap-stylish-chrome-finish-durable-mixer-for-modern-bathtubs",
      "aqua-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "aqua-bath-taps-pair-of-modern-chrome-finish-bathroom-taps-for-bathtubs",
      "aqua-bath-taps-pair-of-modern-chrome-finish-bathroom-taps-for-bathtubs-1",
      "aqua-freestanding-bath-shower-mixer-modern-chrome-finish-with-handset-hose",
      "aqua-mono-basin-mixer-tap-with-waste-modern-chrome-finish-bathroom-sink-tap",
      "basin-taps-waterfall-with-pop-up-waste-square-bathroom-sink-mixer-taps-chrome-uk",
      "bathroom-fort-round-rigid-riser-shower-kit-with-bath-filler-modern-chrome-finish",
      "bathroom-fort-square-rigid-riser-shower-kit-with-bath-filler-chrome-finish",
      "boston-bathroom-basin-sink-mono-mixer-tap-chrome-solid-brass-ceramic-discs",
      "boston-modern-set-of-chrome-hot-cold-twin-bath-taps-deck-mounted-brass",
      "brayton-cube-bathroom-deck-mounted-chrome-bath-filler-mixer-tap",
      "breeze-basin-taps-pair-of-chrome-finish-modern-bathroom-sink-taps",
      "breeze-bath-filler-tap-durable-chrome-finish-modern-bathroom-mixer-for-tubs",
      "breeze-bath-taps-pair-of-chrome-finish-modern-bathroom-taps-for-bathtubs",
      "breeze-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "bristan-blitz-modern-small-basin-mixer-chrome-btz-smbas-c",
      "bristol-basin-taps-traditional-chrome-bathroom-sink-taps-pair",
      "bristol-bath-shower-mixer-chrome-with-shower-kit-wall-bracket",
      "bristol-bath-taps-traditional-chrome-hot-cold-bathroom-taps-pair",
      "bristol-mono-basin-mixer-tap-with-waste-modern-chrome-bathroom-faucet",
      "bristol-traditional-freestanding-bath-shower-mixer-tap-with-handheld-shower-chrome",
      "cascade-bath-filler-tap-durable-chrome-finish-modern-mixer-for-bathtubs",
      "cascade-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish-tap",
      "cascade-mono-basin-mixer-tap-with-waste-chrome-finish-modern-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-modern-chrome-finish-bathroom-sink-tap",
      "chrome-bathroom-basin-mixer-tap-bath-shower-mixer-tap-waste",
      "descent-chrome-bath-shower-mixer-with-shower-kit",
      "devon-bathroom-bath-shower-mixer-waterfall-style-chrome-twin-handle-tap",
      "eden-freestanding-bath-shower-mixer-chrome",
      "eden-wall-mounted-basin-mixer-modern-chrome-bathroom-tap-set",
      "elite-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "elite-chrome-dual-handle-bath-filler-tap-modern-deck-mounted-mixer",
      "elite-chrome-mono-basin-mixer-tap-modern-single-lever-with-waste",
      "ellena-chrome-bathroom-taps-basin-mixer-bath-filler-shower-tap-wide-waterfall",
      "ergo-lever-wall-mounted-basin-mixer-chrome",
      "fray-basin-mono-tap-with-clicker-waste-in-chrome",
      "freestanding-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "hecto-bath-filler-tap-stylish-chrome-finish-bathroom-mixer-for-modern-baths",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish",
      "hecto-bath-shower-mixer-with-shower-kit-wall-bracket-durable-chrome-finish-1",
      "hecto-mono-basin-mixer-tap-with-waste-modern-chrome-finish-bathroom-sink-mixer",
      "libra-thermostatic-wall-mounted-modern-chrome-bath-shower-mixer-tap",
      "medical-basin-mono-tap-with-extended-lever-chrome-finish",
      "modern-bath-shower-mixer-tap-with-handheld-chrome-finish",
      "modern-chrome-waterfall-bath-filler-tap-dual-lever-mixer",
      "modern-chrome-waterfall-bath-filler-tap-stylish-square-basin-mixer-faucet",
      "modern-pull-out-kitchen-tap-chrome-finish-sink-mixer-faucet-with-spray",
      "modern-single-handle-kitchen-faucet-chrome-high-arc-swivel-sink-tap",
      "modern-single-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "modern-single-handle-kitchen-sink-faucet-sleek-chrome-mixer-tap",
      "modern-waterfall-basin-mixer-tap-chrome-finish",
      "mono-basin-mixer-tap-with-waste-stylish-chrome-finish-bathroom-sink-mixer",
      "nes-home-kento-chrome-square-bath-filler-mixer-tap",
      "nes-home-kento-chrome-square-bath-shower-mixer-tap-with-handheld",
      "oxford-deck-mounted-bath-filler-tap-dual-handle-chrome-waterfall-spout",
      "oxford-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "oxford-mini-mono-basin-mixer-tap-compact-chrome-tap-with-waste-included",
      "oxford-mono-basin-mixer-tap-chrome-single-lever-with-waste-included",
      "pair-of-modern-basin-pillar-taps-chrome-finish",
      "premium-pull-out-kitchen-tap-modern-chrome-finish-mixer-faucet-for-sink",
      "prestige-3-hole-deck-mounted-bath-mixer-contemporary-chrome-tap-set",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-modern-chrome-finish-without-hand-shower",
      "prestige-3-hole-deck-mounted-bath-mixer-tap-with-hand-shower-modern-chrome-finish",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-hand-shower",
      "prestige-deck-mounted-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "prestige-mini-mono-basin-mixer-tap-compact-chrome-mixer-with-waste-included",
      "prestige-modern-bath-filler-tap-chrome-deck-mounted-mixer",
      "prestige-mono-basin-mixer-tap-chrome-single-lever-with-waste-included",
      "prestige-tall-mono-basin-mixer-tap-high-rise-chrome-tap-for-countertop-basins",
      "prestige-wall-mounted-basin-mixer-modern-chrome-bathroom-tap",
      "pull-out-hose-kitchen-tap-chrome-flexible-sink-mixer-faucet-with-spray",
      "pull-out-kitchen-tap-chrome-sink-mixer-faucet-with-dual-handles-spray",
      "pure-basin-taps-pair-with-cross-handles-chrome-finish",
      "pure-bath-filler-tap-with-dual-cross-handles-chrome-finish",
      "pure-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "pure-chrome-bath-taps-set-durable-brass-pair-with-3-5-year-guarantee",
      "pure-freestanding-bath-shower-mixer-chrome-floor-mounted-tap-with-handset",
      "qubec-bath-shower-mixer-tap-chrome-finish-with-shower-kit-wall-bracket",
      "qubec-mini-mono-basin-mixer-tap-compact-chrome-finish-for-small-basins",
      "qubec-mono-basin-mixer-tap-chrome-finish-with-waste-included",
      "raldo-modern-chrome-bathroom-basin-sink-square-mixer-luxury-single-lever-tap",
      "rectangular-bath-filler-spout-wall-mounted-chrome-bathroom-tap",
      "round-bath-filler-spout-modern-wall-mounted-chrome-finish",
      "single-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "sleek-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "sleek-chrome-mono-basin-mixer-tap-with-waterfall-spout-waste-included",
      "sleek-mini-mono-basin-mixer-tap-with-waste-modern-chrome-bathroom-faucet",
      "sleek-modern-bath-filler-tap-chrome-finish-dual-lever-mixer-for-bathroom",
      "sleek-tall-basin-mono-mixer-tap-modern-chrome-bathroom-sink-faucet",
      "square-modern-chrome-bathroom-bath-filler-mixer",
      "tall-basin-mixer-tap-modern-chrome-waterfall-faucet-for-countertop-sinks",
      "tall-chrome-basin-mixer-tap-bathroom-sink-faucet-single-lever-modern-design",
      "titan-basin-mono-mixer-tap-with-waste-40mm-cartridge-chrome-finish",
      "titan-basin-taps-chrome-hot-cold-water-bathroom-tap-set",
      "titan-bath-filler-mixer-tap-dual-handle-chrome-finish-bathroom-faucet",
      "titan-bath-shower-mixer-with-shower-kit-wall-bracket-chrome-finish",
      "titan-bath-taps-modern-chrome-basin-taps-set-hot-cold-water",
      "twin-handle-kitchen-mixer-tap-chrome-crosshead-levers-with-swivel-spout",
      "twin-handle-kitchen-mixer-tap-chrome-deck-mounted-with-swivel-spout",
      "twin-handle-kitchen-mixer-tap-chrome-finish-with-360-swivel-spout-faucet",
      "twin-handle-kitchen-mixer-tap-chrome-swivel-spout-sink-faucet",
      "twin-handle-kitchen-tap-chrome-cross-handle-swivel-spout",
      "twin-handle-kitchen-tap-chrome-lever-handle-swivel-spout",
      "twin-handle-kitchen-tap-classic-chrome-with-white-levers",
      "urban-desk-mounted-sensor-tap-chrome-automatic-infrared-basin-mixer",
      "urban-desk-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "urban-non-concussive-basin-mixer-water-saving-push-tap-chrome",
      "urban-non-concussive-basin-taps-timed-flow-push-taps-pair-chrome",
      "urban-wall-mounted-sensor-tap-automatic-chrome-touchless-basin-mixer",
      "urban-wall-mounted-sensor-tap-touchless-chrome-automatic-basin-mixer",
      "vista-bath-filler-tap-modern-chrome-finish",
      "vista-bath-shower-mixer-tap-with-shower-kit-chrome-finish",
      "vista-mono-basin-mixer-tap-with-waste-35mm-cartridge-chrome",
      "wasserrhythm-basin-taps-square-bathroom-sink-taps-mixers-chrome-brass-monobloc",
      "york-freestanding-traditional-bath-shower-mixer-tap-with-handset-chrome",
      "york-traditional-basin-taps-pair-chrome-finish",
      "york-traditional-bath-filler-tap-chrome-finish",
      "york-traditional-bath-shower-mixer-tap-with-shower-kit-wall-bracket-chrome",
      "york-traditional-bath-taps-pair-chrome-finish",
      "york-traditional-mono-basin-mixer-tap-with-waste-chrome-finish",
      "zenith-chrome-bath-shower-mixer-tap-with-handheld-shower-kit-wall-bracket",
      "zenith-freestanding-bath-shower-mixer-tap-with-handset-chrome-finish",
      "zenith-modern-bath-filler-tap-with-open-waterfall-spout-chrome-finish",
      "zenith-modern-bath-filler-tap-with-waterfall-spout-chrome-finish",
      "zenith-tall-mono-basin-mixer-tap-with-modern-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-basin-mixer-tap-with-waterfall-spout-chrome-finish",
      "zenith-wall-mounted-bath-shower-mixer-tap-with-kit-wall-bracket-chrome"
    ]
  },
  {
    "handle": "black-taps",
    "title": "Black Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 51,
    "description": "Shop black taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "cascade-bath-filler-tap-matt-black-durable-modern-bathtub-mixer-for-bathrooms",
      "cascade-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-tap",
      "cascade-mini-mono-basin-mixer-tap-matt-black-with-waste-compact-sink-tap",
      "cascade-mono-basin-mixer-tap-matt-black-with-waste-modern-bathroom-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-matt-black-modern-countertop-sink-tap",
      "charlton-matt-black-deck-mounted-mono-tall-basin-mixer-tap",
      "classic-bath-filler-matt-black-traditional-dual-handle-bathtub-mixer-tap",
      "classic-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-modern-bathtub-tap",
      "classic-mini-mono-basin-mixer-matt-black-with-waste-cloakroom-sink-tap",
      "classic-mono-basin-mixer-matt-black-with-waste-traditional-bathroom-sink-tap",
      "classic-tall-mono-basin-mixer-matt-black-traditional-countertop-bathroom-tap",
      "classic-wall-mounted-basin-mixer-matt-black-traditional-bathroom-sink-tap",
      "classsic-bath-shower-mixer-matt-black-shower-kit-wall-bracket-included",
      "classsic-mini-mono-basin-mixer-matt-black-waste-included",
      "classsic-mono-basin-mixer-matt-black-waste-included",
      "deluxe-bath-filler-matt-black-premium-dual-handle-bathtub-mixer-tap",
      "deluxe-bath-shower-mixer-matt-black-with-shower-kit-wall-bracket-luxury-tap",
      "deluxe-mono-basin-mixer-matt-black-with-waste-luxury-bathroom-sink-tap",
      "eclipse-contemporary-matte-black-basin-sink-mono-mixer-tap",
      "eden-freestanding-bath-shower-mixer-with-hand-shower-matt-black",
      "eden-wall-mounted-basin-mixer-matt-black-modern-bathroom-tap",
      "essence-mini-mono-basin-mixer-matt-black-waste-included",
      "essence-mono-basin-mixer-matt-black-waste-included",
      "freestanding-bath-shower-mixer-tap-matt-black-modern-waterfall-design",
      "matt-black-bath-filler-mixer-tap-modern-round-twin-lever-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-modern-design",
      "matte-black-bath-filler-mixer-tap-dual-lever-waterfall-design",
      "origin-black-2-hole-single-lever-wall-mounted-basin-mixer-tap",
      "prestige-3-hole-deck-mounted-bath-mixer-modern-matt-black-tap-set",
      "prestige-4-hole-deck-mounted-bath-shower-mixer-matt-black-tap-set-with-handheld-shower",
      "prestige-bath-filler-tap-matte-black-finish",
      "prestige-bath-shower-mixer-matt-black-tap-with-shower-kit-wall-bracket",
      "prestige-freestanding-bath-shower-mixer-matte-black-finish",
      "prestige-mini-mono-basin-mixer-tap-matt-black-waste-included",
      "prestige-mono-basin-mixer-matt-black-tap-with-matching-waste",
      "prestige-tall-mono-basin-mixer-tap-matt-black",
      "prestige-wall-mounted-basin-mixer-tap-matte-black-finish",
      "pull-out-single-handle-kitchen-faucet-matt-black-modern-mixer-tap",
      "single-handle-kitchen-tap-matt-black-modern-mixer",
      "sleek-bath-filler-tap-modern-matt-black-bathroom-mixer-for-bathtubs",
      "sleek-matt-black-bath-shower-mixer-tap-with-shower-kit-wall-bracket",
      "sleek-matt-black-mono-basin-mixer-tap-modern-bathroom-tap-with-waste-included",
      "sleek-mini-mono-basin-mixer-tap-matt-black-bathroom-faucet-with-waste",
      "sleek-tall-basin-mono-mixer-tap-modern-bathroom-faucet-matt-black-finish",
      "tall-matte-black-basin-mixer-tap-modern-waterfall-design",
      "twin-handle-kitchen-tap-matt-black-modern-swivel-spout",
      "twin-handle-kitchen-tap-matt-black-with-white-levers",
      "zenith-bath-filler-tap-matt-black-modern-waterfall-design",
      "zenith-bath-shower-mixer-tap-matt-black-with-shower-kit-bracket",
      "zenith-mini-mono-basin-mixer-tap-matt-black-with-waste-included",
      "zenith-mono-basin-mixer-tap-matt-black-with-waste"
    ]
  },
  {
    "handle": "brushed-brass-taps",
    "title": "Brushed Brass Taps",
    "parentCategory": "Taps & Mixers",
    "productCount": 25,
    "description": "Shop brushed brass taps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "boston-bathroom-basin-sink-mono-mixer-tap-chrome-solid-brass-ceramic-discs",
      "boston-modern-set-of-chrome-hot-cold-twin-bath-taps-deck-mounted-brass",
      "cascade-bath-filler-tap-brushed-brass-luxury-modern-bathtub-mixer-for-bathrooms",
      "cascade-bath-shower-mixer-brushed-brass-with-shower-kit-wall-bracket-luxury-tap",
      "cascade-mini-mono-basin-mixer-tap-brushed-brass-with-waste-cloakroom-sink-tap",
      "cascade-mini-mono-basin-mixer-tap-brushed-brass-with-waste-compact-sink-tap",
      "cascade-mono-basin-mixer-tap-brushed-brass-with-waste-luxury-bathroom-sink-tap",
      "cascade-tall-mono-basin-mixer-tap-brushed-brass-countertop-bathroom-sink-tap",
      "deck-mounted-bath-pillar-modern-bathroom-tap-fixture-stainless-steel-brass",
      "deck-mounted-bath-pillar-modern-bathroom-tap-fixture-stainless-steel-brass-1",
      "eden-freestanding-bath-shower-mixer-tap-with-handset-brushed-brass",
      "eden-wall-mounted-basin-mixer-brushed-brass-luxury-tap",
      "prestige-bath-filler-brushed-brass",
      "prestige-bath-filler-tap-brushed-brass-luxury-modern-bathroom-mixer",
      "prestige-bath-shower-mixer-with-kit-brushed-brass",
      "prestige-freestanding-bath-shower-mixer-modern-brushed-brass-faucet",
      "prestige-mini-mono-basin-mixer-tap-brushed-brass-with-waste-included",
      "prestige-mono-basin-mixer-brushed-brass-with-waste",
      "prestige-tall-mono-basin-mixer-tap-brushed-brass-finish-modern-bathroom",
      "prestige-wall-mounted-basin-mixer-tap-brushed-brass-modern-bathroom-faucet",
      "pull-out-single-handle-kitchen-faucet-brushed-brass-luxury-mixer-tap",
      "pure-chrome-bath-taps-set-durable-brass-pair-with-3-5-year-guarantee",
      "single-handle-kitchen-tap-brushed-brass-modern-mixer",
      "twin-handle-kitchen-tap-brushed-brass-traditional-mixer",
      "wasserrhythm-basin-taps-square-bathroom-sink-taps-mixers-chrome-brass-monobloc"
    ]
  },
  {
    "handle": "wastes",
    "title": "Wastes",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 44,
    "description": "Shop wastes at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "90mm-black-top-fast-flow-shower-tray-waste",
      "90mm-brushed-brass-top-fast-flow-shower-tray-waste",
      "90mm-chrome-top-fast-flow-shower-tray-waste",
      "basic-bottle-trap-brushed-brass-finish-for-modern-washbasins",
      "basic-bottle-trap-chrome-finish-durable-sink-waste-pipe-fitting",
      "basic-matt-black-bottle-trap-sleek-finish-for-washbasins",
      "flat-dome-slotted-sprung-basin-waste-chrome-finish-push-click",
      "flat-dome-slotted-sprung-basin-waste-matt-black-push-click-design",
      "minimalist-bottle-trap-brushed-brass-finish-for-modern-bathrooms",
      "minimalist-bottle-trap-chrome-finish-modern-basin-sink-waste-fitting",
      "minimalist-matt-black-bottle-trap-sleek-modern-basin-waste",
      "premium-square-bottle-trap-chrome-finish-bathroom-sink-waste",
      "quarter-circle-corner-countertop-or-hung-basin-waste-fixing-kit-not-included",
      "quarter-circle-corner-countertop-or-hung-basin-waste-fixing-kit-not-included-1",
      "retainer-bath-waste-with-brass-plug-ball-chain-chrome-finish",
      "round-bath-filler-overflow-kit-brushed-brass-with-integrated-waste",
      "round-bath-filler-overflow-kit-chrome-finish-with-integrated-waste",
      "round-bath-filler-overflow-kit-matt-black-with-integrated-waste",
      "round-bath-pop-up-sprung-waste-overflow-chrome-finish",
      "round-bath-sprung-waste-overflow-polished-chrome-black-finish",
      "round-dome-slotted-basin-waste-chrome-push-click-for-overflow-sinks",
      "round-dome-slotted-sprung-basin-waste-brushed-brass-finish",
      "round-dome-slotted-sprung-basin-waste-chrome-push-click-overflow",
      "round-dome-slotted-sprung-basin-waste-matt-black-finish-push-click",
      "round-dome-unslotted-sprung-basin-waste-brushed-brass-finish",
      "round-dome-unslotted-sprung-basin-waste-chrome-push-click-design",
      "round-dome-unslotted-sprung-basin-waste-matt-black-push-click",
      "round-easy-clean-bath-sprung-waste-overflow-chrome-finish",
      "round-easy-clean-bath-sprung-waste-overflow-matt-black-finish",
      "round-flip-basin-waste-slotted-design-for-overflow-basins",
      "round-flip-basin-waste-unslotted-design-for-non-overflow-basins",
      "round-slotted-easy-clean-basin-waste-chrome-finish-push-click-design",
      "round-slotted-plug-chain-basin-waste-chrome-for-overflow-basins",
      "slotted-basin-pop-up-waste-with-lever-chrome-finish",
      "square-bath-filler-overflow-kit-chrome-with-integrated-waste",
      "square-bath-filler-overflow-kit-matt-black-finish",
      "square-bath-sprung-waste-overflow-chrome-black-modern-finish",
      "square-matt-black-bottle-trap-premium-basin-waste-fitting",
      "square-slotted-sprung-basin-waste-chrome-finish-push-click-design",
      "square-unslotted-sprung-basin-waste-chrome-finish-for-modern-sinks",
      "triangle-corner-countertop-or-wall-hung-basin-waste-fixing-kit-not-included",
      "universal-basin-waste-brushed-brass-finish-for-all-basin-types",
      "universal-basin-waste-chrome-finish-for-all-basin-types",
      "universal-basin-waste-matt-black-for-slotted-unslotted-basins"
    ]
  },
  {
    "handle": "basin-wastes",
    "title": "Basin Wastes",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 32,
    "description": "Shop basin wastes at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "flat-dome-slotted-sprung-basin-waste-chrome-finish-push-click",
      "flat-dome-slotted-sprung-basin-waste-matt-black-push-click-design",
      "minimalist-bottle-trap-chrome-finish-modern-basin-sink-waste-fitting",
      "minimalist-matt-black-bottle-trap-sleek-modern-basin-waste",
      "quarter-circle-corner-countertop-or-hung-basin-waste-fixing-kit-not-included",
      "quarter-circle-corner-countertop-or-hung-basin-waste-fixing-kit-not-included-1",
      "round-bath-filler-overflow-kit-brushed-brass-with-integrated-waste",
      "round-bath-filler-overflow-kit-chrome-finish-with-integrated-waste",
      "round-bath-filler-overflow-kit-matt-black-with-integrated-waste",
      "round-bath-sprung-waste-overflow-polished-chrome-black-finish",
      "round-dome-slotted-basin-waste-chrome-push-click-for-overflow-sinks",
      "round-dome-slotted-sprung-basin-waste-brushed-brass-finish",
      "round-dome-slotted-sprung-basin-waste-chrome-push-click-overflow",
      "round-dome-slotted-sprung-basin-waste-matt-black-finish-push-click",
      "round-dome-unslotted-sprung-basin-waste-brushed-brass-finish",
      "round-dome-unslotted-sprung-basin-waste-chrome-push-click-design",
      "round-dome-unslotted-sprung-basin-waste-matt-black-push-click",
      "round-easy-clean-bath-sprung-waste-overflow-matt-black-finish",
      "round-flip-basin-waste-slotted-design-for-overflow-basins",
      "round-flip-basin-waste-unslotted-design-for-non-overflow-basins",
      "round-slotted-easy-clean-basin-waste-chrome-finish-push-click-design",
      "round-slotted-plug-chain-basin-waste-chrome-for-overflow-basins",
      "slotted-basin-pop-up-waste-with-lever-chrome-finish",
      "square-bath-filler-overflow-kit-chrome-with-integrated-waste",
      "square-bath-filler-overflow-kit-matt-black-finish",
      "square-matt-black-bottle-trap-premium-basin-waste-fitting",
      "square-slotted-sprung-basin-waste-chrome-finish-push-click-design",
      "square-unslotted-sprung-basin-waste-chrome-finish-for-modern-sinks",
      "triangle-corner-countertop-or-wall-hung-basin-waste-fixing-kit-not-included",
      "universal-basin-waste-brushed-brass-finish-for-all-basin-types",
      "universal-basin-waste-chrome-finish-for-all-basin-types",
      "universal-basin-waste-matt-black-for-slotted-unslotted-basins"
    ]
  },
  {
    "handle": "bath-wastes",
    "title": "Bath Wastes",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 11,
    "description": "Shop bath wastes at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "retainer-bath-waste-with-brass-plug-ball-chain-chrome-finish",
      "round-bath-filler-overflow-kit-brushed-brass-with-integrated-waste",
      "round-bath-filler-overflow-kit-chrome-finish-with-integrated-waste",
      "round-bath-filler-overflow-kit-matt-black-with-integrated-waste",
      "round-bath-pop-up-sprung-waste-overflow-chrome-finish",
      "round-bath-sprung-waste-overflow-polished-chrome-black-finish",
      "round-easy-clean-bath-sprung-waste-overflow-chrome-finish",
      "round-easy-clean-bath-sprung-waste-overflow-matt-black-finish",
      "square-bath-filler-overflow-kit-chrome-with-integrated-waste",
      "square-bath-filler-overflow-kit-matt-black-finish",
      "square-bath-sprung-waste-overflow-chrome-black-modern-finish"
    ]
  },
  {
    "handle": "shower-wastes",
    "title": "Shower Wastes",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 3,
    "description": "Shop shower wastes at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "90mm-black-top-fast-flow-shower-tray-waste",
      "90mm-brushed-brass-top-fast-flow-shower-tray-waste",
      "90mm-chrome-top-fast-flow-shower-tray-waste"
    ]
  },
  {
    "handle": "shower-tray-wastes",
    "title": "Shower Tray Wastes",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 3,
    "description": "Shop shower tray wastes at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "90mm-black-top-fast-flow-shower-tray-waste",
      "90mm-brushed-brass-top-fast-flow-shower-tray-waste",
      "90mm-chrome-top-fast-flow-shower-tray-waste"
    ]
  },
  {
    "handle": "bottle-traps",
    "title": "Bottle Traps",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 8,
    "description": "Shop bottle traps at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "basic-bottle-trap-brushed-brass-finish-for-modern-washbasins",
      "basic-bottle-trap-chrome-finish-durable-sink-waste-pipe-fitting",
      "basic-matt-black-bottle-trap-sleek-finish-for-washbasins",
      "minimalist-bottle-trap-brushed-brass-finish-for-modern-bathrooms",
      "minimalist-bottle-trap-chrome-finish-modern-basin-sink-waste-fitting",
      "minimalist-matt-black-bottle-trap-sleek-modern-basin-waste",
      "premium-square-bottle-trap-chrome-finish-bathroom-sink-waste",
      "square-matt-black-bottle-trap-premium-basin-waste-fitting"
    ]
  },
  {
    "handle": "outlet-elbows",
    "title": "Outlet Elbows",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 6,
    "description": "Shop outlet elbows at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "matt-black-douche-handset-with-hose-wall-bracket-outlet-elbow-bathroom-kit",
      "premium-douche-handset-with-hose-wall-bracket-outlet-elbow-chrome-finish",
      "round-outlet-elbow-chrome-plumbing-pipe-connector-bathroom-kitchen-fitting",
      "round-shower-outlet-elbow-matte-black-wall-mounted-connector",
      "square-shower-outlet-elbow-chrome-wall-mounted-hand-shower-connector",
      "square-wall-mounted-shower-outlet-elbow-matte-black-brass-connector"
    ]
  },
  {
    "handle": "siphons",
    "title": "Siphons",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 2,
    "description": "Shop siphons at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "infra-red-sensor-hand-sensor-flow-flush-set-siphon",
      "infra-red-sensor-hand-sensor-flow-flush-set-siphon-1"
    ]
  },
  {
    "handle": "fixing-kits",
    "title": "Fixing Kits",
    "parentCategory": "Wastes & Plumbing",
    "productCount": 24,
    "description": "Shop fixing kits at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "angled-floor-wc-toilet-pan-side-bidet-fixing-fitting-kit",
      "bath-panel-clips-with-screws-set-of-6-secure-fixing-kit",
      "countertop-or-wall-hung-basin-310w-x-170h-x430d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-330w-x120h-x290d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-330w-x120h-x290d-waste-fixing-kit-not-included-1",
      "countertop-or-wall-hung-basin-370w-x110h-x270d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-380w-x-130h-x380d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-410w-x150h-x-410d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-420w-x135h-x320d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-450w-x-160h-x580d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-450w-x-165h-x270d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-450w-x160h-x-570d-waste-fixing-kit-not-included",
      "countertop-or-wall-hung-basin-left-handed-waste-fixing-kit-not-include",
      "countertop-or-wall-hung-basin-right-handed-waste-fixing-kit-not-included",
      "mini-bar-valve-fixing-kit-plate-brushed-brass-shower-bar-valve-support",
      "mini-bar-valve-fixing-kit-plate-brushed-brass-shower-bar-valve-support-1",
      "mini-bar-valve-fixing-kit-plate-matt-black-shower-bar-valve-support",
      "mini-bar-valve-fixing-kit-plate-secure-shower-bar-valve-installation",
      "pair-of-zink-plated-fixing-bolts-kits-wall-hung-toilet-fittings-long",
      "quarter-circle-corner-countertop-or-hung-basin-waste-fixing-kit-not-included",
      "quarter-circle-corner-countertop-or-hung-basin-waste-fixing-kit-not-included-1",
      "short-fixing-bolts-fittings-kits-for-wall-hung-toilet",
      "triangle-corner-countertop-or-wall-hung-basin-waste-fixing-kit-not-included",
      "wall-mounted-basin-sink-screw-fixing-kit-wall-hung-basin-fittings"
    ]
  },
  {
    "handle": "bathroom-mirrors",
    "title": "Bathroom Mirrors",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 35,
    "description": "Shop bathroom mirrors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "chelsea-corner-mirror-cabinet-white-320w-x-650h-x-320d",
      "devon-1200-mirror-cabinet-1200mm-wide-bathroom-storage-with-mirror-doors",
      "devon-400-mirror-cabinet-400w-x-700h-x-150d",
      "devon-600-mirror-cabinet-600w-x-700h-x-150d",
      "devon-900-mirror-cabinet-900mm-wide-wall-mounted-bathroom-storage-with-mirror-doors",
      "double-layer-bathroom-mirror-modern-wall-mounted-framed-design",
      "hilton-2-door-mirror-cabinet-cream-500w-x-600h-x-205d",
      "led-bathroom-mirror-battery-operated-500w-x-700h-x-40d",
      "led-bathroom-rectangle-mirror-battery-operated-500w-x-700h-x-40d",
      "led-mirror-cabinet-1-door-with-sensor-shaver-socket-modern-bathroom",
      "led-mirror-cabinet-2-door-with-sensor-shaver-socket-bathroom-storage",
      "led-rectangle-bathroom-mirror-500x700mm-brushed-brass-with-led-demister",
      "led-rectangle-bathroom-mirror-500x700mm-matt-black-with-led-lighting",
      "led-rectangle-bathroom-mirror-500x700mm-with-shaver-socket-modern-vanity",
      "led-rectangle-bathroom-mirror-800x600mm-with-shaver-socket-modern-vanity",
      "led-rectangle-mirror-500x700mm-with-bluetooth-digital-clock-shaver-socket",
      "led-round-bathroom-mirror-600mm-matt-black-with-demister-6000k-led-light",
      "led-round-bathroom-mirror-600x600mm-brushed-brass-with-led-demister",
      "led-round-bathroom-mirror-600x600mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-bathroom-mirror-700x700mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-corner-bathroom-mirror-500x700mm-with-demister-6000k-lighting",
      "led-round-corner-bathroom-mirror-500x700mm-with-modern-wall-mount-design",
      "led-round-corner-bathroom-mirror-with-built-in-light-modern-vanity-mirror",
      "led-round-corner-mirror-500x700mm-with-shaver-socket-modern-bathroom-mirror",
      "led-round-corner-mirror-800x600mm-with-demister-shaver-socket-included",
      "led-round-corner-mirror-with-battery-powered-button-switch-500w-x-700h-x-40d",
      "led-square-bathroom-corner-mirror-battery-operated-390w-x-500h-x-40d",
      "led-square-corner-bathroom-mirror-with-lights-500-x-700mm-wall-mount",
      "round-corner-bathroom-mirror-modern-frameless-wall-mounted-design",
      "round-corner-bathroom-mirror-with-glass-shelf-modern-wall-mounted",
      "round-double-layer-bathroom-mirror-modern-frameless-decorative-design",
      "round-frameless-bathroom-mirror-modern-wall-mounted-circle-design",
      "sharaton-mirror-cabinet-stone-grey-500w-x-600h-x-205d",
      "straight-corner-bathroom-mirror-modern-wall-mounted-design",
      "straight-corner-bathroom-mirror-with-glass-shelf-modern-wall-mounted"
    ]
  },
  {
    "handle": "led-mirrors",
    "title": "LED Mirrors",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 21,
    "description": "Shop led mirrors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "led-bathroom-mirror-battery-operated-500w-x-700h-x-40d",
      "led-bathroom-rectangle-mirror-battery-operated-500w-x-700h-x-40d",
      "led-mirror-cabinet-1-door-with-sensor-shaver-socket-modern-bathroom",
      "led-mirror-cabinet-2-door-with-sensor-shaver-socket-bathroom-storage",
      "led-rectangle-bathroom-mirror-500x700mm-brushed-brass-with-led-demister",
      "led-rectangle-bathroom-mirror-500x700mm-matt-black-with-led-lighting",
      "led-rectangle-bathroom-mirror-500x700mm-with-shaver-socket-modern-vanity",
      "led-rectangle-bathroom-mirror-800x600mm-with-shaver-socket-modern-vanity",
      "led-rectangle-mirror-500x700mm-with-bluetooth-digital-clock-shaver-socket",
      "led-round-bathroom-mirror-600mm-matt-black-with-demister-6000k-led-light",
      "led-round-bathroom-mirror-600x600mm-brushed-brass-with-led-demister",
      "led-round-bathroom-mirror-600x600mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-bathroom-mirror-700x700mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-corner-bathroom-mirror-500x700mm-with-demister-6000k-lighting",
      "led-round-corner-bathroom-mirror-500x700mm-with-modern-wall-mount-design",
      "led-round-corner-bathroom-mirror-with-built-in-light-modern-vanity-mirror",
      "led-round-corner-mirror-500x700mm-with-shaver-socket-modern-bathroom-mirror",
      "led-round-corner-mirror-800x600mm-with-demister-shaver-socket-included",
      "led-round-corner-mirror-with-battery-powered-button-switch-500w-x-700h-x-40d",
      "led-square-bathroom-corner-mirror-battery-operated-390w-x-500h-x-40d",
      "led-square-corner-bathroom-mirror-with-lights-500-x-700mm-wall-mount"
    ]
  },
  {
    "handle": "round-mirrors",
    "title": "Round Mirrors",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 14,
    "description": "Shop round mirrors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "led-round-bathroom-mirror-600mm-matt-black-with-demister-6000k-led-light",
      "led-round-bathroom-mirror-600x600mm-brushed-brass-with-led-demister",
      "led-round-bathroom-mirror-600x600mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-bathroom-mirror-700x700mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-corner-bathroom-mirror-500x700mm-with-demister-6000k-lighting",
      "led-round-corner-bathroom-mirror-500x700mm-with-modern-wall-mount-design",
      "led-round-corner-bathroom-mirror-with-built-in-light-modern-vanity-mirror",
      "led-round-corner-mirror-500x700mm-with-shaver-socket-modern-bathroom-mirror",
      "led-round-corner-mirror-800x600mm-with-demister-shaver-socket-included",
      "led-round-corner-mirror-with-battery-powered-button-switch-500w-x-700h-x-40d",
      "round-corner-bathroom-mirror-modern-frameless-wall-mounted-design",
      "round-corner-bathroom-mirror-with-glass-shelf-modern-wall-mounted",
      "round-double-layer-bathroom-mirror-modern-frameless-decorative-design",
      "round-frameless-bathroom-mirror-modern-wall-mounted-circle-design"
    ]
  },
  {
    "handle": "rectangular-mirrors",
    "title": "Rectangular Mirrors",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 6,
    "description": "Shop rectangular mirrors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "led-bathroom-rectangle-mirror-battery-operated-500w-x-700h-x-40d",
      "led-rectangle-bathroom-mirror-500x700mm-brushed-brass-with-led-demister",
      "led-rectangle-bathroom-mirror-500x700mm-matt-black-with-led-lighting",
      "led-rectangle-bathroom-mirror-500x700mm-with-shaver-socket-modern-vanity",
      "led-rectangle-bathroom-mirror-800x600mm-with-shaver-socket-modern-vanity",
      "led-rectangle-mirror-500x700mm-with-bluetooth-digital-clock-shaver-socket"
    ]
  },
  {
    "handle": "mirror-cabinets",
    "title": "Mirror Cabinets",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 9,
    "description": "Shop mirror cabinets at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "chelsea-corner-mirror-cabinet-white-320w-x-650h-x-320d",
      "devon-1200-mirror-cabinet-1200mm-wide-bathroom-storage-with-mirror-doors",
      "devon-400-mirror-cabinet-400w-x-700h-x-150d",
      "devon-600-mirror-cabinet-600w-x-700h-x-150d",
      "devon-900-mirror-cabinet-900mm-wide-wall-mounted-bathroom-storage-with-mirror-doors",
      "hilton-2-door-mirror-cabinet-cream-500w-x-600h-x-205d",
      "led-mirror-cabinet-1-door-with-sensor-shaver-socket-modern-bathroom",
      "led-mirror-cabinet-2-door-with-sensor-shaver-socket-bathroom-storage",
      "sharaton-mirror-cabinet-stone-grey-500w-x-600h-x-205d"
    ]
  },
  {
    "handle": "mirrors-with-shaver-socket",
    "title": "Mirrors With Shaver Socket",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 7,
    "description": "Shop mirrors with shaver socket at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "led-mirror-cabinet-1-door-with-sensor-shaver-socket-modern-bathroom",
      "led-mirror-cabinet-2-door-with-sensor-shaver-socket-bathroom-storage",
      "led-rectangle-bathroom-mirror-500x700mm-with-shaver-socket-modern-vanity",
      "led-rectangle-bathroom-mirror-800x600mm-with-shaver-socket-modern-vanity",
      "led-rectangle-mirror-500x700mm-with-bluetooth-digital-clock-shaver-socket",
      "led-round-corner-mirror-500x700mm-with-shaver-socket-modern-bathroom-mirror",
      "led-round-corner-mirror-800x600mm-with-demister-shaver-socket-included"
    ]
  },
  {
    "handle": "mirrors-with-demister",
    "title": "Mirrors With Demister",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 11,
    "description": "Shop mirrors with demister at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "led-rectangle-bathroom-mirror-500x700mm-brushed-brass-with-led-demister",
      "led-rectangle-bathroom-mirror-500x700mm-with-shaver-socket-modern-vanity",
      "led-rectangle-bathroom-mirror-800x600mm-with-shaver-socket-modern-vanity",
      "led-rectangle-mirror-500x700mm-with-bluetooth-digital-clock-shaver-socket",
      "led-round-bathroom-mirror-600mm-matt-black-with-demister-6000k-led-light",
      "led-round-bathroom-mirror-600x600mm-brushed-brass-with-led-demister",
      "led-round-bathroom-mirror-600x600mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-bathroom-mirror-700x700mm-with-soft-glow-light-modern-vanity-mirror",
      "led-round-corner-bathroom-mirror-500x700mm-with-demister-6000k-lighting",
      "led-round-corner-mirror-500x700mm-with-shaver-socket-modern-bathroom-mirror",
      "led-round-corner-mirror-800x600mm-with-demister-shaver-socket-included"
    ]
  },
  {
    "handle": "black-mirrors",
    "title": "Black Mirrors",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 2,
    "description": "Shop black mirrors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "led-rectangle-bathroom-mirror-500x700mm-matt-black-with-led-lighting",
      "led-round-bathroom-mirror-600mm-matt-black-with-demister-6000k-led-light"
    ]
  },
  {
    "handle": "brushed-brass-mirrors",
    "title": "Brushed Brass Mirrors",
    "parentCategory": "Mirrors & Cabinets",
    "productCount": 2,
    "description": "Shop brushed brass mirrors at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "led-rectangle-bathroom-mirror-500x700mm-brushed-brass-with-led-demister",
      "led-round-bathroom-mirror-600x600mm-brushed-brass-with-led-demister"
    ]
  },
  {
    "handle": "pvc-wall-panels",
    "title": "PVC Wall Panels",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 26,
    "description": "Shop pvc wall panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "astra-stone-matt-premium-matte-finish-stone-texture-for-elegant-surfaces",
      "base-seal-chrome-pvc-trim-for-hygienic-wall-panel-bottom-sealing",
      "base-seal-white-pvc-wall-ceiling-panel-finishing-trim",
      "beige-concrete-warm-matte-finish-tile-for-modern-walls-flooring",
      "black-pearlescent-quartz-tile-luxury-sparkle-black-finish",
      "capri-grey-matt-tile-elegant-marble-look-stone-for-walls-floors",
      "capri-light-grey-matt-tile-soft-marble-look-stone-for-walls-floors",
      "chrome-h-joint-trim-silver-pvc-aluminum-connector-for-wall-ceiling-panels",
      "external-corner-chrome-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "external-corner-white-durable-pvc-trim-for-neat-panel-edge-finishing",
      "external-corner-white-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "graphite-blue-matt-stone-tile-modern-textured-finish-for-stylish-spaces",
      "grey-concrete-modern-industrial-matte-finish-for-floors-wall-surfaces",
      "h-joint-white-seamless-pvc-panel-connector-trim-for-walls-ceilings",
      "internal-corner-chrome-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "internal-corner-white-pvc-trim-for-neat-wall-ceiling-panel-joint-finishing",
      "internal-corner-white-pvc-trim-for-neat-wall-ceiling-panel-joints",
      "lindos-light-grey-matt-tile-subtle-stone-look-for-walls-floors",
      "milan-carrara-matt-tile-classic-white-marble-look-for-elegant-spaces",
      "platinum-white-sparkle-quartz-tile-modern-shimmer-finish",
      "silver-metallic-quartz-tile-modern-grey-polished-finish",
      "slate-dark-grey-matt-tile-textured-natural-stone-for-modern-interiors",
      "slate-grey-natural-stone-tile-elegant-matte-finish-for-indoor-outdoor",
      "starter-end-chrome-pvc-wall-ceiling-panel-edge-trim",
      "white-galaxy-quartz-tile-sparkling-white-luxury-finish",
      "white-pearlescent-quartz-tile-elegant-sparkle-white-finish"
    ]
  },
  {
    "handle": "wetroom-pvc-panels",
    "title": "Wetroom PVC Panels",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 1,
    "description": "Shop wetroom pvc panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "platinum-white-sparkle-quartz-tile-modern-shimmer-finish"
    ]
  },
  {
    "handle": "ceiling-pvc-panels",
    "title": "Ceiling PVC Panels",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 8,
    "description": "Shop ceiling pvc panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "base-seal-white-pvc-wall-ceiling-panel-finishing-trim",
      "chrome-h-joint-trim-silver-pvc-aluminum-connector-for-wall-ceiling-panels",
      "external-corner-chrome-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "external-corner-white-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "internal-corner-chrome-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "internal-corner-white-pvc-trim-for-neat-wall-ceiling-panel-joint-finishing",
      "internal-corner-white-pvc-trim-for-neat-wall-ceiling-panel-joints",
      "starter-end-chrome-pvc-wall-ceiling-panel-edge-trim"
    ]
  },
  {
    "handle": "pvc-panel-trims",
    "title": "PVC Panel Trims",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 14,
    "description": "Shop pvc panel trims at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "base-seal-chrome-pvc-trim-for-hygienic-wall-panel-bottom-sealing",
      "base-seal-white-pvc-wall-ceiling-panel-finishing-trim",
      "chrome-h-joint-trim-silver-pvc-aluminum-connector-for-wall-ceiling-panels",
      "external-corner-chrome-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "external-corner-white-durable-pvc-trim-for-neat-panel-edge-finishing",
      "external-corner-white-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "h-joint-chrome-pvc-connector-trim-for-10mm-wall-ceiling-panels",
      "h-joint-white-pvc-trim-connector-for-wall-ceiling-panels",
      "h-joint-white-seamless-pvc-panel-connector-trim-for-walls-ceilings",
      "internal-corner-chrome-pvc-trim-for-neat-wall-ceiling-panel-edge-finish",
      "internal-corner-white-pvc-trim-for-neat-wall-ceiling-panel-joint-finishing",
      "internal-corner-white-pvc-trim-for-neat-wall-ceiling-panel-joints",
      "starter-end-chrome-pvc-wall-ceiling-panel-edge-trim",
      "starter-end-white"
    ]
  },
  {
    "handle": "marble-effect-panels",
    "title": "Marble Effect Panels",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 12,
    "description": "Shop marble effect panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "black-pearlescent-quartz-tile-luxury-sparkle-black-finish",
      "calacatta-grey-marble-white-stone-with-soft-grey-veining",
      "capri-grey-matt-tile-elegant-marble-look-stone-for-walls-floors",
      "capri-light-grey-matt-tile-soft-marble-look-stone-for-walls-floors",
      "carrara-gold-marble-white-marble-with-striking-gold-dark-veins",
      "gold-marble-luxurious-white-marble-with-striking-golden-veins",
      "massa-marble-white-marble-with-soft-grey-blue-veining",
      "milan-carrara-marble-elegant-white-stone-with-subtle-grey-veins",
      "milan-carrara-matt-tile-classic-white-marble-look-for-elegant-spaces",
      "ona-marble-luxury-white-marble-with-bold-grey-brown-veins",
      "pergamon-stone-tile-elegant-creamy-marble-look-for-walls-floors",
      "white-marble-slab-elegant-natural-stone-for-luxury-interiors"
    ]
  },
  {
    "handle": "gloss-panels",
    "title": "Gloss Panels",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 9,
    "description": "Shop gloss panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "beige-stone-tile-elegant-natural-look-for-walls-floors",
      "front-bath-panel-i-gloss-anthracite-15mm-thick-height-adjustable-up-to-550mm",
      "front-bath-panel-i-gloss-matt-grey-15mm-thick-height-adjustable-up-to-550mm",
      "front-bath-panel-i-gloss-white-15mm-thick-height-adjustable-up-to-550mm",
      "gloss-anthracite-end-bath-panel-15mm-durable-adjustable-height-up-to-550mm",
      "gloss-matt-grey-end-bath-panel-15mm-thick-height-adjustable-up-to-550mm",
      "gloss-white-end-bath-panel-15mm-thick-height-adjustable-up-to-550mm",
      "gloss-white-slab-sleek-polished-surface-for-modern-interiors",
      "milan-carrara-marble-elegant-white-stone-with-subtle-grey-veins"
    ]
  },
  {
    "handle": "matt-panels",
    "title": "Matt Panels",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 17,
    "description": "Shop matt panels at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "4-folding-glass-panel-door-bath-shower-screen-matt-black-4mm-thick",
      "astra-stone-matt-premium-matte-finish-stone-texture-for-elegant-surfaces",
      "beige-concrete-warm-matte-finish-tile-for-modern-walls-flooring",
      "capri-grey-matt-tile-elegant-marble-look-stone-for-walls-floors",
      "capri-light-grey-matt-tile-soft-marble-look-stone-for-walls-floors",
      "front-bath-panel-i-gloss-matt-grey-15mm-thick-height-adjustable-up-to-550mm",
      "gloss-matt-grey-end-bath-panel-15mm-thick-height-adjustable-up-to-550mm",
      "graphite-blue-matt-stone-tile-modern-textured-finish-for-stylish-spaces",
      "grey-concrete-modern-industrial-matte-finish-for-floors-wall-surfaces",
      "lindos-light-grey-matt-tile-subtle-stone-look-for-walls-floors",
      "marina-6-bi-fold-door-screen-panel-6mm-clear-glass-matt-black",
      "marina-6-side-panel-6mm-clear-glass-matt-black",
      "marina-8-wet-room-8mm-clear-glass-swivel-return-panel-matt-black-300-x-1900mm",
      "milan-carrara-matt-tile-classic-white-marble-look-for-elegant-spaces",
      "silver-metallic-quartz-tile-modern-grey-polished-finish",
      "slate-dark-grey-matt-tile-textured-natural-stone-for-modern-interiors",
      "slate-grey-natural-stone-tile-elegant-matte-finish-for-indoor-outdoor"
    ]
  },
  {
    "handle": "wall-tiles",
    "title": "Wall Tiles",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 12,
    "description": "Shop wall tiles at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "beige-concrete-warm-matte-finish-tile-for-modern-walls-flooring",
      "black-pearlescent-quartz-tile-luxury-sparkle-black-finish",
      "capri-grey-matt-tile-elegant-marble-look-stone-for-walls-floors",
      "capri-light-grey-matt-tile-soft-marble-look-stone-for-walls-floors",
      "graphite-blue-matt-stone-tile-modern-textured-finish-for-stylish-spaces",
      "lindos-light-grey-matt-tile-subtle-stone-look-for-walls-floors",
      "milan-carrara-matt-tile-classic-white-marble-look-for-elegant-spaces",
      "silver-metallic-quartz-tile-modern-grey-polished-finish",
      "slate-dark-grey-matt-tile-textured-natural-stone-for-modern-interiors",
      "slate-grey-natural-stone-tile-elegant-matte-finish-for-indoor-outdoor",
      "travertine-stone-tile-natural-beige-textured-look-for-walls-floors",
      "white-pearlescent-quartz-tile-elegant-sparkle-white-finish"
    ]
  },
  {
    "handle": "marble-effect-tiles",
    "title": "Marble Effect Tiles",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 12,
    "description": "Shop marble effect tiles at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "anthracite-marble-tile-305x610mm-10-tiles-pack-covers-1-86-polished",
      "black-pearlescent-quartz-tile-luxury-sparkle-black-finish",
      "capri-grey-matt-tile-elegant-marble-look-stone-for-walls-floors",
      "capri-light-grey-matt-tile-soft-marble-look-stone-for-walls-floors",
      "carrara-white-marble-tile-305x610mm-10-tiles-pack-covers-1-86-polished",
      "grey-marble-elegant-marble-look-tile-with-natural-veins-polished-finish",
      "grey-marble-silver-tile-glossy-grey-marble-with-silver-stripes",
      "milan-carrara-matt-tile-classic-white-marble-look-for-elegant-spaces",
      "pergamon-marble-warm-beige-marble-look-tile-with-polished-elegant-finish",
      "pergamon-stone-tile-elegant-creamy-marble-look-for-walls-floors",
      "white-marble-classic-polished-marble-look-tile-for-luxurious-interiors",
      "white-marble-silver-tile-glossy-white-with-elegant-silver-stripes"
    ]
  },
  {
    "handle": "wood-look-tiles",
    "title": "Wood Look Tiles",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 9,
    "description": "Shop wood look tiles at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "american-oak-180x1220mm-wood-look-tile-10-pack-covers-2-2-matte",
      "black-oak-180x1220mm-wood-look-tile-10-pack-covers-2-2-matte-finish",
      "grey-oak-180x1220mm-wood-look-tile-10-pieces-per-pack-matte-finish",
      "medium-oak-180x1220mm-wood-look-tile-10-pieces-per-pack-matte-finish",
      "walnut-180x1220mm-wood-look-tile-10-pack-covers-2-2-matte-finish",
      "white-oak-180x1220mm-wood-look-tile-10-pack-covers-2-2-matte-finish",
      "white-wood-matt-elegant-matte-wood-finish-tile-for-walls-floors",
      "white-wood-matt-elegant-matte-wood-finish-tile-for-walls-floors-1",
      "white-wood-matt-elegant-matte-wood-finish-tile-for-walls-floors-2"
    ]
  },
  {
    "handle": "gloss-tiles",
    "title": "Gloss Tiles",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 8,
    "description": "Shop gloss tiles at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "beige-stone-tile-elegant-natural-look-for-walls-floors",
      "black-galaxy-glossy-black-tile-with-starry-night-sparkle-effect",
      "dark-grey-galaxy-gloss-finish-tile-with-holographic-sparkle-effect",
      "gloss-white-high-gloss-finish-tile-for-sleek-walls-modern-interiors",
      "gloss-white-silver-quartz-tile-elegant-white-with-metallic-stripes",
      "grey-galaxy-glossy-grey-tile-with-multi-color-sparkle-for-stylish-spaces",
      "platinum-white-sparkle-gloss-glossy-tile-with-multi-color-glitter-effect",
      "white-galaxy-sparkling-white-tile-with-gloss-finish-galaxy-effect"
    ]
  },
  {
    "handle": "matt-tiles",
    "title": "Matt Tiles",
    "parentCategory": "Panels, Tiles & Trims",
    "productCount": 22,
    "description": "Shop matt tiles at Bathroomfort. Browse relevant bathroom products with fast UK delivery and competitive prices.",
    "productHandles": [
      "american-oak-180x1220mm-wood-look-tile-10-pack-covers-2-2-matte",
      "beige-concrete-warm-matte-finish-tile-for-modern-walls-flooring",
      "black-oak-180x1220mm-wood-look-tile-10-pack-covers-2-2-matte-finish",
      "capri-grey-matt-tile-elegant-marble-look-stone-for-walls-floors",
      "capri-light-grey-matt-tile-soft-marble-look-stone-for-walls-floors",
      "dark-grey-stone-tile-305x610mm-10-tiles-pack-covers-1-86-matt-finish",
      "graphite-blue-matt-stone-tile-modern-textured-finish-for-stylish-spaces",
      "grey-oak-180x1220mm-wood-look-tile-10-pieces-per-pack-matte-finish",
      "light-grey-stone-tile-305x610mm-10-tiles-pack-covers-1-86-matt-finish",
      "lindos-light-grey-matt-tile-subtle-stone-look-for-walls-floors",
      "medium-oak-180x1220mm-wood-look-tile-10-pieces-per-pack-matte-finish",
      "milan-carrara-matt-tile-classic-white-marble-look-for-elegant-spaces",
      "oiled-slate-tile-305x610mm-10-tiles-pack-covers-1-86-matte-finish",
      "sand-stone-tile-305x610mm-10-tiles-pack-covers-1-86-matt-finish",
      "silver-metallic-quartz-tile-modern-grey-polished-finish",
      "slate-dark-grey-matt-tile-textured-natural-stone-for-modern-interiors",
      "slate-grey-natural-stone-tile-elegant-matte-finish-for-indoor-outdoor",
      "walnut-180x1220mm-wood-look-tile-10-pack-covers-2-2-matte-finish",
      "white-oak-180x1220mm-wood-look-tile-10-pack-covers-2-2-matte-finish",
      "white-wood-matt-elegant-matte-wood-finish-tile-for-walls-floors",
      "white-wood-matt-elegant-matte-wood-finish-tile-for-walls-floors-1",
      "white-wood-matt-elegant-matte-wood-finish-tile-for-walls-floors-2"
    ]
  }
];

const runtimeNavItemsByGroup: Record<string, SeoRuntimeNavItem[]> = {
  "bathrooms": [
    {
      "title": "Basins",
      "href": "/collections/basins",
      "sections": [
        {
          "title": "Basins by Type",
          "items": [
            {
              "title": "Basins",
              "href": "/collections/basins"
            },
            {
              "title": "Countertop Basins",
              "href": "/collections/countertop-basins"
            },
            {
              "title": "Wall Hung Basins",
              "href": "/collections/wall-hung-basins"
            },
            {
              "title": "Cloakroom Basins",
              "href": "/collections/cloakroom-basins"
            }
          ]
        },
        {
          "title": "Basins by Material",
          "items": [
            {
              "title": "Ceramic Basins",
              "href": "/collections/ceramic-basins"
            },
            {
              "title": "Resin Basins",
              "href": "/collections/resin-basins"
            }
          ]
        },
        {
          "title": "Basins by Shape & Colour",
          "items": [
            {
              "title": "Square Basins",
              "href": "/collections/square-basins"
            },
            {
              "title": "Round Basins",
              "href": "/collections/round-basins"
            },
            {
              "title": "Oval Basins",
              "href": "/collections/oval-basins"
            },
            {
              "title": "Matt Black Basins",
              "href": "/collections/matt-black-basins"
            }
          ]
        }
      ]
    },
    {
      "title": "Toilets",
      "href": "/collections/toilets",
      "sections": [
        {
          "title": "Toilets by Type",
          "items": [
            {
              "title": "Toilets",
              "href": "/collections/toilets"
            },
            {
              "title": "Close Coupled Toilets",
              "href": "/collections/close-coupled-toilets"
            },
            {
              "title": "Back To Wall Toilets",
              "href": "/collections/back-to-wall-toilets"
            },
            {
              "title": "Wall Hung Toilets",
              "href": "/collections/wall-hung-toilets"
            }
          ]
        },
        {
          "title": "Toilets by Feature",
          "items": [
            {
              "title": "Rimless Toilets",
              "href": "/collections/rimless-toilets"
            },
            {
              "title": "Comfort Height Toilets",
              "href": "/collections/comfort-height-toilets"
            },
            {
              "title": "Toilet and Basin Units",
              "href": "/collections/toilet-and-basin-units"
            }
          ]
        },
        {
          "title": "Seats, Cisterns & Frames",
          "items": [
            {
              "title": "Toilet Seats",
              "href": "/collections/toilet-seats"
            },
            {
              "title": "Concealed Cisterns",
              "href": "/collections/concealed-cisterns"
            },
            {
              "title": "Flush Plates & Buttons",
              "href": "/collections/flush-plates-and-buttons"
            },
            {
              "title": "Toilet Frames",
              "href": "/collections/toilet-frames"
            }
          ]
        }
      ]
    }
  ],
  "baths": [
    {
      "title": "Baths",
      "href": "/collections/baths",
      "sections": [
        {
          "title": "Baths by Type",
          "items": [
            {
              "title": "Baths",
              "href": "/collections/baths"
            },
            {
              "title": "L Shape Baths",
              "href": "/collections/l-shape-baths"
            },
            {
              "title": "Acrylic Baths",
              "href": "/collections/acrylic-baths"
            },
            {
              "title": "Steel Enamel Baths",
              "href": "/collections/steel-enamel-baths"
            },
            {
              "title": "2 Tap Hole Baths",
              "href": "/collections/two-tap-hole-baths"
            }
          ]
        },
        {
          "title": "Bath Panels",
          "items": [
            {
              "title": "Bath Panels",
              "href": "/collections/bath-panels"
            },
            {
              "title": "Front Bath Panels",
              "href": "/collections/front-bath-panels"
            },
            {
              "title": "End Bath Panels",
              "href": "/collections/end-bath-panels"
            }
          ]
        },
        {
          "title": "Bath Screens & Fittings",
          "items": [
            {
              "title": "Bath Screens",
              "href": "/collections/bath-screens"
            },
            {
              "title": "Bath Legs & Supports",
              "href": "/collections/bath-legs-and-supports"
            },
            {
              "title": "Bath Handles",
              "href": "/collections/bath-handles"
            }
          ]
        }
      ]
    }
  ],
  "showers": [
    {
      "title": "Showers",
      "href": "/collections/showers",
      "sections": [
        {
          "title": "Showers by Type",
          "items": [
            {
              "title": "Showers",
              "href": "/collections/showers"
            },
            {
              "title": "Concealed Showers",
              "href": "/collections/concealed-showers"
            },
            {
              "title": "Exposed Showers",
              "href": "/collections/exposed-showers"
            },
            {
              "title": "Thermostatic Showers",
              "href": "/collections/thermostatic-showers"
            },
            {
              "title": "Shower Kits",
              "href": "/collections/shower-kits"
            },
            {
              "title": "Shower Systems",
              "href": "/collections/shower-systems"
            }
          ]
        },
        {
          "title": "Shower Valves",
          "items": [
            {
              "title": "Shower Valves",
              "href": "/collections/shower-valves"
            },
            {
              "title": "Concealed Shower Valves",
              "href": "/collections/concealed-shower-valves"
            },
            {
              "title": "Bar Valves",
              "href": "/collections/bar-valves"
            }
          ]
        },
        {
          "title": "Shower Handsets & Hoses",
          "items": [
            {
              "title": "Shower Handsets",
              "href": "/collections/shower-handsets"
            },
            {
              "title": "Shower Hoses",
              "href": "/collections/shower-hoses"
            }
          ]
        }
      ]
    },
    {
      "title": "Shower Accessories",
      "href": "/collections/shower-accessories",
      "sections": [
        {
          "title": "Shower Accessories by Type",
          "items": [
            {
              "title": "Shower Arms",
              "href": "/collections/shower-arms"
            },
            {
              "title": "Shower Heads",
              "href": "/collections/shower-heads"
            }
          ]
        },
        {
          "title": "Shower Arms by Mounting",
          "items": [
            {
              "title": "Ceiling Shower Arms",
              "href": "/collections/ceiling-shower-arms"
            },
            {
              "title": "Wall Mounted Shower Arms",
              "href": "/collections/wall-mounted-shower-arms"
            }
          ]
        },
        {
          "title": "Shower Arms by Shape",
          "items": [
            {
              "title": "Square Shower Arms",
              "href": "/collections/square-shower-arms"
            },
            {
              "title": "Round Shower Arms",
              "href": "/collections/round-shower-arms"
            }
          ]
        },
        {
          "title": "Shower Arms by Finish",
          "items": [
            {
              "title": "Brass Shower Arms",
              "href": "/collections/brass-shower-arms"
            },
            {
              "title": "Black Shower Arms",
              "href": "/collections/black-shower-arms"
            }
          ]
        },
        {
          "title": "Shower Heads by Shape",
          "items": [
            {
              "title": "Square Shower Heads",
              "href": "/collections/square-shower-heads"
            },
            {
              "title": "Round Shower Heads",
              "href": "/collections/round-shower-heads"
            }
          ]
        },
        {
          "title": "Shower Heads by Finish",
          "items": [
            {
              "title": "Brass Shower Heads",
              "href": "/collections/brass-shower-heads"
            },
            {
              "title": "Black Shower Heads",
              "href": "/collections/black-shower-heads"
            }
          ]
        }
      ]
    },
    {
      "title": "Shower Enclosures",
      "href": "/collections/shower-enclosures",
      "sections": [
        {
          "title": "Enclosures & Doors",
          "items": [
            {
              "title": "Shower Enclosures",
              "href": "/collections/shower-enclosures"
            },
            {
              "title": "Shower Doors",
              "href": "/collections/shower-doors"
            },
            {
              "title": "Sliding Shower Doors",
              "href": "/collections/sliding-shower-doors"
            },
            {
              "title": "Pivot Shower Doors",
              "href": "/collections/pivot-shower-doors"
            },
            {
              "title": "Quadrant Shower Enclosures",
              "href": "/collections/quadrant-shower-enclosures"
            },
            {
              "title": "Side Panels",
              "href": "/collections/side-panels"
            }
          ]
        },
        {
          "title": "Wetrooms",
          "items": [
            {
              "title": "Wetroom Screens",
              "href": "/collections/wetroom-screens"
            },
            {
              "title": "Wetroom Support Bars",
              "href": "/collections/wetroom-support-bars"
            }
          ]
        },
        {
          "title": "Shower Trays",
          "items": [
            {
              "title": "Shower Trays",
              "href": "/collections/shower-trays"
            },
            {
              "title": "Square Shower Trays",
              "href": "/collections/square-shower-trays"
            },
            {
              "title": "Rectangular Shower Trays",
              "href": "/collections/rectangular-shower-trays"
            },
            {
              "title": "Quadrant Shower Trays",
              "href": "/collections/quadrant-shower-trays"
            },
            {
              "title": "Offset Quadrant Shower Trays",
              "href": "/collections/offset-quadrant-shower-trays"
            },
            {
              "title": "Walk In Shower Trays",
              "href": "/collections/walk-in-shower-trays"
            }
          ]
        },
        {
          "title": "Enclosure Fittings",
          "items": [
            {
              "title": "Shower Tray Legs & Plinths",
              "href": "/collections/shower-tray-legs-and-plinths"
            },
            {
              "title": "Shower Door Handles",
              "href": "/collections/shower-door-handles"
            },
            {
              "title": "Shower Seals",
              "href": "/collections/shower-seals"
            },
            {
              "title": "Extension Profiles",
              "href": "/collections/extension-profiles"
            }
          ]
        }
      ]
    }
  ],
  "taps": [
    {
      "title": "Bathroom Taps",
      "href": "/collections/bathroom-taps",
      "sections": [
        {
          "title": "Taps by Use",
          "items": [
            {
              "title": "Bathroom Taps",
              "href": "/collections/bathroom-taps"
            },
            {
              "title": "Basin Taps",
              "href": "/collections/basin-taps"
            },
            {
              "title": "Bath Taps",
              "href": "/collections/bath-taps"
            },
            {
              "title": "Kitchen Taps",
              "href": "/collections/kitchen-taps"
            },
            {
              "title": "Commercial Taps",
              "href": "/collections/commercial-taps"
            }
          ]
        },
        {
          "title": "Basin Taps",
          "items": [
            {
              "title": "Basin Mixer Taps",
              "href": "/collections/basin-mixer-taps"
            },
            {
              "title": "Tall Basin Mixer Taps",
              "href": "/collections/tall-basin-mixer-taps"
            },
            {
              "title": "Wall Mounted Basin Taps",
              "href": "/collections/wall-mounted-basin-taps"
            }
          ]
        },
        {
          "title": "Bath Taps",
          "items": [
            {
              "title": "Bath Filler Taps",
              "href": "/collections/bath-filler-taps"
            },
            {
              "title": "Bath Shower Mixer Taps",
              "href": "/collections/bath-shower-mixer-taps"
            },
            {
              "title": "Freestanding Bath Taps",
              "href": "/collections/freestanding-bath-taps"
            }
          ]
        },
        {
          "title": "Taps by Style & Finish",
          "items": [
            {
              "title": "Waterfall Taps",
              "href": "/collections/waterfall-taps"
            },
            {
              "title": "Chrome Taps",
              "href": "/collections/chrome-taps"
            },
            {
              "title": "Black Taps",
              "href": "/collections/black-taps"
            },
            {
              "title": "Brushed Brass Taps",
              "href": "/collections/brushed-brass-taps"
            }
          ]
        }
      ]
    },
    {
      "title": "Wastes & Plumbing",
      "href": "/collections/wastes",
      "sections": [
        {
          "title": "Wastes by Use",
          "items": [
            {
              "title": "Wastes",
              "href": "/collections/wastes"
            },
            {
              "title": "Basin Wastes",
              "href": "/collections/basin-wastes"
            },
            {
              "title": "Bath Wastes",
              "href": "/collections/bath-wastes"
            },
            {
              "title": "Shower Wastes",
              "href": "/collections/shower-wastes"
            },
            {
              "title": "Shower Tray Wastes",
              "href": "/collections/shower-tray-wastes"
            }
          ]
        },
        {
          "title": "Plumbing Fittings",
          "items": [
            {
              "title": "Bottle Traps",
              "href": "/collections/bottle-traps"
            },
            {
              "title": "Outlet Elbows",
              "href": "/collections/outlet-elbows"
            },
            {
              "title": "Siphons",
              "href": "/collections/siphons"
            },
            {
              "title": "Fixing Kits",
              "href": "/collections/fixing-kits"
            }
          ]
        }
      ]
    }
  ],
  "furniture": [
    {
      "title": "Bathroom Furniture",
      "href": "/collections/bathroom-furniture",
      "sections": [
        {
          "title": "Furniture by Type",
          "items": [
            {
              "title": "Bathroom Furniture",
              "href": "/collections/bathroom-furniture"
            },
            {
              "title": "Bathroom Vanities",
              "href": "/collections/bathroom-vanities"
            },
            {
              "title": "Vanity Units",
              "href": "/collections/vanity-units"
            },
            {
              "title": "Basin Units",
              "href": "/collections/basin-units"
            },
            {
              "title": "Tallboy Units",
              "href": "/collections/tallboy-units"
            },
            {
              "title": "WC Units",
              "href": "/collections/wc-units"
            }
          ]
        },
        {
          "title": "Vanities by Mounting",
          "items": [
            {
              "title": "Wall Hung Vanity Units",
              "href": "/collections/wall-hung-vanity-units"
            },
            {
              "title": "Floorstanding Vanity Units",
              "href": "/collections/floorstanding-vanity-units"
            }
          ]
        },
        {
          "title": "Furniture by Colour",
          "items": [
            {
              "title": "Anthracite Bathroom Furniture",
              "href": "/collections/anthracite-bathroom-furniture"
            },
            {
              "title": "Matt Grey Bathroom Furniture",
              "href": "/collections/matt-grey-bathroom-furniture"
            },
            {
              "title": "White Bathroom Furniture",
              "href": "/collections/white-bathroom-furniture"
            }
          ]
        }
      ]
    },
    {
      "title": "Bathroom Mirrors",
      "href": "/collections/bathroom-mirrors",
      "sections": [
        {
          "title": "Mirrors by Type",
          "items": [
            {
              "title": "Bathroom Mirrors",
              "href": "/collections/bathroom-mirrors"
            },
            {
              "title": "LED Mirrors",
              "href": "/collections/led-mirrors"
            },
            {
              "title": "Mirror Cabinets",
              "href": "/collections/mirror-cabinets"
            }
          ]
        },
        {
          "title": "Mirrors by Shape",
          "items": [
            {
              "title": "Round Mirrors",
              "href": "/collections/round-mirrors"
            },
            {
              "title": "Rectangular Mirrors",
              "href": "/collections/rectangular-mirrors"
            }
          ]
        },
        {
          "title": "Mirror Features & Finish",
          "items": [
            {
              "title": "Mirrors With Shaver Socket",
              "href": "/collections/mirrors-with-shaver-socket"
            },
            {
              "title": "Mirrors With Demister",
              "href": "/collections/mirrors-with-demister"
            },
            {
              "title": "Black Mirrors",
              "href": "/collections/black-mirrors"
            },
            {
              "title": "Brushed Brass Mirrors",
              "href": "/collections/brushed-brass-mirrors"
            }
          ]
        }
      ]
    }
  ],
  "tiles": [
    {
      "title": "Tiles & Panels",
      "href": "/collections/pvc-wall-panels",
      "sections": [
        {
          "title": "Wall Panels",
          "items": [
            {
              "title": "PVC Wall Panels",
              "href": "/collections/pvc-wall-panels"
            },
            {
              "title": "Wetroom PVC Panels",
              "href": "/collections/wetroom-pvc-panels"
            },
            {
              "title": "Ceiling PVC Panels",
              "href": "/collections/ceiling-pvc-panels"
            }
          ]
        },
        {
          "title": "Panel Finish & Effect",
          "items": [
            {
              "title": "Marble Effect Panels",
              "href": "/collections/marble-effect-panels"
            },
            {
              "title": "Gloss Panels",
              "href": "/collections/gloss-panels"
            },
            {
              "title": "Matt Panels",
              "href": "/collections/matt-panels"
            }
          ]
        },
        {
          "title": "Panel Trims",
          "items": [
            {
              "title": "PVC Panel Trims",
              "href": "/collections/pvc-panel-trims"
            }
          ]
        },
        {
          "title": "Tiles",
          "items": [
            {
              "title": "Wall Tiles",
              "href": "/collections/wall-tiles"
            }
          ]
        },
        {
          "title": "Tile Finish & Effect",
          "items": [
            {
              "title": "Marble Effect Tiles",
              "href": "/collections/marble-effect-tiles"
            },
            {
              "title": "Wood Look Tiles",
              "href": "/collections/wood-look-tiles"
            },
            {
              "title": "Gloss Tiles",
              "href": "/collections/gloss-tiles"
            },
            {
              "title": "Matt Tiles",
              "href": "/collections/matt-tiles"
            }
          ]
        }
      ]
    }
  ]
};

const collectionsByHandle = new Map(collections.map((collection) => [collection.handle, collection]));

export function getSeoRuntimeCollectionDefinition(handle: string) {
  if (!isSeoRuntimeEnabled()) return null;
  return collectionsByHandle.get(handle) ?? null;
}

export function isSeoRuntimeCollectionHandle(handle: string) {
  return isSeoRuntimeEnabled() && collectionsByHandle.has(handle);
}

export function getSeoRuntimeCollectionHandles() {
  if (!isSeoRuntimeEnabled()) return [];
  return collections.map((collection) => collection.handle);
}

export function getSeoRuntimeNavItemsForGroup(groupId: string): SeoRuntimeNavItem[] {
  if (!isSeoRuntimeEnabled()) return [];

  return (runtimeNavItemsByGroup[groupId] ?? []).map((item) => ({
    title: item.title,
    href: item.href,
    sections: item.sections.map((section) => ({
      title: section.title,
      items: section.items.map((link) => ({ ...link })),
    })),
  }));
}

export function getRelatedSeoRuntimeCollectionLinks(
  handle: string,
  limit: number = 14
): SeoRuntimeRelatedCategoryLink[] {
  if (!isSeoRuntimeEnabled()) return [];

  const currentHref = `/collections/${handle}`;
  const related: SeoRuntimeRelatedCategoryLink[] = [];
  const seen = new Set([currentHref]);

  const addLink = (link: SeoRuntimeMenuLink, context: string) => {
    if (seen.has(link.href) || related.length >= limit) return;
    seen.add(link.href);
    related.push({ ...link, context });
  };

  for (const items of Object.values(runtimeNavItemsByGroup)) {
    for (const item of items) {
      const matchingSection = item.sections.find((section) =>
        section.items.some((link) => link.href === currentHref)
      );
      const isItemMatch = item.href === currentHref;

      if (!isItemMatch && !matchingSection) continue;

      if (!isItemMatch) {
        addLink({ title: item.title, href: item.href }, 'Main category');
      }

      if (matchingSection) {
        for (const link of matchingSection.items) {
          addLink(link, matchingSection.title);
        }
      }

      for (const section of item.sections) {
        if (section === matchingSection) continue;
        for (const link of section.items) {
          addLink(link, section.title);
        }
      }

      return related;
    }
  }

  return related;
}
